
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32Eau", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $1UWNP = parcelRequire("1UWNP");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $03RpJ = parcelRequire("03RpJ");


var $5msm2 = parcelRequire("5msm2");


var $2O9Q9 = parcelRequire("2O9Q9");


var $jXCr4 = parcelRequire("jXCr4");


var $imdMF = parcelRequire("imdMF");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $9ekgQ = parcelRequire("9ekgQ");


var $cJff5 = parcelRequire("cJff5");


var $ljBeq = parcelRequire("ljBeq");


var $cn81K = parcelRequire("cn81K");


var $03qcI = parcelRequire("03qcI");


var $biQM6 = parcelRequire("biQM6");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $1Qme9 = parcelRequire("1Qme9");























var $ktiKH = parcelRequire("ktiKH");


var $yW9ML = parcelRequire("yW9ML");

const $af0491d427fc090c$export$a607044ff61ed35a = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    // Unused, clean up when removing rovo-search-remove-rss-bootstrap-fg
    // Here due to type strictness on BootstrapState
    const unusedProps = {
        prevQueryParams: {},
        initialSpaceARIs: []
    };
    // `dynamicContext.thirdPartyConfigs` is only populated when
    // `rovo_fps_use_rovo_config` is ON. When the gate is OFF the dynamic
    // context value is `undefined`, and a naive `{ ...dynamicContext }` spread
    // would overwrite the populated `thirdPartyConfigs` coming from the
    // static context — breaking every consumer that destructures it from
    // `useBootstrap()` (e.g. universal-type filter resolution in the search
    // pipeline). Pick the dynamic value only when it's actually defined.
    // Remove this when rovo_fps_use_rovo_config is cleaned up
    const { thirdPartyConfigs: dynamicThirdPartyConfigs, ...dynamicContextRest } = dynamicContext;
    const mergedThirdPartyConfigs = dynamicThirdPartyConfigs ?? staticContext.thirdPartyConfigs;
    return [
        {
            ...unusedProps,
            ...staticContext,
            ...dynamicContextRest,
            thirdPartyConfigs: mergedThirdPartyConfigs
        }
    ];
};
const $af0491d427fc090c$export$3129106711858d9e = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.applicationMode);
const $af0491d427fc090c$export$8d72fbb40ea96b11 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.linkedCloudARIs);
const $af0491d427fc090c$export$7a947e70298b5de6 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.unitMetadata);
const $af0491d427fc090c$export$42159b7c323c1456 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.initialTextQueryParam);
const $af0491d427fc090c$export$8b362261a7637697 = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.referrer;
};
/**
 * Retrieve third party configs from the static bootstrap store (legacy path).
 *
 * Used by `useThirdPartyConfigsContext` when `rovo_fps_use_rovo_config` is OFF.
 * On the FG-OFF path the value is seeded from `useFetchConfigLegacy` and only
 * mutated by `setThirdPartyConfigs` from the legacy OAuth handler.
 */ const $af0491d427fc090c$var$useThirdPartyConfigsFromStaticContext = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.thirdPartyConfigs);
/**
 * Retrieve third party configs from the dynamic bootstrap context (FG-ON path).
 *
 * Under `rovo_fps_use_rovo_config`, `BootstrapContextProvider` routes
 * `thirdPartyConfigs` into dynamic context so reference changes from
 * `useRovoConfig.onOAuthSuccess` propagate via React's normal context
 * broadcast. Falls back to the static-context default if (somehow) the
 * dynamic value is undefined.
 */ const $af0491d427fc090c$var$useThirdPartyConfigsFromDynamicContext = ()=>{
    const dynamic = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamic?.thirdPartyConfigs ?? $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs;
};
const $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs = {};
const $af0491d427fc090c$export$e2860ebe87e62f0d = ()=>{
    // The dispatch below intentionally calls one of two hooks based on a
    // stable feature-gate value. Per `rovo_fps_use_rovo_config` rollout
    // semantics the gate result does not flip within a session, so the
    // hook call order is stable across renders for a given user — but
    // the react-hooks rule cannot statically prove this, so we disable
    // `rules-of-hooks` for both call sites in the ternary.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $af0491d427fc090c$var$useThirdPartyConfigsFromDynamicContext() : $af0491d427fc090c$var$useThirdPartyConfigsFromStaticContext();
/* eslint-enable react-hooks/rules-of-hooks */ };
const $af0491d427fc090c$export$682b612810461522 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.productEdition);
const $af0491d427fc090c$export$b238e8fc41384c76 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>!!ctx.rovoFeatures?.scas);
const $af0491d427fc090c$export$db066d8e499b7f58 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentConfig);
const $af0491d427fc090c$export$414e9503f60ee463 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.multiSiteSearchInRovo);
const $af0491d427fc090c$export$a20db2e6915ac3c5 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isHello);
const $af0491d427fc090c$export$c3427a530f474eaf = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.searchSessionId;
};
const $af0491d427fc090c$export$5abfe064a9321e1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.nouns);
const $af0491d427fc090c$export$aa1a270414bf62e1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.products);
const $af0491d427fc090c$export$da4da5285a2fd344 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.analyticsAttributes);
const $af0491d427fc090c$export$f1c90440d6c09079 = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsage;
};
const $af0491d427fc090c$export$4c06a80ce19ae7c8 = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return staticContext.isConfigLoaded;
};
const $af0491d427fc090c$export$b79f482a36aed45 = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return (0, $cozmU.useMemo)(()=>{
        return staticContext.products != null && staticContext.products.length > 0;
    }, [
        staticContext.products
    ]);
};
const $af0491d427fc090c$export$c8d3ac176f5c521c = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return staticContext.experimentConfig.frontendExperiments;
};
const $af0491d427fc090c$export$284401669662f77b = (args)=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const { experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, experience: experience, cloudId: cloudId, isJiraIssueIndexed: isJiraIssueIndexed, isHello: isHello } = staticContext;
    return (0, $cozmU.useMemo)(()=>{
        return (0, $5msm2.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: args.entities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }, [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        experience,
        isJiraIssueIndexed,
        args.entities,
        args.thirdPartyFilters,
        isHello
    ]);
};
const $af0491d427fc090c$export$ce2438226fe8a866 = ()=>{
    const { onSearchCompleted: onSearchCompleted } = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return onSearchCompleted;
};
const $af0491d427fc090c$export$de591553328a258f = ()=>{
    const { onOAuthSuccess: onOAuthSuccess } = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return onOAuthSuccess;
};
/**
 * Retrieve BootstrapVariables (with applied callback) from context.
 * Merges static and dynamic context, then applies the callback transformation.
 */ const $af0491d427fc090c$var$_useBootstrapStateContextWithSelector = (cb)=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    const store = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext));
    // Select each field individually so Object.is comparison works on primitives/stable refs.
    // This ensures we only re-render when a field useQueryPlan reads actually changes.
    const cloudId = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.cloudId);
    const primaryProduct = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.primaryProduct);
    const primarySubProduct = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.primarySubProduct);
    // Under `rovo_fps_use_rovo_config`, `thirdPartyConfigs` is routed through
    // dynamic context (see `BootstrapContextProvider`). Pick the appropriate
    // source so that downstream consumers (e.g. useQueryPlan, analytics) see
    // post-OAuth reference changes without depending on the static-lock hack.
    const thirdPartyConfigsFromStatic = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.thirdPartyConfigs);
    const thirdPartyConfigs = (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? dynamicContext?.thirdPartyConfigs ?? $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs : thirdPartyConfigsFromStatic;
    const experimentConfig = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.experimentConfig);
    const experimentLayers = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.experimentLayers);
    const products = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.products);
    const unitMetadata = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>(0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: s.primaryProduct,
            fireExperimentExposure: false
        }) !== 'control' ? s.unitMetadata : undefined);
    const allFilterExcludedProducts = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.allFilterExcludedProducts);
    const productEdition = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.productEdition);
    const productDataRegions = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.productDataRegions);
    const isJiraIssueIndexed = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.isJiraIssueIndexed);
    const isRovoEnabled = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.isRovoEnabled);
    const user = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.user);
    const nouns = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.nouns);
    const overrides = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.overrides);
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const context = (0, $cozmU.useMemo)(()=>{
        return cb({
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            searchSessionId: dynamicContext?.searchSessionId,
            experimentConfig: experimentConfig,
            experimentLayers: experimentLayers,
            products: products,
            unitMetadata: unitMetadata,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isRovoEnabled: isRovoEnabled,
            user: user,
            nouns: nouns,
            referrer: dynamicContext?.referrer,
            ...enableRovoSearchOverrides && {
                overrides: overrides
            }
        });
    }, [
        cloudId,
        primaryProduct,
        primarySubProduct,
        thirdPartyConfigs,
        experimentConfig,
        experimentLayers,
        products,
        unitMetadata,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        isJiraIssueIndexed,
        isRovoEnabled,
        user,
        nouns,
        overrides,
        enableRovoSearchOverrides,
        dynamicContext?.searchSessionId,
        dynamicContext?.referrer,
        cb
    ]);
    return context;
};
const $af0491d427fc090c$export$f58a6d0fc9e4868e = $af0491d427fc090c$var$_useBootstrapStateContextWithSelector;
const $af0491d427fc090c$export$38c566c0640fb69a = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.features);
const $af0491d427fc090c$export$4fcccae6c9e96003 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.cloudId);
const $af0491d427fc090c$export$76d8dfaa701293d9 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.orgId);
const $af0491d427fc090c$export$742cda9929e8b50c = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.primaryProduct);
const $af0491d427fc090c$export$e0c045bdef566c47 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.primarySubProduct);
const $af0491d427fc090c$export$8bff48fd870f30 = ()=>{
    return []; // no longer used, remove when cleaning up fg rovo-search-remove-rss-bootstrap-fg
};
const $af0491d427fc090c$export$87c54b525b914dab = ()=>(0, $cn81K.getUser)((0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.user));
const $af0491d427fc090c$export$c7a275b1a627c5f0 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.SAINHostName);
const $af0491d427fc090c$export$6f099dbd230ba66f = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.hasEditOrViewPlanPermission ?? false);
const $af0491d427fc090c$export$9df89e94884205e9 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isRovoEnabled ?? false);
const $af0491d427fc090c$export$803daaa2f0fbbc6e = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentLayers ?? []);
const $af0491d427fc090c$export$eac498b27b856e7c = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.user?.id);
const $af0491d427fc090c$export$b69f9d68446c9dad = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    const { products: products, primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = staticContext;
    const { product: currentSelectedProduct, cql: currentCql } = dynamicContext.queryParams;
    const applicationMode = (0, $ljBeq.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const primaryProductToSelect = (0, $9ekgQ.productKeySchema).safeParse(primaryProduct);
    const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $2O9Q9.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $dvVWp.ProductKeys).Atlas;
    if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
    else return null;
};
const $af0491d427fc090c$export$e3421d27ae244aa = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.queryParams?.type === (0, $7ydfN.TypeFilterValueKey).Incident;
};
const $af0491d427fc090c$export$25662b49e6b8f72d = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.queryParams;
};
const $af0491d427fc090c$export$7061561fd19f7ef1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.aggregatorHostName);
const $af0491d427fc090c$export$5ff79b6adc9830a0 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.aggAbsoluteUrl);
const $af0491d427fc090c$export$bc37b6cf798ce4a = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.allFilterExcludedProducts);
const $af0491d427fc090c$export$b3275ad39f44e473 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.productDataRegions);
const $af0491d427fc090c$export$7b21d1d3f4e52ac8 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isJiraIssueIndexed);














const $6a9abda6e217f991$export$ae43642c556804c9 = (queryParams)=>{
    const hostProductSetQueryParamsCallback = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.queryParamsCallback);
    const setQueryParamsCallback = (0, $cozmU.useCallback)((newParams)=>{
        const areEqualQueryParams = (0, $biQM6.areAllEqualQueryParams)(newParams, queryParams ?? {});
        if (areEqualQueryParams) return;
        const rawQueryParams = (0, $biQM6.toQueryParamsRaw)(newParams);
        hostProductSetQueryParamsCallback(rawQueryParams);
    }, [
        queryParams,
        hostProductSetQueryParamsCallback
    ]);
    return setQueryParamsCallback;
};
const $6a9abda6e217f991$export$8eb026c9237da68b = ()=>{
    const refreshSearchSessionId = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.refreshSearchSessionId);
    return refreshSearchSessionId;
};
const $6a9abda6e217f991$export$6372fdd1070e00df = ()=>{
    const clearReferrer = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.clearReferrer);
    return clearReferrer;
};
const $6a9abda6e217f991$export$b2cdbc1165101e18 = ()=>{
    const setThirdPartyConfigs = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.setThirdPartyConfigs);
    return setThirdPartyConfigs;
};



var $4BJ6s = parcelRequire("4BJ6s");

const $b56164202d52b555$export$e324594224ef24da = {
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setThirdPartyConfigs = useSetThirdPartyConfigs()`
   */ setThirdPartyConfigs: (configs)=>({ setState: setState })=>{
            setState({
                thirdPartyConfigs: configs
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setQueryParams = useSetQueryParams()`
   */ setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $biQM6.areAllEqualQueryParams)(queryParam, (0, $biQM6.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $biQM6.toQueryParamsRaw)(queryParam));
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   *
   * You should not ever need to call this directly. Open a thread in #help-search-plex and tag @rwasher, @sogrady, @jquach, if you find you need to!
   */ syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, // Previously saved query params - this is to prevent infinitely updating queryParams
            queryParams: diffQueryParamsState // The 'internal' query params state
             } = getState();
            const queryParamsURL = (0, $biQM6.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $biQM6.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $biQM6.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $biQM6.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $biQM6.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $biQM6.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const refreshSearchSessionId = useRefreshSearchSessionId()`
   */ refreshSearchSessionId: ()=>({ setState: setState })=>{
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            setState({
                searchSessionId: (0, $03RpJ.default)()
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const clearReferrer = useClearReferrer()`
   */ clearReferrer: ()=>({ setState: setState })=>{
            setState({
                referrer: undefined
            });
        }
};
const $b56164202d52b555$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
// Keep store private and use hooks to access state and actions
const $b56164202d52b555$var$Store = (0, $8s9DV.createStore)({
    initialState: $jXCr4.initialState,
    actions: $b56164202d52b555$export$e324594224ef24da,
    name: 'bootstrap'
});
const $b56164202d52b555$export$543309f9b943a423 = {
    onInit: ()=>({ getState: getState, setState: setState }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $biQM6.parseQueryParams)(queryParams);
            setState({
                ...getState(),
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                initialTextQueryParam: parsedQueryParams?.text,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                searchSessionId: initialProps.searchSessionId || (0, $03RpJ.default)(),
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $biQM6.parseQueryParams)(queryParams);
            const currentState = getState();
            const products = $b56164202d52b555$var$buildProducts(currentState.products, initialProps?.products ?? []);
            // Merge thirdPartyConfigs so that OAuth-updated entries (set via
            // setThirdPartyConfigs with userNeedsOAuth: false) are not
            // overwritten by the stale consumer-provided value on re-renders,
            // while still picking up new/updated entries from the host app.
            //
            // IMPORTANT: We only create a new object when an actual override is
            // needed. If nothing changed, we preserve the incoming reference to
            // avoid unnecessary re-renders in RSS store subscribers (e.g.
            // useFetchResultsProps depends on thirdPartyConfigs by reference).
            const incomingThirdPartyConfigs = initialProps?.thirdPartyConfigs;
            const currentThirdPartyConfigs = currentState.thirdPartyConfigs;
            let mergedThirdPartyConfigs = incomingThirdPartyConfigs;
            if (incomingThirdPartyConfigs && currentThirdPartyConfigs) {
                // Check whether any entries need to be preserved from the current store
                let hasOverrides = false;
                for (const key of Object.keys(currentThirdPartyConfigs)){
                    const currentEntry = currentThirdPartyConfigs[key];
                    const incomingEntry = incomingThirdPartyConfigs[key];
                    if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) {
                        hasOverrides = true;
                        break;
                    }
                }
                // Only create a new object if we actually need to override something
                if (hasOverrides) {
                    mergedThirdPartyConfigs = {
                        ...incomingThirdPartyConfigs
                    };
                    for (const key of Object.keys(currentThirdPartyConfigs)){
                        const currentEntry = currentThirdPartyConfigs[key];
                        const incomingEntry = mergedThirdPartyConfigs[key];
                        if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) mergedThirdPartyConfigs[key] = currentEntry;
                    }
                }
            }
            setState({
                ...currentState,
                ...initialProps,
                ...mergedThirdPartyConfigs !== undefined && {
                    thirdPartyConfigs: mergedThirdPartyConfigs
                },
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess,
                products: products,
                referrer: parsedQueryParams?.referrer
            });
            dispatch($b56164202d52b555$export$e324594224ef24da.syncQueryParams());
        }
};
const $b56164202d52b555$export$557bf45c8d0f5bd = (0, $j8on0.createContainer)($b56164202d52b555$var$Store, $b56164202d52b555$export$543309f9b943a423);
const $b56164202d52b555$export$cf715ed8590c209b = (0, $kBr4q.createActionsHook)($b56164202d52b555$var$Store);
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * This is being actively migrated away from in QS-9194
 *
 * Instead use specific per-value accessors from this file, including for actions if they are present
 *
 * e.g. const [{ useCloudId, useQueryParams }, { useSetQueryParams }] = useBootstrap()
 * -> const [cloudId] = useCloudId();
 * -> const [queryParams] = useQueryParams();
 * -> const setQueryParams = useSetQueryParams();
 */ const $b56164202d52b555$var$useBootstrapStore = (0, $kBr4q.createHook)($b56164202d52b555$var$Store);
const $b56164202d52b555$export$9ba1f1f28043c5bf = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $af0491d427fc090c$export$a607044ff61ed35a)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useBootstrapStore()[0]
    ];
};
const $b56164202d52b555$export$9ec3accb60f929bc = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $b56164202d52b555$export$610b442bd2bdbce2 = (cb)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$f58a6d0fc9e4868e)(cb) : $b56164202d52b555$export$9ec3accb60f929bc(cb);
};
const $b56164202d52b555$export$9d56bc2341757114 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $b56164202d52b555$export$1fd8522aeddaccda = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$da4da5285a2fd344)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9d56bc2341757114()[0]
    ];
};
const $b56164202d52b555$export$7ea98f64fcaf4bba = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products
});
const $b56164202d52b555$export$5afbfe6edea8e998 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$aa1a270414bf62e1)() : $b56164202d52b555$export$7ea98f64fcaf4bba();
};
const $b56164202d52b555$export$eac7f1ebb1342f3d = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.nouns
});
const $b56164202d52b555$export$6019aa9111ebc3a2 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$5abfe064a9321e1)() : $b56164202d52b555$export$eac7f1ebb1342f3d();
};
const $b56164202d52b555$export$5668414148ce6645 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products && state.products.length > 0
});
const $b56164202d52b555$export$9e9836415b9aa240 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$b79f482a36aed45)() : $b56164202d52b555$export$5668414148ce6645();
};
const $b56164202d52b555$export$38f7f3dced53e226 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $b56164202d52b555$export$f7c6299b3492081c = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        !(0, $af0491d427fc090c$export$b79f482a36aed45)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$38f7f3dced53e226()[0]
    ];
};
const $b56164202d52b555$export$740fb20e7075dfd2 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $b56164202d52b555$export$92c6f3c7c09f3247 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$742cda9929e8b50c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$740fb20e7075dfd2()[0]
    ];
};
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * Instead use usePrimarySubProduct in bootstrap/index.tsx
 */ const $b56164202d52b555$var$usePrimarySubProductStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.primarySubProduct
});
const $b56164202d52b555$export$baffb23dea1bbe6d = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$e0c045bdef566c47)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$usePrimarySubProductStore()
    ];
};
const $b56164202d52b555$export$85911a18814719bc = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $b56164202d52b555$export$e1e7a4797df1a656 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c3427a530f474eaf)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$85911a18814719bc()[0]
    ];
};
const $b56164202d52b555$export$ecbe89dec8c82f9a = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>(0, $03qcI.isHello)(state.cloudId)
});
const $b56164202d52b555$export$1a0be923fb1117e4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$a20db2e6915ac3c5)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$ecbe89dec8c82f9a()[0]
    ];
};
const $b56164202d52b555$export$ecc663167952d044 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.features
});
const $b56164202d52b555$export$4a39035bacc4ed76 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$38c566c0640fb69a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$ecc663167952d044()[0]
    ];
};
const $b56164202d52b555$export$766d82ac8f8b178e = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state, args)=>{
        return (0, $5msm2.getBackendExperiment)({
            experimentConfig: state.experimentConfig,
            entities: args.entities,
            productEdition: state.productEdition,
            isHello: (0, $03qcI.isHello)(state.cloudId),
            productDataRegions: state.productDataRegions,
            experience: (0, $imdMF.SEARCH_PAGE),
            tenantId: state.cloudId,
            isJiraIssueIndexed: state.isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }
});
const $b56164202d52b555$export$9e89c81d9ff2c758 = (args)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$284401669662f77b)(args)
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$766d82ac8f8b178e(args)[0]
    ];
};
const $b56164202d52b555$export$76b3461be06c4ce4 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $b56164202d52b555$export$d2c28b106f1bf70b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c8d3ac176f5c521c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$76b3461be06c4ce4()[0]
    ];
};
const $b56164202d52b555$export$3e826cc2f34e3f9f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.smartLinkUsage
});
const $b56164202d52b555$export$5016cfcf87c60291 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.unitMetadata
});
const $b56164202d52b555$export$61c62393cc326189 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$f1c90440d6c09079)() : $b56164202d52b555$export$3e826cc2f34e3f9f();
};
const $b56164202d52b555$export$89824387636c5038 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>(0, $cJff5.getMultiSiteSearchInRovo)(state.experimentConfig)
});
const $b56164202d52b555$export$1e668811222ead9b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$414e9503f60ee463)() : $b56164202d52b555$export$89824387636c5038();
};
const $b56164202d52b555$export$5ecdff6d23ea5c41 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.user?.id
});
const $b56164202d52b555$export$761b9f1acd811a4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$eac498b27b856e7c)() : $b56164202d52b555$export$5ecdff6d23ea5c41();
};
const $b56164202d52b555$export$7bafc36c74b1b9af = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $b56164202d52b555$export$b9e6179ff71a6122 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$db066d8e499b7f58)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$7bafc36c74b1b9af()[0]
    ];
};
/**
 * @deprecated
 * https://hello.atlassian.net/wiki/x/bKRdZAE
 */ const $b56164202d52b555$var$useApplicationModeStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.isRovoEnabled
    ], (isRovoEnabled)=>(0, $ljBeq.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        }))
});
const $b56164202d52b555$export$150d84149ef86e81 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$3129106711858d9e)() : $b56164202d52b555$var$useApplicationModeStore();
};
const $b56164202d52b555$export$ac142617c8f07aa9 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $af0491d427fc090c$export$8d72fbb40ea96b11)()
    ] : [
        $b56164202d52b555$export$6fa68bea98f6275f()[0]
    ];
};
const $b56164202d52b555$export$37b5bbb85d4e84cc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$7a947e70298b5de6)() : $b56164202d52b555$export$5016cfcf87c60291();
};
const $b56164202d52b555$export$84529f276bb721c4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$42159b7c323c1456)() : $b56164202d52b555$export$5b08efe445210431();
};
const $b56164202d52b555$export$e99d08753f6dce85 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $af0491d427fc090c$export$8b362261a7637697)()
    ] : [
        $b56164202d52b555$export$956b416c80bdc23b()[0]
    ];
};
const $b56164202d52b555$export$cc885caaa8b7ab4e = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>{
        const user = state.user;
        return (0, $cn81K.getUser)(user);
    }
});
const $b56164202d52b555$export$23bbbc4533528f03 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$87c54b525b914dab)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$cc885caaa8b7ab4e()[0]
    ];
};
const $b56164202d52b555$export$956b416c80bdc23b = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.referrer
});
const $b56164202d52b555$export$5b08efe445210431 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.initialTextQueryParam
});
const $b56164202d52b555$export$aef5773142a94889 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.orgId
});
const $b56164202d52b555$export$52a03a3207af3687 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$76d8dfaa701293d9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$aef5773142a94889()[0]
    ];
};
const $b56164202d52b555$export$d875bd9731f2aec2 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $b56164202d52b555$export$9da0f7c65f28ed16 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$4fcccae6c9e96003)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$d875bd9731f2aec2()[0]
    ];
};
const $b56164202d52b555$export$6fa68bea98f6275f = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.linkedCloudARIs
});
const $b56164202d52b555$export$4e035a5c2351d2e5 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.products,
        (state)=>state.primaryProduct,
        (state)=>state.isRovoEnabled,
        (state)=>state.queryParams.product,
        (state)=>state.queryParams.cql
    ], (products, primaryProduct, isRovoEnabled, currentSelectedProduct, currentCql)=>{
        const applicationMode = (0, $ljBeq.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        });
        const primaryProductToSelect = (0, $9ekgQ.productKeySchema).safeParse(primaryProduct);
        const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $2O9Q9.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $dvVWp.ProductKeys).Atlas;
        if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
        else return null;
    })
});
const $b56164202d52b555$export$c7f4a8f2f4902c5b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$b69f9d68446c9dad)() : $b56164202d52b555$export$4e035a5c2351d2e5();
};
const $b56164202d52b555$export$cfec170a04b8b09e = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.isConfigLoaded
    ], (isConfigLoaded)=>isConfigLoaded)
});
const $b56164202d52b555$export$dfc6af34d0b0a7e1 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$4c06a80ce19ae7c8)() : $b56164202d52b555$export$cfec170a04b8b09e();
};
const $b56164202d52b555$export$826527619b7a782d = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>!!state.rovoFeatures?.scas
});
const $b56164202d52b555$export$27738d748ac05943 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$b238e8fc41384c76)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$826527619b7a782d()[0]
    ];
};
const $b56164202d52b555$export$479cadf76e337ced = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.productEdition
});
const $b56164202d52b555$export$83e4de12d3240f53 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$682b612810461522)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$479cadf76e337ced()[0]
    ];
};
const $b56164202d52b555$export$7c7bef429afbfd0f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.queryParams?.type === (0, $7ydfN.TypeFilterValueKey).Incident
});
const $b56164202d52b555$export$98a75a8d27d2d106 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$e3421d27ae244aa)() : $b56164202d52b555$export$7c7bef429afbfd0f();
};
const $b56164202d52b555$export$d37ccf8bdc15c61 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.thirdPartyConfigs
});
const $b56164202d52b555$export$a66178d9c618d6dc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$e2860ebe87e62f0d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$d37ccf8bdc15c61()[0]
    ];
};
const $b56164202d52b555$export$fa705064035366ce = (queryParams)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { setQueryParams: setQueryParamsStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const setQueryParamsContext = (0, $6a9abda6e217f991$export$ae43642c556804c9)(queryParams);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsStore;
};
const $b56164202d52b555$export$3b183e08127f60ee = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { refreshSearchSessionId: refreshSearchSessionIdStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const refreshSearchSessionIdContext = (0, $6a9abda6e217f991$export$8eb026c9237da68b)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdStore;
};
const $b56164202d52b555$export$c6dd687c49bf782b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { clearReferrer: clearReferrerStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const clearReferrerContext = (0, $6a9abda6e217f991$export$6372fdd1070e00df)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerStore;
};
const $b56164202d52b555$export$556790c5329d7a06 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { setThirdPartyConfigs: setThirdPartyConfigsStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const setThirdPartyConfigsContext = (0, $6a9abda6e217f991$export$b2cdbc1165101e18)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsStore;
};
const $b56164202d52b555$export$9145e6ed5e8754d7 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.onSearchCompleted
});
const $b56164202d52b555$export$b9665757e0cd2a7 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const onSearchCompletedStore = $b56164202d52b555$export$9145e6ed5e8754d7();
    const onSearchCompletedContext = (0, $af0491d427fc090c$export$ce2438226fe8a866)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedStore ?? (()=>{});
};
const $b56164202d52b555$export$8dbc380ce96047bb = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.onOAuthSuccess
});
const $b56164202d52b555$export$d5e98fc55a6be8ab = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const onOAuthSuccessStore = $b56164202d52b555$export$8dbc380ce96047bb();
    const onOAuthSuccessContext = (0, $af0491d427fc090c$export$de591553328a258f)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessStore;
};
const $b56164202d52b555$export$94c4fbf6686bd545 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.queryParams
});
const $b56164202d52b555$export$b37ee0d76c6d2fbc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$25662b49e6b8f72d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$94c4fbf6686bd545()
    ];
};
const $b56164202d52b555$export$6a2137557a0d64b6 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.aggregatorHostName
});
const $b56164202d52b555$export$ee782f3c04c9ae8b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$7061561fd19f7ef1)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$6a2137557a0d64b6()
    ];
};
const $b56164202d52b555$export$c9561269f12847d9 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.aggAbsoluteUrl
});
const $b56164202d52b555$export$c61c0a9ee44eb20d = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$5ff79b6adc9830a0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$c9561269f12847d9()
    ];
};
const $b56164202d52b555$export$a622d298cd701527 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $b56164202d52b555$export$5f38673942a99ffe = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$bc37b6cf798ce4a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$a622d298cd701527()
    ];
};
const $b56164202d52b555$export$46b088d1cfd71b45 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.productDataRegions
});
const $b56164202d52b555$export$7b2a84178d2593d6 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$b3275ad39f44e473)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$46b088d1cfd71b45()
    ];
};
const $b56164202d52b555$export$34ca8c3e8a50a02f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.isJiraIssueIndexed
});
const $b56164202d52b555$export$fbf3e851fc33b7ac = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$7b21d1d3f4e52ac8)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$34ca8c3e8a50a02f()
    ];
};
const $b56164202d52b555$export$81f625b5a645837d = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.initialSpaceARIs
});
const $b56164202d52b555$export$dbfb675a6b71c171 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$8bff48fd870f30)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$81f625b5a645837d()
    ];
};
const $b56164202d52b555$export$9f206c50663dec0 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.SAINHostName
});
const $b56164202d52b555$export$3a6ef70862d81412 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c7a275b1a627c5f0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9f206c50663dec0()
    ];
};
const $b56164202d52b555$export$9f9ac629bd95fe42 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.hasEditOrViewPlanPermission
});
const $b56164202d52b555$export$ef5d8e24d9af554f = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$6f099dbd230ba66f)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9f9ac629bd95fe42() ?? false
    ];
};
const $b56164202d52b555$var$useIsRovoEnabledStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.isRovoEnabled
});
const $b56164202d52b555$export$1deffd91058f2ec4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$9df89e94884205e9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useIsRovoEnabledStore()
    ];
};
const $b56164202d52b555$var$useExperimentLayersStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentLayers
});
const $b56164202d52b555$export$e157d3c129f2f296 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$803daaa2f0fbbc6e)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useExperimentLayersStore()
    ];
};
module.exports["BootstrapStoreContainer"] = $b56164202d52b555$export$557bf45c8d0f5bd;
module.exports["useBootstrap"] = $b56164202d52b555$export$9ba1f1f28043c5bf;
module.exports["useBootstrapState"] = $b56164202d52b555$export$610b442bd2bdbce2;
module.exports["useAnalyticsAttributes"] = $b56164202d52b555$export$1fd8522aeddaccda;
module.exports["useAvailableProducts"] = $b56164202d52b555$export$5afbfe6edea8e998;
module.exports["useAvailableNouns"] = $b56164202d52b555$export$6019aa9111ebc3a2;
module.exports["useBootstrapLoading"] = $b56164202d52b555$export$f7c6299b3492081c;
module.exports["usePrimaryProduct"] = $b56164202d52b555$export$92c6f3c7c09f3247;
module.exports["usePrimarySubProduct"] = $b56164202d52b555$export$baffb23dea1bbe6d;
module.exports["useSearchSessionId"] = $b56164202d52b555$export$e1e7a4797df1a656;
module.exports["useIsHello"] = $b56164202d52b555$export$1a0be923fb1117e4;
module.exports["useFeatures"] = $b56164202d52b555$export$4a39035bacc4ed76;
module.exports["useSmartLinkUsage"] = $b56164202d52b555$export$61c62393cc326189;
module.exports["useCurrentUserId"] = $b56164202d52b555$export$761b9f1acd811a4;
module.exports["useExperimentConfig"] = $b56164202d52b555$export$b9e6179ff71a6122;
module.exports["useApplicationMode"] = $b56164202d52b555$export$150d84149ef86e81;
module.exports["useUnitMetadata"] = $b56164202d52b555$export$37b5bbb85d4e84cc;
module.exports["useReferrer"] = $b56164202d52b555$export$e99d08753f6dce85;
module.exports["useUser"] = $b56164202d52b555$export$23bbbc4533528f03;
module.exports["useOrgId"] = $b56164202d52b555$export$52a03a3207af3687;
module.exports["useCloudId"] = $b56164202d52b555$export$9da0f7c65f28ed16;
module.exports["useAutoSelectPrimaryProduct"] = $b56164202d52b555$export$c7f4a8f2f4902c5b;
module.exports["useIsConfigLoaded"] = $b56164202d52b555$export$dfc6af34d0b0a7e1;
module.exports["useProductEdition"] = $b56164202d52b555$export$83e4de12d3240f53;
module.exports["useIsTypeFilteredToIncident"] = $b56164202d52b555$export$98a75a8d27d2d106;
module.exports["useThirdPartyConfigs"] = $b56164202d52b555$export$a66178d9c618d6dc;
module.exports["useSetQueryParams"] = $b56164202d52b555$export$fa705064035366ce;
module.exports["useRefreshSearchSessionId"] = $b56164202d52b555$export$3b183e08127f60ee;
module.exports["useClearReferrer"] = $b56164202d52b555$export$c6dd687c49bf782b;
module.exports["useSetThirdPartyConfigs"] = $b56164202d52b555$export$556790c5329d7a06;
module.exports["useOnSearchCompleted"] = $b56164202d52b555$export$b9665757e0cd2a7;
module.exports["useOnOAuthSuccess"] = $b56164202d52b555$export$d5e98fc55a6be8ab;
module.exports["useQueryParams"] = $b56164202d52b555$export$b37ee0d76c6d2fbc;
module.exports["useAggAbsoluteUrl"] = $b56164202d52b555$export$c61c0a9ee44eb20d;
module.exports["useAllFilterExcludedProducts"] = $b56164202d52b555$export$5f38673942a99ffe;
module.exports["useProductDataRegions"] = $b56164202d52b555$export$7b2a84178d2593d6;
module.exports["useIsJiraIssueIndexed"] = $b56164202d52b555$export$fbf3e851fc33b7ac;
module.exports["useInitialSpaceARIs"] = $b56164202d52b555$export$dbfb675a6b71c171;
module.exports["useExperimentLayers"] = $b56164202d52b555$export$e157d3c129f2f296;

});

parcelRegister("2O9Q9", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $9fae4aa188a3fc73$export$f1263520d5e0f007 = {
    Unified: 'unified',
    Rovo: 'rovo'
};
module.exports["ApplicationModes"] = $9fae4aa188a3fc73$export$f1263520d5e0f007;

});

parcelRegister("jXCr4", function(module, exports) {
const $2fb9df04a7909139$export$d4c72bab9d6cc13a = {
    products: [],
    nouns: [],
    allFilterExcludedProducts: [],
    thirdPartyConfigs: {},
    searchSessionId: '',
    queryParams: {},
    prevQueryParams: {},
    overrides: undefined,
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined,
        dynamicExperiments: undefined
    },
    experimentLayers: [],
    isRovoEnabled: false,
    isConfigLoaded: false,
    rovoFeatures: {},
    isJiraIssueIndexed: false,
    productEdition: undefined,
    productDataRegions: undefined,
    linkedCloudARIs: undefined,
    unitMetadata: undefined,
    analyticsAttributes: undefined,
    aggAbsoluteUrl: undefined,
    cloudId: undefined,
    aggregatorHostName: undefined,
    SAINHostName: undefined,
    user: undefined,
    primaryProduct: undefined,
    primarySubProduct: undefined,
    orgId: undefined,
    referrer: undefined,
    initialTextQueryParam: undefined,
    features: undefined,
    hasEditOrViewPlanPermission: false,
    onSearchCompleted: undefined,
    onOAuthSuccess: undefined,
    smartLinkUsage: undefined
};
module.exports["initialState"] = $2fb9df04a7909139$export$d4c72bab9d6cc13a;

});

parcelRegister("imdMF", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $cf748a175c344ccf$export$944168d706dc6466 = 'search-page';
module.exports["SEARCH_PAGE"] = $cf748a175c344ccf$export$944168d706dc6466;

});

parcelRegister("7ydfN", function(module, exports) {
const $d0b41f69660db9c4$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    AsyncVideo: 'async-video',
    MeetingRecording: 'meeting-recording',
    Playlist: 'playlist',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $d0b41f69660db9c4$export$e01073b80ff953d5 = Object.values($d0b41f69660db9c4$export$49f6cbb853d30562);
const $d0b41f69660db9c4$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    PullRequest: 'pull-request',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
module.exports["TypeFilterValueKey"] = $d0b41f69660db9c4$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $d0b41f69660db9c4$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $d0b41f69660db9c4$export$1f2db89e0caa00c9;

});

parcelRegister("8fNUp", function(module, exports) {
// The canonical `ThirdPartyConfig` interface lives in
// `@atlassian/rovo-connectors-config`. It is consumed here to build the derived
// `ThirdPartyConfigsWithAPIResponse` type below.

var $iDrrr = parcelRequire("iDrrr");


var $aoy1P = parcelRequire("aoy1P");


var $1hmDb = parcelRequire("1hmDb");

const $a0602398df0f360b$export$e88fb694deeca21a = 'smartlinks-connector';
const $a0602398df0f360b$export$83921c8e433ffcd9 = 'lite-connector-';
const $a0602398df0f360b$export$7ad7a95070d8bb93 = (0, $1hmDb.ConnectorSources).Federated;
const $a0602398df0f360b$export$e3a0662f044cd99b = (0, $1hmDb.ConnectorSources).Lite;
const $a0602398df0f360b$export$c14e5e3fa6d8b46 = (0, $1hmDb.ConnectorSources).Smartlinks;
const $a0602398df0f360b$export$aa06c0b5cc41ad9a = (0, $1hmDb.ConnectorSources).Full;
const $a0602398df0f360b$export$d18b7c9bcda587c4 = 'ADMIN_IMPORTED_USER_LINK';
const $a0602398df0f360b$export$37e0ed5b7fa94503 = (0, $1hmDb.ConnectorSources).Backfill;
const $a0602398df0f360b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $1hmDb.ConnectorSources)).includes(value);
};
const $a0602398df0f360b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $a0602398df0f360b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($a0602398df0f360b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $a0602398df0f360b$var$forgeConnectorIconsRegistry = new Map();
const $a0602398df0f360b$export$4e96e986802512bd = (productKey, icon)=>{
    $a0602398df0f360b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $a0602398df0f360b$export$2f2bd8960b497856 = (productKey)=>{
    if ((0, $iDrrr.fg)('rovo_fps_forge_connector_filter_icons')) // Combined Config registers icons in rovo-connectors-config; legacy config uses this registry.
    return (0, $aoy1P.getForgeConnectorIcon)(productKey) ?? $a0602398df0f360b$var$forgeConnectorIconsRegistry.get(productKey);
    return $a0602398df0f360b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $a0602398df0f360b$export$2768da79a2599ca3 = ()=>{
    $a0602398df0f360b$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $a0602398df0f360b$export$e88fb694deeca21a;
module.exports["LITE_CONNECTOR_SOURCE_PREFIX"] = $a0602398df0f360b$export$83921c8e433ffcd9;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$aa06c0b5cc41ad9a;
module.exports["AUTH_RESOLUTION_MODE_ADMIN_IMPORTED"] = $a0602398df0f360b$export$d18b7c9bcda587c4;
module.exports["isConnectorSource"] = $a0602398df0f360b$export$af092ad5a950adea;
module.exports["FORGE_CONNECTOR_PREFIX"] = $a0602398df0f360b$export$9a0cf6dd1d986cc2;
module.exports["isForgeConnectorProductKey"] = $a0602398df0f360b$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $a0602398df0f360b$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $a0602398df0f360b$export$2f2bd8960b497856;

});

parcelRegister("1hmDb", function(module, exports) {
const $7f7ae3614280bba9$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $7f7ae3614280bba9$export$499e9a6668a55181;

});

parcelRegister("cJff5", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $cXtTj = parcelRequire("cXtTj");


var $cha5E = parcelRequire("cha5E");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $fR63l = parcelRequire("fR63l");


var $3XLuW = parcelRequire("3XLuW");


var $7zn5c = parcelRequire("7zn5c");


var $3Ydx7 = parcelRequire("3Ydx7");


var $8fNUp = parcelRequire("8fNUp");

/**
 * Statsig experiment gating impersonated (3LO-free) Microsoft Teams serving in search.
 *
 * Not surface-scoped: the impersonation check it feeds (`isImpersonationEnabled`) lives in the
 * shared `getThirdPartyFilters`, which builds queries for both Full Page Search and Quick Find.
 * Teams currently only surfaces in Full Page Search because Quick Find omits it from its connector
 * list and never requests the `graph:conversation` / `graph:message` entities.
 */ const $84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT = 'enable_teams_impersonation_search';
/** Statsig experiment gating impersonated (3LO-free) SharePoint serving in Full Page Search. */ const $84806324b2485b8b$var$SHAREPOINT_IMPERSONATION_SEARCH_EXPERIMENT = 'enable_sharepoint_impersonation_search';
const $84806324b2485b8b$export$59c9152b54b9272 = ()=>{
    (0, $cha5E.expVal)($84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control');
};
const $84806324b2485b8b$export$f88a0d041695e20e = ()=>{
    return (0, $2pQiO.UNSAFE_expValNoExposure)($84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$f4db28ff05de5f7 = ()=>{
    (0, $cha5E.expVal)($84806324b2485b8b$var$SHAREPOINT_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control');
};
const $84806324b2485b8b$export$aab1030ed135feab = ()=>{
    return (0, $2pQiO.UNSAFE_expValNoExposure)($84806324b2485b8b$var$SHAREPOINT_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$43910e1172480373 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('kd_convo_starters_same_line', 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Slack]?.connectorSources?.includes((0, $8fNUp.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    if (!isUserEligible) return isUserEligible;
    const isFederatedSearchEnabled = (0, $cha5E.expVal)('fed_search_results_in_conf_fps', 'isEnabled', false);
    if (isFederatedSearchEnabled) return false;
    // The latency experiment keeps federated Slack in the all-products request path so
    // we can measure request behavior without the FPS-side exclusion. The gate scopes who
    // is enrolled at all, and the experiment splits enrolled users into cohorts.
    const isLatencyExperimentEnabled = (0, $iDrrr.fg)('ai_3p_slack_search_latency_experiment_enabled') && (0, $cXtTj.default).getExperimentValue('ai-3p-latency-slack-experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    return !isLatencyExperimentEnabled;
};
const $84806324b2485b8b$export$8f6d6be7108023ff = (thirdPartyConfigs, isAllProductSearch)=>{
    const slackConfig = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Slack];
    return isAllProductSearch && !slackConfig?.userNeedsOAuth && !!slackConfig?.connectorSources?.includes((0, $8fNUp.FEDERATED_CONNECTOR_SOURCE)) && (0, $cha5E.expVal)('fed_search_results_in_conf_fps', 'isEnabled', false);
};
const $84806324b2485b8b$export$a254d1715475fc25 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $84806324b2485b8b$export$6308fede6bfa9216 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $84806324b2485b8b$export$a28677150905172f = ()=>{
    return (0, $cXtTj.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $84806324b2485b8b$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $cXtTj.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $84806324b2485b8b$export$752769d90d201b0a = ()=>{
    return (0, $cXtTj.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
/**
 * Resolves whether the multi-site search experiment is enabled for the current user.
 * Only served for Confluence and Jira
 * */ const $84806324b2485b8b$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $84806324b2485b8b$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $cXtTj.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($84806324b2485b8b$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $84806324b2485b8b$export$9da12dc1aa287e01 = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const githubConfig = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Github];
    if (!githubConfig) return false;
    // 1. GitHub connector enabled in tenant.
    if (typeof githubConfig.isEnabled === 'function' && !githubConfig.isEnabled()) return false;
    // 2. User is not yet connected to GitHub.
    if (githubConfig.userNeedsOAuth !== true) return false;
    return true;
};
const $84806324b2485b8b$export$e4fdf56860b85064 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $84806324b2485b8b$export$97f8cc609584332 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $cXtTj.default).getExperimentValue('rovo_fps_show_slack_top_reaction_in_search_ab', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) !== 'control';
const $84806324b2485b8b$export$1a64a03574a6a9b9 = 'quickfind_user_recs';
const $84806324b2485b8b$export$215e8e0e5adc6c3d = 'quickfind_user_recs_challenger_1';
const $84806324b2485b8b$export$eaa28b2ddfe6f8be = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    const isAuthorised = (productKey)=>{
        const config = thirdPartyConfigs[productKey];
        if (!config) return false;
        if (config.userNeedsOAuth === false) return true;
        return config.datasources?.some((ds)=>ds?.userNeedsOAuth === false) ?? false;
    };
    return isAuthorised((0, $fR63l.ProductKeys3P).GoogleDrive) || isAuthorised((0, $fR63l.ProductKeys3P).Sharepoint);
};
const $84806324b2485b8b$export$9cfd2de823bd5c88 = (thirdPartyConfigs, options = {
    fireExperimentExposure: false
})=>{
    if (!$84806324b2485b8b$export$eaa28b2ddfe6f8be(thirdPartyConfigs)) return undefined;
    const value = (0, $cXtTj.default).getExperimentValue('quick_find_recs_1p_3p_sequence_model_exp_p2', 'featureServiceModel', $84806324b2485b8b$export$1a64a03574a6a9b9, options);
    return value === $84806324b2485b8b$export$215e8e0e5adc6c3d ? $84806324b2485b8b$export$215e8e0e5adc6c3d : $84806324b2485b8b$export$1a64a03574a6a9b9;
};
const $84806324b2485b8b$export$d3aa540d72bc6697 = 'quickfind_user_recs_challenger_2';
const $84806324b2485b8b$export$7ac9a21e4901c2f1 = (productEdition)=>{
    const jiraEdition = productEdition?.jira?.toLowerCase();
    return jiraEdition === 'premium' || jiraEdition === 'enterprise';
};
const $84806324b2485b8b$export$7bfdbbe5986e3890 = (options = {
    fireExperimentExposure: false
})=>{
    if (options.fireExperimentExposure === true) return (0, $cha5E.expVal)('quick_find_jira_recommendations', 'cohort', 'control') === 'test';
    return (0, $2pQiO.UNSAFE_expValNoExposure)('quick_find_jira_recommendations', 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$b74b5be8ea9cf91c = 'quick-find-prompt-of-the-day';
const $84806324b2485b8b$export$99bd1e94e401e67f = (options = {
    fireExperimentExposure: false
})=>{
    if (options.fireExperimentExposure === true) return (0, $cha5E.expVal)($84806324b2485b8b$export$b74b5be8ea9cf91c, 'isEnabled', false) === true;
    return (0, $2pQiO.UNSAFE_expValNoExposure)($84806324b2485b8b$export$b74b5be8ea9cf91c, 'isEnabled', false) === true;
};
/**
 * Cohorts for QF GitHub tip banner experiment.
 *
 * - `control`            : banner is not rendered at all.
 * - `test-with-gnin`     : banner triggers on EITHER a GitHub keyword OR a
 *                         Jira GNIN-routing intent (typed JQL / work-item
 *                         key). Matches the experiment doc's "Test 1".
 * - `test-keyword-only`  : banner triggers on a GitHub keyword ONLY \u2014 the
 *                         Jira GNIN intent path is skipped. Matches the
 *                         experiment doc's "Test 2", Jira-specific.
 */ const $84806324b2485b8b$var$QF_GITHUB_TIP_BANNER_COHORTS = [
    'control',
    'test-with-gnin',
    'test-keyword-only'
];
const $84806324b2485b8b$export$839b881580a7010a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const value = (0, $cXtTj.default).getExperimentValue('rovo_qf_github_tip_banner', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    return $84806324b2485b8b$var$QF_GITHUB_TIP_BANNER_COHORTS.includes(value) ? value : 'control';
};
const $84806324b2485b8b$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS = [
    'control',
    'auto_open_chat_modal',
    'on_demand_sain_banner',
    'inline_chat_input_in_results',
    'floating_chat_input'
];
const $84806324b2485b8b$export$e611075348720a7f = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const cohort = (0, $cXtTj.default).getExperimentValue('search_page_proactive_ai_multi_variant', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($84806324b2485b8b$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $84806324b2485b8b$export$1f8098f0a4df3d11 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $cXtTj.default).getExperimentValue('append_deactivated_account_to_contributor_list', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    }) === true;
};
const $84806324b2485b8b$export$951b40241628ffcc = ()=>(0, $cXtTj.default).getExperimentValue('ai_3p_google_drive_federated_search_experiment', 'cohort', 'control') === 'test';
const $84806324b2485b8b$export$2b578d5fa5d72fe8 = ()=>(0, $iDrrr.fg)('ai_3p_sharepoint_federated_search_enabled');
const $84806324b2485b8b$export$48676ed348c9fd9 = ()=>(0, $cha5E.expVal)('rovo_fps_jira_fast_hydration', 'isEnabled', false);
const $84806324b2485b8b$export$2de69c38b710da60 = ()=>(0, $cha5E.expVal)('rovo_qf_jira_fast_hydration', 'isEnabled', false);
const $84806324b2485b8b$var$QUICK_FIND_INSTANT_SEARCH_EXPERIMENT = 'rovo_qf_instant_search';
const $84806324b2485b8b$var$QUICK_FIND_INSTANT_SEARCH_COHORTS = [
    'control',
    'test'
];
const $84806324b2485b8b$export$4540f540b000c694 = (cohortValue)=>$84806324b2485b8b$var$QUICK_FIND_INSTANT_SEARCH_COHORTS.includes(cohortValue);
const $84806324b2485b8b$export$52e695f60019d861 = (primaryProduct)=>{
    // Unified instant-search UI is Confluence-only; never enable it elsewhere.
    if (primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Confluence) return false;
    return (0, $7zn5c.getMutuallyExclusiveUIExperiment)($84806324b2485b8b$var$QUICK_FIND_INSTANT_SEARCH_EXPERIMENT, (0, $3XLuW.STATSIG_QUICK_FIND_LAYER), {
        fireLayerExposure: false
    })?.get('cohort', 'control', $84806324b2485b8b$export$4540f540b000c694) === 'test';
};
const $84806324b2485b8b$export$2dbdf1b16ec34350 = (primaryProduct)=>{
    if (primaryProduct !== (0, $3Ydx7.PrimaryProductKeys).Confluence) return;
    (0, $7zn5c.getMutuallyExclusiveUIExperiment)($84806324b2485b8b$var$QUICK_FIND_INSTANT_SEARCH_EXPERIMENT, (0, $3XLuW.STATSIG_QUICK_FIND_LAYER), {
        fireLayerExposure: true
    })?.get('cohort', 'control', $84806324b2485b8b$export$4540f540b000c694);
};
const $84806324b2485b8b$var$FPS_REFRESH_HOME_ROLLOUT_EXPERIMENT = 'rovo-search-team-eu-26-fps-refresh-exp-home';
const $84806324b2485b8b$var$FPS_REFRESH_CONFLUENCE_ROLLOUT_EXPERIMENT = 'rovo-search-team-eu-26-fps-refresh-exp-confluence';
const $84806324b2485b8b$export$4091f47f5b1f5fd0 = ()=>(0, $cha5E.expVal)($84806324b2485b8b$var$FPS_REFRESH_HOME_ROLLOUT_EXPERIMENT, 'isEnabled', false);
const $84806324b2485b8b$export$eb72dc7762e3e702 = ()=>(0, $cha5E.expVal)($84806324b2485b8b$var$FPS_REFRESH_CONFLUENCE_ROLLOUT_EXPERIMENT, 'isEnabled', false);
const $84806324b2485b8b$export$bb65f9c4738fa52d = (primaryProduct)=>{
    if ((0, $iDrrr.fg)('rovo-search-team-eu-26-fps-refresh')) return true;
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas) return $84806324b2485b8b$export$4091f47f5b1f5fd0();
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence) return $84806324b2485b8b$export$eb72dc7762e3e702();
    return false;
};
const $84806324b2485b8b$export$266abc361fb8e8d8 = ()=>(0, $iDrrr.fg)('rovo-search-team-eu-26-fps-hide-leap-query');
module.exports["triggerExposureForTeamsImpersonatedSearchExp"] = $84806324b2485b8b$export$59c9152b54b9272;
module.exports["serveTeamsImpersonatedSearchExpWithoutExposure"] = $84806324b2485b8b$export$f88a0d041695e20e;
module.exports["triggerExposureForSharepointImpersonatedSearchExp"] = $84806324b2485b8b$export$f4db28ff05de5f7;
module.exports["serveSharepointImpersonatedSearchExpWithoutExposure"] = $84806324b2485b8b$export$aab1030ed135feab;
module.exports["serveConvoStartersSameLine"] = $84806324b2485b8b$export$43910e1172480373;
module.exports["removeFedSlackFromAllProductSearch"] = $84806324b2485b8b$export$9f3b4e44245ab299;
module.exports["serveFederatedOnlySlackInAllProductSearch"] = $84806324b2485b8b$export$8f6d6be7108023ff;
module.exports["serveQF3PBannerExperiment"] = $84806324b2485b8b$export$a254d1715475fc25;
module.exports["serveQF3PBannerExperimentWithoutExposure"] = $84806324b2485b8b$export$6308fede6bfa9216;
module.exports["serveConfluenceSpaceIconUpdate"] = $84806324b2485b8b$export$a28677150905172f;
module.exports["serveQuickFind3PBoostingExperiment"] = $84806324b2485b8b$export$32815557e5d06f0a;
module.exports["getMultiSiteSearchInRovo"] = $84806324b2485b8b$export$9e14285db0210414;
module.exports["serveImproveBannerTargetingExperiment"] = $84806324b2485b8b$export$647c2f5a2b1ce3a5;
module.exports["getUnifiedSearchRightRailEnhancementsExpValue"] = $84806324b2485b8b$export$e4fdf56860b85064;
module.exports["serveSlackTopReactionInSearchExperiment"] = $84806324b2485b8b$export$97f8cc609584332;
module.exports["getQuickFindRecs1P3PSequenceModelP2"] = $84806324b2485b8b$export$9cfd2de823bd5c88;
module.exports["QUICK_FIND_JIRA_RECS_FEATURE_SERVICE_MODEL"] = $84806324b2485b8b$export$d3aa540d72bc6697;
module.exports["isEligibleForQuickFindJiraRecommendationsExperiment"] = $84806324b2485b8b$export$7ac9a21e4901c2f1;
module.exports["serveQuickFindJiraRecommendationsExperiment"] = $84806324b2485b8b$export$7bfdbbe5986e3890;
module.exports["servePromptOfTheDayExperiment"] = $84806324b2485b8b$export$99bd1e94e401e67f;
module.exports["serveQfGithubTipBannerExperiment"] = $84806324b2485b8b$export$839b881580a7010a;
module.exports["getSearchPageProactiveAiMultiVariantCohort"] = $84806324b2485b8b$export$e611075348720a7f;
module.exports["serveAppendDeactivatedAccountToContributorList"] = $84806324b2485b8b$export$1f8098f0a4df3d11;
module.exports["enableFederatedSearchForGoogleDrive"] = $84806324b2485b8b$export$951b40241628ffcc;
module.exports["enableFederatedSearchForSharepoint"] = $84806324b2485b8b$export$2b578d5fa5d72fe8;
module.exports["serveFastJiraHydrationExperiment"] = $84806324b2485b8b$export$48676ed348c9fd9;
module.exports["serveQfFastJiraHydrationExperiment"] = $84806324b2485b8b$export$2de69c38b710da60;
module.exports["serveQuickFindInstantSearch"] = $84806324b2485b8b$export$52e695f60019d861;
module.exports["triggerExposureForQuickFindInstantSearch"] = $84806324b2485b8b$export$2dbdf1b16ec34350;
module.exports["shouldShowRefreshedFilterRow"] = $84806324b2485b8b$export$bb65f9c4738fa52d;
module.exports["shouldHideLeapQueryFeatures"] = $84806324b2485b8b$export$266abc361fb8e8d8;

});

parcelRegister("ljBeq", function(module, exports) {

var $2O9Q9 = parcelRequire("2O9Q9");

const $bd2b1b749e2898a7$export$daea4e28213a211a = ({ isRovoEnabled: isRovoEnabled })=>{
    if (isRovoEnabled) return (0, $2O9Q9.ApplicationModes).Rovo;
    return (0, $2O9Q9.ApplicationModes).Unified;
};
module.exports["getApplicationMode"] = $bd2b1b749e2898a7$export$daea4e28213a211a;

});

parcelRegister("cn81K", function(module, exports) {

var $2LWYf = parcelRequire("2LWYf");

const $2c79acb9e8948053$export$7cbf767827cd68ba = (user)=>{
    if (!user || !user.id) return {
        status: (0, $2LWYf.UserStatus).Unauthenticated,
        id: null,
        name: null,
        email: null
    };
    if (user.id === 'unidentified') return {
        status: (0, $2LWYf.UserStatus).Anonymous,
        ...user
    };
    return {
        status: (0, $2LWYf.UserStatus).Authenticated,
        ...user
    };
};
module.exports["getUser"] = $2c79acb9e8948053$export$7cbf767827cd68ba;

});

parcelRegister("2LWYf", function(module, exports) {
var $e1b52c1f474013cf$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});
var $e1b52c1f474013cf$export$b259bb7f1faab8ee = /*#__PURE__*/ function(LinkDocContentType) {
    LinkDocContentType["extractedLink"] = "extractedLink";
    LinkDocContentType["boostedLink"] = "boostedLink";
    return LinkDocContentType;
}({});
module.exports["UserStatus"] = $e1b52c1f474013cf$export$a82073022ded66e8;
module.exports["LinkDocContentType"] = $e1b52c1f474013cf$export$b259bb7f1faab8ee;

});

parcelRegister("03qcI", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $0bc560a4e6e1cdc5$export$cbfae22cc278acfc = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $0bc560a4e6e1cdc5$export$8e3fc93123f96c19 = (cloudId)=>cloudId === $0bc560a4e6e1cdc5$export$cbfae22cc278acfc;
module.exports["isHello"] = $0bc560a4e6e1cdc5$export$8e3fc93123f96c19;

});

parcelRegister("biQM6", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");

const $c4b729d0e5d2e8d2$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $c4b729d0e5d2e8d2$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $cZKQq.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $cZKQq.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    // remove assets filters
    if ((0, $iDrrr.fg)('asset_rovo_search_remove_filters')) {
        if ((validatedQueryParams.product === (0, $dvVWp.ProductKeys).Assets || validatedQueryParams.assetsSchema || validatedQueryParams.assetsType) && !(0, $iDrrr.fg)('assets_rovo_search_all')) {
            if (validatedQueryParams.product === (0, $dvVWp.ProductKeys).Assets) validatedQueryParams.product = undefined;
            validatedQueryParams.assetsSchema = undefined;
            validatedQueryParams.assetsType = undefined;
        }
    }
    return validatedQueryParams;
};
const $c4b729d0e5d2e8d2$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $c4b729d0e5d2e8d2$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $c4b729d0e5d2e8d2$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        // Some query params (e.g. `overrides`) are stored as structured objects in
        // `SearchQueryStringParams` (parsed via Zod). When converting back to raw query params /
        // query string, we must serialize them.
        if (value && typeof value === 'object') return [
            [
                paramKey,
                encodeURIComponent(JSON.stringify(value))
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $c4b729d0e5d2e8d2$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($c4b729d0e5d2e8d2$export$fc8e8d0c43c32316($c4b729d0e5d2e8d2$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $c4b729d0e5d2e8d2$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($c4b729d0e5d2e8d2$export$fc8e8d0c43c32316($c4b729d0e5d2e8d2$export$17404cc52c459484(queryParams)));
};
const $c4b729d0e5d2e8d2$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$c4b729d0e5d2e8d2$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
const $c4b729d0e5d2e8d2$export$11c3edcbebb03988 = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $c4b729d0e5d2e8d2$export$ac30e2047efa6738 = (datasourceId, selectedProduct, thirdPartyConfigs)=>{
    if (!datasourceId || !selectedProduct || !thirdPartyConfigs) return undefined;
    const productConfig = thirdPartyConfigs[selectedProduct];
    if (!productConfig?.datasources) return undefined;
    return productConfig.datasources.find((ds)=>ds.datasourceId === datasourceId);
};
module.exports["parseQueryParams"] = $c4b729d0e5d2e8d2$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $c4b729d0e5d2e8d2$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $c4b729d0e5d2e8d2$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $c4b729d0e5d2e8d2$export$e247f217269cd2eb;
module.exports["convertQueryParamsToStringArray"] = $c4b729d0e5d2e8d2$export$11c3edcbebb03988;
module.exports["getDatasourceFromId"] = $c4b729d0e5d2e8d2$export$ac30e2047efa6738;

});

parcelRegister("cZKQq", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $1Fy3P = parcelRequire("1Fy3P");


var $7ydfN = parcelRequire("7ydfN");


var $iYHGy = parcelRequire("iYHGy");


var $1T3zR = parcelRequire("1T3zR");


var $fEMyR = parcelRequire("fEMyR");


var $5sbmC = parcelRequire("5sbmC");


var $cQ704 = parcelRequire("cQ704");


var $4ktA3 = parcelRequire("4ktA3");


var $04Vsl = parcelRequire("04Vsl");


var $esQrd = parcelRequire("esQrd");


var $bvXTU = parcelRequire("bvXTU");


var $3L25R = parcelRequire("3L25R");


var $ai4mL = parcelRequire("ai4mL");


var $kvUqR = parcelRequire("kvUqR");


var $4IMl4 = parcelRequire("4IMl4");


var $41SDB = parcelRequire("41SDB");


var $gcyCs = parcelRequire("gcyCs");


var $hAGDy = parcelRequire("hAGDy");


var $fZYb4 = parcelRequire("fZYb4");


var $cVMuZ = parcelRequire("cVMuZ");


var $QaUQl = parcelRequire("QaUQl");


var $4wG6Y = parcelRequire("4wG6Y");


var $9ekgQ = parcelRequire("9ekgQ");


var $eV6Wt = parcelRequire("eV6Wt");


var $86rIn = parcelRequire("86rIn");


var $kI7H0 = parcelRequire("kI7H0");


var $k4X5q = parcelRequire("k4X5q");


var $f8JMS = parcelRequire("f8JMS");


var $9efpj = parcelRequire("9efpj");


var $8maTJ = parcelRequire("8maTJ");


var $clVfp = parcelRequire("clVfp");


var $iRUkk = parcelRequire("iRUkk");


var $e63Cm = parcelRequire("e63Cm");

const $76d59471cda7f035$export$ec20ab1a5eb36014 = (0, $iYHGy.allContentTypeSchema).enum;
const $76d59471cda7f035$export$48b648eee115c3e5 = (0, $5sbmC.atlasContentTypeSchema).enum;
const $76d59471cda7f035$export$721015a6e24d06a0 = (0, $1T3zR.asanaContentTypeSchema).enum;
const $76d59471cda7f035$export$98ac9eece9e68319 = (0, $esQrd.confluenceContentTypeSchema).enum;
const $76d59471cda7f035$export$bcc0874ed7743007 = (0, $4IMl4.googleContentTypeSchema).enum;
const $76d59471cda7f035$export$847712e479ca402d = (0, $QaUQl.microsoftContentTypeSchema).enum;
const $76d59471cda7f035$export$8c76eb96ebfefeac = (0, $3L25R.dropboxContentTypeSchema).enum;
const $76d59471cda7f035$export$e3ddf72248eaf972 = (0, $gcyCs.jiraContentTypeSchema).enum;
const $76d59471cda7f035$export$39271a5a1b74da02 = (0, $04Vsl.compassContentTypeSchema).enum;
const $76d59471cda7f035$export$145fdb32ff1a4acf = (0, $cVMuZ.mercuryContentTypeSchema).enum;
const $76d59471cda7f035$export$d493ea6967abef56 = (0, $9efpj.talentContentTypeSchema).enum;
const $76d59471cda7f035$export$309520b897e0c0b = (0, $clVfp.trelloContentTypeSchema).enum;
const $76d59471cda7f035$export$d51b5367809bb96 = (0, $kI7H0.slackContentTypeSchema).enum;
const $76d59471cda7f035$export$c69d59ad598aee72 = (0, $8maTJ.teamsContentTypeSchema).enum;
const $76d59471cda7f035$export$8de16d71f5b0d410 = (0, $kvUqR.githubContentTypeSchema).enum;
const $76d59471cda7f035$export$bf86d9f770860253 = (0, $iRUkk.webPageContentTypeSchema).enum;
const $76d59471cda7f035$export$66f84ff942de6e1f = (0, $ai4mL.figmaContentTypeSchema).enum;
const $76d59471cda7f035$export$56591a3ad34d704b = (0, $fZYb4.loomContentTypeSchema).enum;
const $76d59471cda7f035$export$fd3bdf5548c7bf84 = (0, $e63Cm.zendeskContentTypeSchema).enum;
const $76d59471cda7f035$export$6b45e4ca3151b046 = (0, $k4X5q.smartLinksContentTypeSchema).enum;
const $76d59471cda7f035$export$9325d29d4a9658a4 = (0, $eV6Wt.salesforceContentTypeSchema).enum;
const $76d59471cda7f035$export$92229a634de6b0ae = (0, $bvXTU.databricksContentTypeSchema).enum;
const $76d59471cda7f035$export$7c597234a357d5f7 = (0, $41SDB.hubspotContentTypeSchema).enum;
const $76d59471cda7f035$export$7f83273171d63901 = (0, $86rIn.servicenowContentTypeSchema).enum;
const $76d59471cda7f035$export$a08d1bf234105c9c = (0, $fEMyR.assetsContentTypeSchema).enum;
const $76d59471cda7f035$export$593c74387f9db963 = (0, $87Lnp.z).nativeEnum({
    ...$76d59471cda7f035$export$ec20ab1a5eb36014,
    ...$76d59471cda7f035$export$721015a6e24d06a0,
    ...$76d59471cda7f035$export$48b648eee115c3e5,
    ...$76d59471cda7f035$export$98ac9eece9e68319,
    ...$76d59471cda7f035$export$bcc0874ed7743007,
    ...$76d59471cda7f035$export$847712e479ca402d,
    ...$76d59471cda7f035$export$e3ddf72248eaf972,
    ...$76d59471cda7f035$export$39271a5a1b74da02,
    ...$76d59471cda7f035$export$145fdb32ff1a4acf,
    ...$76d59471cda7f035$export$309520b897e0c0b,
    ...$76d59471cda7f035$export$d51b5367809bb96,
    ...$76d59471cda7f035$export$c69d59ad598aee72,
    ...$76d59471cda7f035$export$66f84ff942de6e1f,
    ...$76d59471cda7f035$export$8de16d71f5b0d410,
    ...$76d59471cda7f035$export$56591a3ad34d704b,
    ...$76d59471cda7f035$export$bf86d9f770860253,
    ...$76d59471cda7f035$export$8c76eb96ebfefeac,
    ...$76d59471cda7f035$export$fd3bdf5548c7bf84,
    ...$76d59471cda7f035$export$6b45e4ca3151b046,
    ...$76d59471cda7f035$export$9325d29d4a9658a4,
    ...$76d59471cda7f035$export$7c597234a357d5f7,
    ...$76d59471cda7f035$export$92229a634de6b0ae,
    ...$76d59471cda7f035$export$a08d1bf234105c9c,
    ...$76d59471cda7f035$export$d493ea6967abef56,
    ...$76d59471cda7f035$export$7f83273171d63901
});
const $76d59471cda7f035$export$4f29dba8e623c3d1 = (0, $87Lnp.z).nativeEnum({
    ...(0, $7ydfN.TypeFilterValueKey),
    ...$76d59471cda7f035$export$ec20ab1a5eb36014
});
const $76d59471cda7f035$export$e2e108cbe2e4f865 = $76d59471cda7f035$export$4f29dba8e623c3d1.enum;
const $76d59471cda7f035$export$8a9f7fff0151f0f7 = (0, $87Lnp.z).nativeEnum({
    ...(0, $1Fy3P.PageStatusFilterValueKey),
    ...$76d59471cda7f035$export$ec20ab1a5eb36014
});
const $76d59471cda7f035$export$e6747eee8f26f8c0 = (0, $hAGDy.lastModifiedValueSchema).enum;
const $76d59471cda7f035$export$d43f91ac58cde147 = (0, $f8JMS.sortSchema).enum;
const $76d59471cda7f035$var$jsonEncodedSchema = (schema)=>(0, $87Lnp.z).preprocess((value)=>{
        // Expected format: URL encoded JSON string
        if (typeof value === 'string') {
            let decoded = value;
            try {
                decoded = decodeURIComponent(value);
            } catch  {
            // ignore decoding errors; schema will fail if JSON is invalid
            }
            try {
                return JSON.parse(decoded);
            } catch  {
                return value;
            }
        }
        return value;
    }, schema);
const $76d59471cda7f035$export$37bdef1e194c0e7e = $76d59471cda7f035$var$jsonEncodedSchema((0, $87Lnp.z).object({
    sourceProduct: (0, $87Lnp.z).string().min(1).optional(),
    frontendFeatureGates: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).string().min(1),
        value: (0, $87Lnp.z).boolean()
    })).optional(),
    frontendExperiments: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).string().min(1),
        value: (0, $87Lnp.z).record((0, $87Lnp.z).union([
            (0, $87Lnp.z).string(),
            (0, $87Lnp.z).boolean()
        ]))
    })).optional(),
    backendExperiments: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).enum([
            'search_platform_layer_l1',
            'search_platform_layer_l2',
            'search_platform_layer_l3',
            'search_platform_layer_query_expansion'
        ]),
        analyticsDefinitions: (0, $87Lnp.z).array((0, $87Lnp.z).object({
            layerId: (0, $87Lnp.z).string().nullable().optional(),
            shadowId: (0, $87Lnp.z).string().nullable().optional(),
            entity: (0, $87Lnp.z).string().nullable().optional(),
            subEntity: (0, $87Lnp.z).string().nullable().optional(),
            abTestId: (0, $87Lnp.z).string().nullable(),
            armId: (0, $87Lnp.z).string().nullable().optional(),
            controlId: (0, $87Lnp.z).string().nullable()
        }).passthrough()).optional()
    }).passthrough()).optional()
}).passthrough());
const $76d59471cda7f035$export$7b58b3b9a7b83d61 = (0, $87Lnp.z).object({
    text: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    originalQuery: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    product: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $9ekgQ.productKeySchema))),
    datasource: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    type: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$4f29dba8e623c3d1)),
    filterDropdownOpen: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Last Modified
    lastModified: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $hAGDy.lastModifiedValueSchema))),
    lastModified_lt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    lastModified_gt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    from: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    to: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    sort: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $f8JMS.sortSchema))),
    titleMatch: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Confluence filters
    contributors: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    owners: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    ancestor: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    // Salesforce Filters
    campaignStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    caseStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    knowledgeArticleStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    eventTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    leadStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    taskStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    taskTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    isAutoApplied: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    salesforceStages: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    spaces: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    sites: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    verified: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    labels: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    tags: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    pageStatus: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$8a9f7fff0151f0f7)),
    archived: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Jira Filters
    jAssignee: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jReporter: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jCommentedByMe: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    jProject: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jWatchedByMe: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Assets Filters
    assetsSchema: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    assetsType: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Mercury Filters
    focusAreaTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    focusAreaUnder: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Talent Filters
    positionEmploymentTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionFocusAreas: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionJobFamilies: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionTeams: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Compass Filters
    compassArchived: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    createdBy: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    lastUpdatedBy: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Salesforce Close Date filter
    closeDate: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    closeDateVal: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    // Salesforce Opportunity Status filter
    opportunityStatus: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    referrer: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    /**
	 * Quick Find chat-convergence routing decision that sent the user to this search, when there was
	 * one. Read once on bootstrap and passed down to Search AI answers, which surfaces it on
	 * `aiResult viewed` (QS-10491).
	 */ rovoJourneyId: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    /**
	 * URL encoded JSON string used to override feature gates/experiments for debugging.
	 */ overrides: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$37bdef1e194c0e7e)),
    cql: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    status: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Pull Request Status filter (GitHub, Bitbucket, GitLab)
    pullRequestStatus: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Repository filter (GitHub)
    repository: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Reviewer filter (GitHub)
    reviewer: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Slack Channel filter
    slackChannels: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Loom folder filter (Quick Find, multi-select)
    folders: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // MS Teams Team (workspace) filter
    workspaceName: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // MS Teams Has Attachment filter
    hasAttachment: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema))
});
const $76d59471cda7f035$export$f374b5430ac28f4c = $76d59471cda7f035$export$7b58b3b9a7b83d61.keyof().enum;
const $76d59471cda7f035$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: _, lastModified_gt: __, lastModified_lt: ___, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    // If closeDate is not 'custom', strip out closeDateVal
    (queryParams)=>{
        if (queryParams.closeDate !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { closeDateVal: closeDateVal, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $76d59471cda7f035$export$83efce6e50d7c43b = (0, $87Lnp.z).nativeEnum({
    ...(0, $4wG6Y.ProductKey),
    ...$76d59471cda7f035$export$e2e108cbe2e4f865,
    ...$76d59471cda7f035$export$e6747eee8f26f8c0,
    ...$76d59471cda7f035$export$f374b5430ac28f4c
});
const $76d59471cda7f035$export$3d21d7040623da50 = $76d59471cda7f035$export$83efce6e50d7c43b.enum;
module.exports["ContentType"] = $76d59471cda7f035$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $76d59471cda7f035$export$e6747eee8f26f8c0;
module.exports["Sort"] = $76d59471cda7f035$export$d43f91ac58cde147;
module.exports["searchQueryParamsBaseSchema"] = $76d59471cda7f035$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $76d59471cda7f035$export$ff67c0a0b67bb249;

});

parcelRegister("1Fy3P", function(module, exports) {
// these are values for the query params
// oxlint-disable-next-line eslint/no-redeclare
const $1ea302473f169de3$export$dbcc81d768a46013 = {
    RoughDraft: 'roughDraft',
    InProgress: 'inProgress',
    ReadyForReview: 'readyForReview',
    Verified: 'verified'
};
const $1ea302473f169de3$export$48932d85514b3629 = Object.values($1ea302473f169de3$export$dbcc81d768a46013);
const $1ea302473f169de3$export$106c1c66f1b4a23e = {
    [$1ea302473f169de3$export$dbcc81d768a46013.RoughDraft]: 'Rough draft',
    [$1ea302473f169de3$export$dbcc81d768a46013.InProgress]: 'In progress',
    [$1ea302473f169de3$export$dbcc81d768a46013.ReadyForReview]: 'Ready for review',
    [$1ea302473f169de3$export$dbcc81d768a46013.Verified]: 'Verified'
};
const $1ea302473f169de3$export$1b1e4f3d8ba5c6c1 = (value)=>{
    return $1ea302473f169de3$export$48932d85514b3629.includes(value);
};
module.exports["PageStatusFilterValueKey"] = $1ea302473f169de3$export$dbcc81d768a46013;
module.exports["allPageStatusFilterValueKeys"] = $1ea302473f169de3$export$48932d85514b3629;
module.exports["PageStatusFilterValue"] = $1ea302473f169de3$export$106c1c66f1b4a23e;
module.exports["isPageStatusFilterValueKey"] = $1ea302473f169de3$export$1b1e4f3d8ba5c6c1;

});

parcelRegister("ktiKH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $biQM6 = parcelRequire("biQM6");








var $ktiKH = parcelRequire("ktiKH");

const $e274018abf4fad3c$export$1e8af0ff123020f2 = {
    queryParams: {},
    referrer: undefined,
    /**
   * Empty because it is falsy and then will be overridden during boostrap
   * Can't be uuid() because then won't be overridden!
   * Can't be undefined, because we want to be explicit about the fact that this should be set during bootstrap and not be optional
   */ searchSessionId: '',
    smartLinkUsage: undefined,
    thirdPartyConfigs: undefined
};
const $e274018abf4fad3c$export$6286a07f09af7d90 = ({ children: children, searchSessionId: searchSessionId, referrer: referrer, smartLinkUsage: smartLinkUsage, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    const parsedQueryParams = (0, $cozmU.useMemo)(()=>{
        return (0, $biQM6.parseQueryParams)(queryParams || $e274018abf4fad3c$export$1e8af0ff123020f2.queryParams);
    }, [
        queryParams
    ]);
    // A classic anything-updates useMemo
    const dynamicProps = (0, $cozmU.useMemo)(()=>{
        return {
            queryParams: parsedQueryParams,
            searchSessionId: // Passed directly through for easy hook access in code sites
            // TODO QS-9194 should all be prop drilled later
            searchSessionId,
            referrer: referrer,
            smartLinkUsage: smartLinkUsage,
            thirdPartyConfigs: thirdPartyConfigs
        };
    }, [
        parsedQueryParams,
        referrer,
        searchSessionId,
        smartLinkUsage,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.DynamicBootstrapContext).Provider, {
        value: dynamicProps
    }, children);
};



var $yW9ML = parcelRequire("yW9ML");





var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $3ZYG5 = parcelRequire("3ZYG5");


var $jXCr4 = parcelRequire("jXCr4");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $9NmsO = parcelRequire("9NmsO");


var $ljBeq = parcelRequire("ljBeq");


var $03qcI = parcelRequire("03qcI");





var $eD8r5 = parcelRequire("eD8r5");


var $4BJ6s = parcelRequire("4BJ6s");







// Attempting to build defaultstate from the same underlying definitions to ease migration to minimise migration
// omit from initialState
const { queryParams: $805dc5654c534215$var$_queryParams, referrer: $805dc5654c534215$var$_referrer, searchSessionId: $805dc5654c534215$var$_searchSessionId, thirdPartyConfigs: $805dc5654c534215$var$_thirdPartyConfigs, prevQueryParams: $805dc5654c534215$var$_prevQueryParams, initialSpaceARIs: $805dc5654c534215$var$_initialSpaceARIs, ...$805dc5654c534215$var$inheritedInitialState } = (0, $jXCr4.initialState);
const $805dc5654c534215$export$30ed20aaeaed4b77 = {
    ...$805dc5654c534215$var$inheritedInitialState,
    initialTextQueryParam: undefined,
    queryParamsCallback: ()=>{},
    refreshSearchSessionId: ()=>{},
    clearReferrer: ()=>{},
    setThirdPartyConfigs: ()=>{},
    onSearchCompleted: ()=>{},
    experience: (0, $9pcjO.SearchExperience).SEARCH_PAGE,
    applicationMode: (0, $ljBeq.getApplicationMode)({
        isRovoEnabled: $805dc5654c534215$var$inheritedInitialState.isRovoEnabled
    }),
    multiSiteSearchInRovo: (0, $cJff5.getMultiSiteSearchInRovo)($805dc5654c534215$var$inheritedInitialState.experimentConfig),
    isHello: (0, $03qcI.isHello)($805dc5654c534215$var$inheritedInitialState.cloudId),
    thirdPartyConfigs: {}
};
const $805dc5654c534215$export$bc36689a336ce85c = ({ children: children, initialProps: props, queryParams: queryParams, queryParamsCallback: queryParamsCallback, refreshSearchSessionId: refreshSearchSessionId, initialText: initialText, clearReferrer: clearReferrer, initialThirdPartyConfigs: initialThirdPartyConfigs, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, experience: experience, accessibleProducts: accessibleProducts })=>{
    /**
   * Static lock version counter. The useMemo recomputes whenever this value changes.
   *
   * Version semantics:
   * - 0: Lock open (bootstrap config not yet loaded)
   * - 1: Lock closed (bootstrap config loaded, values frozen)
   * - >1: Lock was reopened post-bootstrap via setThirdPartyConfigs (the ONLY path that increments above 1)
   *
   * If isConfigLoaded is already true on first render, starts at 1 so values are immediately available
   * without an extra render cycle.
   *
   * Post-bootstrap, setThirdPartyConfigs can increment the counter above 1 to force the useMemo to
   * recompute with updated refs. This is an expensive action that should be used sparingly and only
   * in response to uncommon user actions (e.g. OAuth connect flow).
   *
   * IMPORTANT: effectiveLockVersion is the SOLE dependency of the static useMemo. Do not add other dependencies.
   * If you need the useMemo to recompute for a new value, store that value in a ref and reopen the lock by incrementing this counter.
   */ const [staticLockVersion, setStaticLockVersion] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(()=>$805dc5654c534215$var$shouldStaticLockClose({
            isConfigLoaded: props.isConfigLoaded || false
        }) ? 1 : 0);
    /**
   * Close the static lock synchronously during render when isConfigLoaded becomes true.
   * Sets the version to exactly 1 (not an increment) so that only setThirdPartyConfigs can push the version above 1.
   */ if (staticLockVersion === 0 && $805dc5654c534215$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    })) setStaticLockVersion(1);
    // Create a stable store instance once per component lifetime
    const storeRef = (0, $cozmU.useRef)(null);
    /**
   * Derive the effective lock version synchronously from both the state counter AND props.isConfigLoaded.
   *
   * When isConfigLoaded transitions from false to true, the in-render setState above schedules a
   * state update, but staticLockVersion still reads as 0 on THIS render. Previously, the useMemo
   * (which depended solely on staticLockVersion) would not recompute until the NEXT render when
   * staticLockVersion became 1 — costing an extra render cycle (~100ms+ in a complex tree).
   *
   * effectiveLockVersion resolves this by treating the lock as closed immediately when
   * isConfigLoaded is true, even before the state update takes effect. The useMemo now depends
   * on effectiveLockVersion, so it recomputes on the same render that isConfigLoaded becomes true.
   *
   * For setThirdPartyConfigs (version > 1), the state-based counter still drives recomputation
   * as before, since isConfigLoaded is already true at that point.
   */ const effectiveLockVersion = staticLockVersion === 0 && $805dc5654c534215$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    }) ? 1 : staticLockVersion;
    /**
   * thirdPartyConfigs is expected to be static after bootstrap, but can be overridden during OAuth workflow as a cheap "cache bust".
   *
   * Stored in a ref so that updates do not directly cause re-renders. Instead, the OAuth callback
   * (setThirdPartyConfigs) updates the ref and reopens the static lock for exactly one render,
   * allowing the useMemo to recompute with the new value.
   */ const thirdPartyConfigsRef = (0, $cozmU.useRef)(initialThirdPartyConfigs || {});
    // Sync thirdPartyConfigs from props when config finishes loading (before static lock closes).
    // Uses staticLockVersion (not staticLockClosed/effectiveLockVersion) because when isConfigLoaded
    // transitions to true, effectiveLockVersion eagerly resolves to 1 on the same render. The ref
    // must be updated BEFORE the useMemo (which depends on effectiveLockVersion) recomputes, so we
    // check the underlying state which is still 0 on the transition render.
    if (staticLockVersion === 0 && props.isConfigLoaded) thirdPartyConfigsRef.current = initialThirdPartyConfigs || {};
    const setThirdPartyConfigs = (0, $cozmU.useCallback)((configs)=>{
        thirdPartyConfigsRef.current = configs;
        // Reopen the static lock for exactly one render so the useMemo recomputes with the new thirdPartyConfigs
        setStaticLockVersion((v)=>v + 1);
    }, []);
    const useMemoStaticProps = (0, $cozmU.useMemo)(()=>{
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        const parsedQueryParams = queryParams && enableRovoSearchOverrides ? (0, $biQM6.parseQueryParams)(queryParams) : undefined;
        const isRovoEnabled = props.isRovoEnabled || $805dc5654c534215$export$30ed20aaeaed4b77.isRovoEnabled;
        const cloudId = props.cloudId || $805dc5654c534215$export$30ed20aaeaed4b77.cloudId;
        const primaryProduct = props.primaryProduct || $805dc5654c534215$export$30ed20aaeaed4b77.primaryProduct;
        const primarySubProduct = props.primarySubProduct || $805dc5654c534215$export$30ed20aaeaed4b77.primarySubProduct;
        const user = props.user || $805dc5654c534215$export$30ed20aaeaed4b77.user;
        // Under rovo-search-remove-rss-bootstrap-fg, compute experimentConfig directly
        // via getExperimentConfig instead of receiving it through props from BootstrapStoreProvider.
        // This moves the experiment config computation into the static context where it belongs,
        // using props already available here. If a prop is explicitly provided, use it as an
        // override (supports backward compat during rollout and test scenarios).
        // Keep in sync with: bootstrap-store-provider/index.tsx
        const experimentConfig = (0, $4BJ6s.serveBootstrapProviderExp)() ? props.experimentConfig || (0, $3ZYG5.getExperimentConfig)({
            primaryProduct: primaryProduct,
            experimentLayers: props.experimentLayers ?? [],
            sideBySideExperiment: props.features?.sideBySide?.experiments,
            statsigLayer: undefined,
            onError: (error)=>(0, $eD8r5.logException)(error, user?.id, primaryProduct)
        }) : props.experimentConfig || $805dc5654c534215$export$30ed20aaeaed4b77.experimentConfig;
        // This can contain duplicates from e.g. a full drive connector and a drive smartlink connector
        // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed here
        // instead of in bootstrap-store-provider. On the old path, products is already processed.
        const products = (0, $4BJ6s.serveBootstrapProviderExp)() ? $805dc5654c534215$var$dedupProducts((0, $9NmsO.getAccessibleProducts)({
            supportedProducts: (0, $dvVWp.getAllProductKeys)(),
            products: props.products,
            accessibleProducts: accessibleProducts
        }), $805dc5654c534215$export$30ed20aaeaed4b77.products) : $805dc5654c534215$var$dedupProducts(props.products || [], $805dc5654c534215$export$30ed20aaeaed4b77.products);
        return {
            // Literal constant
            allFilterExcludedProducts: (0, $4ysB6.getAllFilterExcludedProducts)({
                experience: experience,
                primaryProduct: props.primaryProduct
            }),
            // Static from internal props to BootstrapProvider
            experience: experience || $805dc5654c534215$export$30ed20aaeaed4b77.experience,
            // Static from host product props
            cloudId: cloudId,
            isHello: (0, $03qcI.isHello)(cloudId),
            aggregatorHostName: props.aggregatorHostName || $805dc5654c534215$export$30ed20aaeaed4b77.aggregatorHostName,
            aggAbsoluteUrl: props.aggAbsoluteUrl || $805dc5654c534215$export$30ed20aaeaed4b77.aggAbsoluteUrl,
            SAINHostName: props.SAINHostName || $805dc5654c534215$export$30ed20aaeaed4b77.SAINHostName,
            orgId: props.orgId || $805dc5654c534215$export$30ed20aaeaed4b77.orgId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            analyticsAttributes: props.analyticsAttributes || $805dc5654c534215$export$30ed20aaeaed4b77.analyticsAttributes,
            features: props.features || $805dc5654c534215$export$30ed20aaeaed4b77.features,
            experimentLayers: props.experimentLayers || $805dc5654c534215$export$30ed20aaeaed4b77.experimentLayers,
            queryParamsCallback: queryParamsCallback || $805dc5654c534215$export$30ed20aaeaed4b77.queryParamsCallback,
            onSearchCompleted: onSearchCompleted || props.onSearchCompleted || $805dc5654c534215$export$30ed20aaeaed4b77.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess || props.onOAuthSuccess || $805dc5654c534215$export$30ed20aaeaed4b77.onOAuthSuccess,
            user: user,
            // Extracted on first load from queryParams (host product props)
            initialTextQueryParam: initialText,
            // DYNAMIC: from bootstrap config -> isConfigLoaded
            isConfigLoaded: props.isConfigLoaded || $805dc5654c534215$export$30ed20aaeaed4b77.isConfigLoaded,
            isRovoEnabled: isRovoEnabled,
            applicationMode: (0, $ljBeq.getApplicationMode)({
                isRovoEnabled: isRovoEnabled
            }),
            nouns: props.nouns || $805dc5654c534215$export$30ed20aaeaed4b77.nouns,
            productEdition: props.productEdition || $805dc5654c534215$export$30ed20aaeaed4b77.productEdition,
            productDataRegions: props.productDataRegions || $805dc5654c534215$export$30ed20aaeaed4b77.productDataRegions,
            rovoFeatures: props.rovoFeatures || $805dc5654c534215$export$30ed20aaeaed4b77.rovoFeatures,
            linkedCloudARIs: props.linkedCloudARIs || $805dc5654c534215$export$30ed20aaeaed4b77.linkedCloudARIs,
            unitMetadata: props.unitMetadata || $805dc5654c534215$export$30ed20aaeaed4b77.unitMetadata,
            isJiraIssueIndexed: props.isJiraIssueIndexed || $805dc5654c534215$export$30ed20aaeaed4b77.isJiraIssueIndexed,
            hasEditOrViewPlanPermission: props.hasEditOrViewPlanPermission || $805dc5654c534215$export$30ed20aaeaed4b77.hasEditOrViewPlanPermission,
            // when removing this feature flag, update the type to no longer be optional
            ...enableRovoSearchOverrides && {
                overrides: parsedQueryParams?.overrides || (0, $jXCr4.initialState).overrides
            },
            // Third party configs - static after bootstrap, mutable only via OAuth callback (read from ref)
            thirdPartyConfigs: thirdPartyConfigsRef.current,
            refreshSearchSessionId: // passed directly through from props
            refreshSearchSessionId,
            clearReferrer: clearReferrer,
            setThirdPartyConfigs: setThirdPartyConfigs,
            experimentConfig: // experimentConfig is now computed directly in this static context under
            // rovo-search-remove-rss-bootstrap-fg via getExperimentConfig, or falls back to props on the old path.
            experimentConfig,
            multiSiteSearchInRovo: (0, $cJff5.getMultiSiteSearchInRovo)(experimentConfig),
            products: products
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveLockVersion
    ]); // Do not expand this dependency. See effectiveLockVersion JSDoc. Reach out to #help-search-plex or #search-plex-perf-squad with any questions
    // Create or sync the external store.
    // On first render this creates the store; on subsequent renders it notifies
    // only subscribers whose selected slice actually changed.
    if (storeRef.current === null) storeRef.current = (0, $yW9ML.createStaticBootstrapStore)(useMemoStaticProps);
    else storeRef.current.setState(useMemoStaticProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.StaticBootstrapContext).Provider, {
        value: useMemoStaticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.StaticBootstrapStoreContext).Provider, {
        value: storeRef.current
    }, children));
};
/**
 * Lock static context values after config is loaded to ensure they do not change during the session, as they are expected to be static after the bootstrap phase.
 * This also allows us to remove any dependencies on props that would cause unnecessary re-renders of the static context provider and all of its children
 *
 * The only values that should be here are booleans set by ASYNC behaviour that we must wait for (e.g. the config network call(s))
 * To add a new async dependency, provide a boolean e.g. myAsyncValue that is false until the async behaviour is complete, and then add it to the shouldStaticLockClose function.
 *
 * Note: This is on the search query critical performance path, any additional values added here should be carefully considered.
 * Reach out to #help-search-plex or #search-plex-perf-squad with any questions
 */ const $805dc5654c534215$var$shouldStaticLockClose = ({ isConfigLoaded: isConfigLoaded })=>{
    return isConfigLoaded; // Set by `useFetchConfig`, supported by promise-reuse and localStorage caching
};
/**
 * The set of `products` as passed in as a prop has duplicates due to smartlinks etc (drive can appear several times!)
 * We uniq() this list for use within search
 */ const $805dc5654c534215$var$dedupProducts = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));


const $b0de8a9155c475f6$export$b676c7d6baea13e9 = ({ children: children, experience: experience, accessibleProducts: accessibleProducts, ...props })=>{
    const { thirdPartyConfigs: initialThirdPartyConfigsProp, searchSessionId: searchSessionIdProp, smartLinkUsage: smartLinkUsageProp } = props.initialProps || {};
    const safeQueryParams = props.queryParams && (0, $biQM6.parseQueryParams)(props.queryParams);
    /**
   * searchSessionId is generated on the client and does not change frequently, but can be refreshed with refreshSearchSessionId
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [searchSessionId, setSearchSessionId] = (0, $cozmU.useState)(searchSessionIdProp ?? crypto.randomUUID());
    const refreshSearchSessionId = (0, $cozmU.useCallback)(()=>{
        const newSearchSessionId = crypto.randomUUID();
        setSearchSessionId(newSearchSessionId);
    }, []);
    /**
   * Initial ?referrer=X paramater for analytics
   * Referrer is actually static for a single page load once, but is cleaned up after use so it isn't re-used in analytics events
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [referrer, setReferrer] = (0, $cozmU.useState)(safeQueryParams?.referrer);
    const clearReferrer = (0, $cozmU.useCallback)(()=>{
        setReferrer(undefined);
    }, []);
    /**
   * Initial ?text=X parameter for search store
   *
   * I think this is only used in search-page when checking referrer (not relay) and can be cleaned up with `search-page-relay`
   */ const [initialText] = (0, $cozmU.useState)(safeQueryParams?.text);
    const staticProps = {
        refreshSearchSessionId: refreshSearchSessionId,
        clearReferrer: clearReferrer,
        initialText: initialText,
        initialThirdPartyConfigs: (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? {} : initialThirdPartyConfigsProp || {},
        experience: experience,
        accessibleProducts: accessibleProducts
    };
    const dynamicProps = {
        searchSessionId: searchSessionId,
        referrer: referrer,
        smartLinkUsage: smartLinkUsageProp,
        ...(0, $iDrrr.fg)('rovo_fps_use_rovo_config') && {
            thirdPartyConfigs: initialThirdPartyConfigsProp || {}
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $805dc5654c534215$export$bc36689a336ce85c), {
        ...props,
        ...staticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e274018abf4fad3c$export$6286a07f09af7d90), {
        ...props,
        ...dynamicProps
    }, children));
};
const $b0de8a9155c475f6$export$dada99aabcba96f5 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $805dc5654c534215$export$30ed20aaeaed4b77));
const $b0de8a9155c475f6$export$64067c351da2da1b = /*#__PURE__*/ (0, $cozmU.createContext)((0, $yW9ML.createStaticBootstrapStore)((0, $805dc5654c534215$export$30ed20aaeaed4b77)));
const $b0de8a9155c475f6$export$7925fbd6de082b5c = /*#__PURE__*/ (0, $cozmU.createContext)((0, $e274018abf4fad3c$export$1e8af0ff123020f2));
module.exports["BootstrapContextProvider"] = $b0de8a9155c475f6$export$b676c7d6baea13e9;
module.exports["StaticBootstrapContext"] = $b0de8a9155c475f6$export$dada99aabcba96f5;
module.exports["StaticBootstrapStoreContext"] = $b0de8a9155c475f6$export$64067c351da2da1b;
module.exports["DynamicBootstrapContext"] = $b0de8a9155c475f6$export$7925fbd6de082b5c;

});

parcelRegister("3ZYG5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $1Qme9 = parcelRequire("1Qme9");


var $cc6x1 = parcelRequire("cc6x1");


var $3XLuW = parcelRequire("3XLuW");


var $5msm2 = parcelRequire("5msm2");


var $7zn5c = parcelRequire("7zn5c");

const $8b075a34b0dc6cb8$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $5msm2.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
        const layer = (0, $cXtTj.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $7zn5c.getFrontendExperiment)({
                abTestId: frontendExperimentName,
                onError: (error)=>onErrorFn?.(error)
            }),
            backendExperiment: (0, $3XLuW.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $5msm2.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $3XLuW.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
    };
};
const $8b075a34b0dc6cb8$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $iDrrr.fg)('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $cXtTj.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null),
            armId: statsigOverrideExperiment.get('armId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment
    };
};
const $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a = ({ primaryProduct: primaryProduct, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError, getLayerValuesFn: getLayerValuesFn })=>{
    const { frontendExperiment: frontendExperiment, backendExperiment: backendExperiment } = $8b075a34b0dc6cb8$export$42e21c9a86f72c4f(sideBySideExperiment, statsigLayer, onError, true, getLayerValuesFn);
    // This experiment can be alternated between mutually exclusive or not.
    const multiSiteSearchInRovoExperiment = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    });
    const multiSiteSearchCohort = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct,
        fireExperimentExposure: false
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiments: {
            // the frontend experiment that's mutually exclusive to other BE and FE experiments
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            // NOTE: these aren't mutually exclusive to other BE or FE experiments
            [multiSiteSearchInRovoExperiment.abTestId]: multiSiteSearchInRovoExperiment,
            rovo_fps_multi_site_search_exp: {
                abTestId: 'rovo_fps_multi_site_search_exp',
                cohort: multiSiteSearchCohort,
                serveExperiment: multiSiteSearchCohort !== 'control'
            }
        },
        dynamicExperiments: (0, $cc6x1.dynamicExperimentsSchema).safeParse(experimentLayers ?? []).data
    };
};
const $8b075a34b0dc6cb8$export$b9e6179ff71a6122 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { primaryProduct: primaryProduct, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError } = t0;
    let t1;
    if ($[0] !== experimentLayers || $[1] !== onError || $[2] !== primaryProduct || $[3] !== sideBySideExperiment || $[4] !== statsigLayer) {
        t1 = $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a({
            primaryProduct: primaryProduct,
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        });
        $[0] = experimentLayers;
        $[1] = onError;
        $[2] = primaryProduct;
        $[3] = sideBySideExperiment;
        $[4] = statsigLayer;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ primaryProduct: primaryProduct, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError })=>{
    return (0, $cozmU.useMemo)(()=>$8b075a34b0dc6cb8$export$dd0548ef3fdfe45a({
            primaryProduct: primaryProduct,
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        }), [
        primaryProduct,
        experimentLayers,
        sideBySideExperiment,
        onError,
        statsigLayer
    ]);
};
module.exports["getMutuallyExclusiveExperiment"] = $8b075a34b0dc6cb8$export$fd4704975f80304e;
module.exports["getExperimentConfig"] = $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a;
module.exports["useExperimentConfig"] = $8b075a34b0dc6cb8$export$b9e6179ff71a6122;

});

parcelRegister("4ysB6", function(module, exports) {

var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");

const $9de4c4eec0b45ac2$export$62fed45313a13eff = 'universalTypeFilter';
const $9de4c4eec0b45ac2$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $9de4c4eec0b45ac2$export$62fed45313a13eff,
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'owner',
    'opportunityStatus',
    'campaignStatus',
    'caseStatus',
    'documentStatus',
    'calendarType',
    'leadStatus',
    'taskStatus',
    'taskType',
    'closeDate',
    'focusAreaType',
    'focusAreaUnder',
    'assignee',
    'reporter',
    'project',
    'content',
    'label',
    'tag',
    'folder',
    'pageStatus',
    'verified',
    'onlyTitleMatch',
    'archived',
    'statusFilter',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'watchedByMe',
    'positionFocusArea',
    'positionStatus',
    'positionJobFamily',
    'positionTeam',
    'commentedByMe',
    'positionEmploymentType',
    'salesforceStage',
    'repository',
    'reviewer',
    'pullRequestStatus',
    'slackChannel',
    'workspaceName',
    'hasAttachment'
];
const $9de4c4eec0b45ac2$export$1fd3303b0f1dd4fb = ()=>{
    return $9de4c4eec0b45ac2$export$64f2f70bb9f8e772.filter((filterId)=>{
        if ((filterId === 'tag' || filterId === 'folder') && !(0, $iDrrr.fg)('loom-rovo-search')) return false;
        if (filterId === 'workspaceName' && !(0, $iDrrr.fg)('rovo_fps_show_workspace_name_filter')) return false;
        return true;
    });
};
const $9de4c4eec0b45ac2$export$2c1f2e526d05c6ca = 'search-page-hidden-filters-v2';
const $9de4c4eec0b45ac2$export$b6072f70c84313e0 = ()=>{
    return $9de4c4eec0b45ac2$export$2c1f2e526d05c6ca;
};
const $9de4c4eec0b45ac2$export$66f51a64560a2aea = 'rovo_fps_exclude_assets_from_all_products';
const $9de4c4eec0b45ac2$var$shouldExcludeAssetsFromAllFilter = ({ experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE, primaryProduct: primaryProduct })=>experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE && primaryProduct !== (0, $dvVWp.ProductKeys).Assets && (0, $cha5E.expVal)($9de4c4eec0b45ac2$export$66f51a64560a2aea, 'isEnabled', false);
const $9de4c4eec0b45ac2$export$6c2878d515cb8e84 = (context = {})=>{
    const isFederatedSearchEnabled = (0, $cha5E.expVal)('fed_search_results_in_conf_fps', 'isEnabled', false);
    const excludedProducts = isFederatedSearchEnabled ? [
        (0, $dvVWp.ProductKeys).Trello
    ] : [
        (0, $dvVWp.ProductKeys).Trello,
        (0, $dvVWp.ProductKeys).Gmail,
        (0, $dvVWp.ProductKeys).OutlookMail
    ];
    if ($9de4c4eec0b45ac2$var$shouldExcludeAssetsFromAllFilter(context)) excludedProducts.push((0, $dvVWp.ProductKeys).Assets);
    return excludedProducts;
};
const $9de4c4eec0b45ac2$export$86f74b36cf553a49 = (excludedProducts)=>excludedProducts.includes((0, $dvVWp.ProductKeys).Assets) ? [
        'ati:cloud:cmdb:object',
        'ati:cloud:cmdb:schema',
        'ati:cloud:cmdb:type'
    ] : [];
module.exports["universalTypeFilterId"] = $9de4c4eec0b45ac2$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $9de4c4eec0b45ac2$export$1fd3303b0f1dd4fb;
module.exports["getSearchPageFilterConfigKey"] = $9de4c4eec0b45ac2$export$b6072f70c84313e0;
module.exports["getAllFilterExcludedProducts"] = $9de4c4eec0b45ac2$export$6c2878d515cb8e84;
module.exports["getAllFilterExcludedEntities"] = $9de4c4eec0b45ac2$export$86f74b36cf553a49;

});

parcelRegister("9pcjO", function(module, exports) {
const $b4698b95fb92ddf1$export$81f65d0c79fe28b4 = {
    QUICK_FIND: 'quick-find',
    SEARCH_PAGE: 'search-page'
};
module.exports["SearchExperience"] = $b4698b95fb92ddf1$export$81f65d0c79fe28b4;

});

parcelRegister("9NmsO", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");





var $aqAfG = parcelRequire("aqAfG");


var $aoy1P = parcelRequire("aoy1P");




const $282b3c72875f64ab$export$6702bcb53d02902a = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $aqAfG.ProductKeys1P).Talent]: (0, $iDrrr.fg)('talent_global_search'),
        [(0, $aqAfG.ProductKeys1P).CustomerServiceManagement]: (0, $iDrrr.fg)('csm_product_filter_in_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.includes(productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $aqAfG.ProductKeys1P).JiraServiceManagement) && (0, $iDrrr.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $iDrrr.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $aqAfG.ProductKeys1P).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};



var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $94b8c9fa1b18d88d$export$b38c0215344366f7 = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    // Facade: when rovo_fps_use_rovo_config is enabled, delegate to the
    // canonical implementation in @atlassian/rovo-connectors-config so that
    // search-page and other consumers share a single source of truth.
    // When disabled, fall through to the inline legacy implementation below.
    if ((0, $iDrrr.fg)('rovo_fps_use_rovo_config')) return (0, $282b3c72875f64ab$export$6702bcb53d02902a)({
        supportedProducts: supportedProducts,
        products: products,
        accessibleProducts: accessibleProducts
    });
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $dvVWp.ProductKeys).Talent]: (0, $iDrrr.fg)('talent_global_search'),
        [(0, $dvVWp.ProductKeys).CustomerServiceManagement]: (0, $iDrrr.fg)('csm_product_filter_in_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.find((featureGatedProduct)=>featureGatedProduct === productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $8fNUp.isForgeConnectorProductKey)(productKey)) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $dvVWp.ProductKeys).JiraServiceManagement) && (0, $iDrrr.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $iDrrr.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $dvVWp.ProductKeys).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getAccessibleProducts"] = $94b8c9fa1b18d88d$export$b38c0215344366f7;

});

parcelRegister("eD8r5", function(module, exports) {

var $3X0xX = parcelRequire("3X0xX");


var $cFPRS = parcelRequire("cFPRS");

const $5a252b1cbebb706f$export$f86b2a1a2ce291b3 = async (error, userId, primaryProduct)=>{
    try {
        const SentryClient = await (0, $cFPRS.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $3X0xX.COMMON_TAGS)))scope.setTag(key, value);
            scope.setUser({
                id: userId || (0, $3X0xX.UNKNOWN_TAG)
            });
            scope.setTag('product', primaryProduct || (0, $3X0xX.UNKNOWN_TAG));
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
module.exports["logException"] = $5a252b1cbebb706f$export$f86b2a1a2ce291b3;

});

parcelRegister("4BJ6s", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $69f0b6cf42752fd8$export$1a5e9086021cdce5 = ()=>{
    // This FG is used to force enable the context store code path for e2e testing purposes
    if ((0, $iDrrr.fg)('rovo-search-remove-rss-bootstrap-fg')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo-search-remove-rss-bootstrap-exp', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
module.exports["serveBootstrapProviderExp"] = $69f0b6cf42752fd8$export$1a5e9086021cdce5;

});

parcelRegister("1i979", function(module, exports) {

var $jg98Q = parcelRequire("jg98Q");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $51pfw = parcelRequire("51pfw");


var $imUxN = parcelRequire("imUxN");


var $3yJeH = parcelRequire("3yJeH");


var $1Qme9 = parcelRequire("1Qme9");


var $6yu7A = parcelRequire("6yu7A");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");

// Anything unmapped (Home, other 1P apps, every connector) gets no inline filters.
const $b7c49ef11e2d0611$var$INLINE_FILTER_IDS_BY_PRODUCT = {
    [(0, $dvVWp.ProductKeys).Confluence]: [
        'space'
    ],
    [(0, $dvVWp.ProductKeys).Jira]: [
        'project'
    ]
};
const $b7c49ef11e2d0611$export$c119cca36ac9a52c = (selectedProduct, primaryProduct)=>{
    const product = selectedProduct ?? primaryProduct;
    if (!product) return [];
    return $b7c49ef11e2d0611$var$INLINE_FILTER_IDS_BY_PRODUCT[product] ?? [];
};



var $e0v3Z = parcelRequire("e0v3Z");

const $0023915a6e6a3533$export$51e3c005021600c8 = new Set([
    'label',
    'tag'
]);
const $0023915a6e6a3533$export$388d8f84295a9ea5 = (filterId)=>$0023915a6e6a3533$export$51e3c005021600c8.has(filterId);
const $0023915a6e6a3533$export$931e138580bca877 = (filterId, value)=>$0023915a6e6a3533$export$388d8f84295a9ea5(filterId) ? (0, $e0v3Z.sha256Hash)(value) : value;



var $7ydfN = parcelRequire("7ydfN");





var $lDiEy = parcelRequire("lDiEy");


var $8fNUp = parcelRequire("8fNUp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $35JNe = parcelRequire("35JNe");

class $c59181be2ffd57d8$export$8ba86dff7c04c14c extends (0, $35JNe.ResultsFetchError) {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}



var $fR63l = parcelRequire("fR63l");




const $201f44e4b1c735f8$export$94d61914de4d5edf = [
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Slack,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Conversation
            ]
        ],
        hiddenFilters: [
            'lastUpdated',
            'contributor'
        ]
    }
];








const $ff46216cbb528f97$export$5a7e3222966d6cdd = [
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Deal
            ]
        ],
        shownFilters: [
            'salesforceStage',
            'opportunityStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Case
            ]
        ],
        shownFilters: [
            'caseStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Campaign
            ]
        ],
        shownFilters: [
            'campaignStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Document
            ]
        ],
        shownFilters: [
            'documentStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Calendar
            ]
        ],
        shownFilters: [
            'calendarType'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Lead
            ]
        ],
        shownFilters: [
            'leadStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).WorkItem
            ]
        ],
        shownFilters: [
            'taskStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).WorkItem
            ]
        ],
        shownFilters: [
            'taskType'
        ]
    }
];


/**
 * Extracts the selected values for a given filter from the store's filters map.
 * Select filters store values as `value: string[]`; boolean and other filter
 * types are not expected to appear in rules and return an empty array.
 */ const $4abb27497bf1f895$var$getFilterValues = (filters, filterId)=>{
    const filter = filters[filterId];
    if (filter && 'value' in filter && Array.isArray(filter.value)) return filter.value;
    return [];
};
const $4abb27497bf1f895$export$8848759bd942e213 = (selectedProduct, filters, exclusionRules = (0, $201f44e4b1c735f8$export$94d61914de4d5edf), inclusionRules = (0, $ff46216cbb528f97$export$5a7e3222966d6cdd))=>{
    const excluded = new Set();
    // ── Exclusion rules: hide filters when conditions ARE met ──
    for (const rule of exclusionRules){
        // Check product condition (if specified)
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        // Check all filter selection conditions (AND logic — all must match)
        const allFiltersMatch = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $4abb27497bf1f895$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allFiltersMatch) rule.hiddenFilters.forEach((f)=>{
            // Never hide a filter that currently has active selections — the user
            // may have chosen a value before the exclusion rule activated and the
            // selection is still valid.
            const filterValues = $4abb27497bf1f895$var$getFilterValues(filters, f);
            if (filterValues.length === 0) excluded.add(f);
        });
    }
    // ── Inclusion rules: hide filters when conditions are NOT met ──
    // Step 1: Collect all filter IDs managed by inclusion rules and track which
    // condition filter IDs each managed filter depends on.
    const managedFilters = new Set();
    const satisfiedFilters = new Set();
    const conditionFiltersPerManaged = new Map();
    for (const rule of inclusionRules){
        // Check product condition first — skip rules for other products entirely
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        rule.shownFilters.forEach((f)=>{
            managedFilters.add(f);
            if (!conditionFiltersPerManaged.has(f)) conditionFiltersPerManaged.set(f, new Set());
            rule.selectedFilters.forEach(([filterId])=>conditionFiltersPerManaged.get(f).add(filterId));
        });
        // Check if this rule's conditions are all met
        const allConditionsMet = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $4abb27497bf1f895$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allConditionsMet) rule.shownFilters.forEach((f)=>satisfiedFilters.add(f));
    }
    // Step 2: For each inclusion-managed filter, hide it if:
    // - No inclusion rule matched (filter not satisfied), AND
    // - At least one condition filter has an active selection (the user has made
    //   a choice that makes the filter irrelevant). If no condition filter has a
    //   value yet (e.g. "All" mode), leave the filter visible — don't hide it
    //   prematurely before the user has picked a type.
    for (const filterId of managedFilters)if (!satisfiedFilters.has(filterId)) {
        const conditionFilterIds = conditionFiltersPerManaged.get(filterId) ?? new Set();
        const anyConditionFilterHasValue = [
            ...conditionFilterIds
        ].some((cfId)=>$4abb27497bf1f895$var$getFilterValues(filters, cfId).length > 0);
        if (anyConditionFilterHasValue) // A condition filter has a selection but it doesn't match any rule —
        // hide the managed filter. Unlike exclusion rules, inclusion rules hide
        // even when the managed filter has active selections — the store-level
        // `setSearchStoreState` will clear those selections separately so the
        // store stays in sync with what is applied.
        excluded.add(filterId);
    }
    return excluded;
};



var $ceA8V = parcelRequire("ceA8V");


var $c3cgJ = parcelRequire("c3cgJ");


var $biQM6 = parcelRequire("biQM6");


var $hnDqW = parcelRequire("hnDqW");


var $6Vsfx = parcelRequire("6Vsfx");


var $c3mkK = parcelRequire("c3mkK");


var $jbIQp = parcelRequire("jbIQp");


var $8JYuM = parcelRequire("8JYuM");


var $ieiUX = parcelRequire("ieiUX");


var $fuajF = parcelRequire("fuajF");

const $2b1419bc2c84719c$export$d4c72bab9d6cc13a = {
    abTest: undefined,
    cql: undefined,
    autoCorrection: undefined,
    product: undefined,
    requestId: undefined,
    traceId: undefined,
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    originalQuery: undefined,
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    selectedDatasource: undefined,
    availableProducts: [],
    availableProductsForSelectedSites: [],
    allFilterExcludedProducts: [],
    jsmIncidentFilterIds: [],
    // Rest of store states
    resultsSort: {
        field: 'relevance',
        order: 'DESC'
    },
    retryCount: 0,
    queryVersion: 0,
    queryUpdatedTime: undefined,
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false,
    leapQuery: {
        loading: false,
        candidates: [],
        titleIndex: 0
    },
    requestedBackendExperiments: undefined,
    filterDropdownOpenByQueryParam: false,
    experience: (0, $9pcjO.SearchExperience).SEARCH_PAGE,
    wasContentClearedBySpaceChange: false
};
const $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
const $2b1419bc2c84719c$var$getAvailableProductsForSelectedCloudIdsFromConfig = ({ availableProducts: availableProducts, config: config })=>(0, $6Vsfx.getAvailableProductsForSelectedCloudIds)({
        availableProducts: availableProducts,
        selectedCloudIds: config.selectedCloudIds,
        unitMetadata: config.unitMetadata
    });
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $2b1419bc2c84719c$var$safeStateKeys = [
    'filterSelectionOrder',
    'resultsSort',
    'retryCount',
    'selectedDatasource',
    'wasContentClearedBySpaceChange'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $2b1419bc2c84719c$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, queryParams: currentQueryParams })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState({
                ...newState,
                availableProducts: availableProducts
            });
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$2b1419bc2c84719c$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery, filterDropdownOpenByQueryParam: filterDropdownOpenByQueryParam } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: allFilterStates } = {
            ...getState(),
            ...newState
        };
        // Compute excluded filters via FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES (e.g.
        // salesforceStage when type≠deal). Excluded filters do NOT contribute to URL params
        // or the GraphQL query. This is the single source of truth for filter visibility;
        // UI selectors (useFiltersToDisplay, useSelectedFilterCount) apply the same exclusion.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], allFilterStates);
        const staticFilters = Object.values(allFilters).filter((f)=>{
            if (excludedFilterIds.has(f.id)) return false;
            const filterState = f.getInitialState(config).getState();
            const isSuggestedFilter = f.isSuggestedFilter?.(primaryProduct);
            return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? filterState.universal || isSuggestedFilter // When there are no selected products, only universal and suggested filters are persisted in state
             : // Forge connectors are registered dynamically and not in filterState.products, so check them separately
            filterState.universal && selectedProducts.some((0, $8fNUp.isForgeConnectorProductKey)) || filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState?.id)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        // If overrides is already an object (parsed), convert it back to JSON string for parseQueryParams
        const overridesToPreserve = currentQueryParams?.overrides && enableRovoSearchOverrides ? typeof currentQueryParams.overrides === 'string' ? currentQueryParams.overrides : encodeURIComponent(JSON.stringify(currentQueryParams.overrides)) : undefined;
        const paramsToPassToParse = {
            product: selectedProducts[0],
            datasource: selectedDatasource?.datasourceId,
            text: text !== '' ? text : undefined,
            filterDropdownOpen: filterDropdownOpenByQueryParam || undefined,
            ...filterQueryParams,
            ...(0, $hnDqW.canContinueRovoJourney)(primaryProduct) && {
                rovoJourneyId: (0, $hnDqW.normalizeRovoJourneyId)(currentQueryParams?.rovoJourneyId)
            },
            // Preserve overrides from current query params if enable-rovo_search_overrides is enabled
            ...overridesToPreserve && {
                overrides: overridesToPreserve
            }
        };
        const parsedQueryParams = (0, $biQM6.parseQueryParams)(paramsToPassToParse, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $2b1419bc2c84719c$export$f14fed79ef571627 = $2b1419bc2c84719c$var$setSearchStoreState;
const $2b1419bc2c84719c$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $ieiUX.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set((0, $biQM6.convertQueryParamsToStringArray)(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: filterStates,
                selectedProducts: selectedProducts,
                selectedDatasource: (0, $biQM6.getDatasourceFromId)(queryParams.datasource?.toString(), selectedProducts[0], thirdPartyConfigs),
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen),
                availableProducts: availableProducts,
                availableProductsForSelectedSites: $2b1419bc2c84719c$var$getAvailableProductsForSelectedCloudIdsFromConfig({
                    availableProducts: availableProducts,
                    config: config
                }),
                allFilterExcludedProducts: allFilterExcludedProducts,
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            }, {
                updateQueryParams: false // onInit should not update the query params
            }));
        },
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { filters: filterStates } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $ieiUX.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = (0, $biQM6.convertQueryParamsToStringArray)(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState?.id)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: resolvedFilterStates } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            const { getFiltersWithSelection: getFiltersWithSelection } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, resolvedFilterStates);
            getFiltersWithSelection().forEach((filterId)=>{
                filterSelectionOrder = $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const querySelectedProducts = getSelectedProducts(queryParams);
            const selectedDatasource = (0, $biQM6.getDatasourceFromId)(queryParams.datasource?.toString(), querySelectedProducts[0], thirdPartyConfigs);
            const nextStateSync = {
                filters: resolvedFilterStates,
                selectedProducts: querySelectedProducts,
                selectedDatasource: selectedDatasource,
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen),
                availableProducts: availableProducts,
                availableProductsForSelectedSites: $2b1419bc2c84719c$var$getAvailableProductsForSelectedCloudIdsFromConfig({
                    availableProducts: availableProducts,
                    config: config
                }),
                paginationTokens: [],
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            };
            const stateBeforeSync = getState();
            const prevStateSyncComparable = {
                filters: stateBeforeSync.filters,
                selectedProducts: stateBeforeSync.selectedProducts,
                selectedDatasource: stateBeforeSync.selectedDatasource,
                filterSelectionOrder: stateBeforeSync.filterSelectionOrder,
                inputQuery: stateBeforeSync.inputQuery,
                searchQuery: stateBeforeSync.searchQuery,
                originalQuery: stateBeforeSync.originalQuery,
                filterDropdownOpenByQueryParam: stateBeforeSync.filterDropdownOpenByQueryParam,
                availableProducts: stateBeforeSync.availableProducts,
                availableProductsForSelectedSites: stateBeforeSync.availableProductsForSelectedSites,
                paginationTokens: stateBeforeSync.paginationTokens,
                cql: stateBeforeSync.cql,
                primaryProduct: stateBeforeSync.primaryProduct,
                experience: stateBeforeSync.experience
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(prevStateSyncComparable, nextStateSync)) dispatch($2b1419bc2c84719c$var$setSearchStoreState(nextStateSync, {
                updateQueryParams: false
            } // onUpdate lifecycle should never update the query params
            ));
        },
    setFilter: (state, options)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            // Get the static filter definition
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(staticFilter.id)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                },
                ...options?.setSelectedProduct ? {
                    selectedProducts: [
                        options?.setSelectedProduct
                    ]
                } : {}
            }, {
                updateQueryParams: options?.shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        },
    setNewFilterStates: (newFilterStates, setSelectedProduct, filterSelectionOrder)=>async ({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: newFilterStates,
                ...setSelectedProduct !== undefined && {
                    selectedProducts: [
                        setSelectedProduct
                    ]
                },
                ...filterSelectionOrder && {
                    filterSelectionOrder: filterSelectionOrder
                }
            }, {
                updateQueryParams: false
            }));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({}, {
                updateQueryParams: true
            }));
        }
};
function $2b1419bc2c84719c$var$hasLoadInitialOptions(filter) {
    return typeof filter === 'object' && filter !== null && 'loadInitialOptions' in filter && typeof filter.loadInitialOptions === 'function' && 'getState' in filter && typeof filter.getState === 'function';
}
// Shared by explicit clear and parent-selection changes. The caller validates the filter type.
const $2b1419bc2c84719c$var$resetDependentSelectFilter = (filter, state, config)=>{
    const clearedState = filter.withState(state, config).clear().getState();
    if (!state) return clearedState;
    const selectState = clearedState;
    return {
        ...selectState,
        didMountPerProducts: {},
        initialOptions: {
            ...selectState.initialOptions,
            options: [],
            isLoading: false
        },
        lookup: {
            ...selectState.lookup,
            options: [],
            lookupResultOptions: [],
            input: '',
            isLoading: false,
            isActive: false
        }
    };
};
const $2b1419bc2c84719c$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config, thirdPartyConfigs: thirdPartyConfigs })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: stateSelectedDatasource, selectedProducts: selectedProducts } = getState();
            // When selectedDatasource is not set (e.g. no `datasource=` URL param was present),
            // derive it from thirdPartyConfigs using the selected product. This allows filters
            // that need a datasourceId (e.g. salesforceStage dynamic stage options) to fetch
            // correctly even when the datasource was not explicitly set via URL.
            //
            // Some dynamic 3P filters (those declaring `requiresTopLevel3PDatasource: true` —
            // today: salesforceStage, campaignStatus, caseStatus) read from the top-level
            // thirdPartyConfigs entry directly because it always carries a datasourceId, whereas
            // .datasources?.[0] may only be populated in multi-domain configurations.
            const shouldUseTopLevel3PDatasource = 'requiresTopLevel3PDatasource' in staticSelectFilter && !!staticSelectFilter.requiresTopLevel3PDatasource;
            const selectedDatasource = stateSelectedDatasource ?? (selectedProducts[0] ? shouldUseTopLevel3PDatasource ? thirdPartyConfigs?.[selectedProducts[0]] : thirdPartyConfigs?.[selectedProducts[0]]?.datasources?.[0] : undefined);
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            // Race-condition guard: dynamic 3P filters require a resolved datasource to
            // fetch their option list. If the bootstrap config hasn't loaded yet,
            // `thirdPartyConfigs` is empty and `selectedDatasource` is undefined — in
            // which case calling `loadInitialOptions` would mark this product as loaded
            // with an empty result and the filter would never retry. Skip the call so the
            // caller (UI effect) can re-trigger once the datasource arrives.
            if (shouldUseTopLevel3PDatasource && !selectedDatasource) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                // overriding the intl in config to fix a race condition with initial options and outdated translation messages
                intl: props.intl,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const newFilter = staticSelectFilter.withState(filterState, extendedConfig);
            if ($2b1419bc2c84719c$var$hasLoadInitialOptions(newFilter)) await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            if (props.dependentFilterId && props.dependentFilterId !== props.filterId) {
                const dependentFilter = allFilters[props.dependentFilterId];
                const dependentState = allFiltersState[props.dependentFilterId];
                if (dependentFilter?.isCompatible(dependentState?.id) && (0, $jbIQp.isSelectFilter)(dependentFilter.type)) {
                    dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter($2b1419bc2c84719c$var$resetDependentSelectFilter(dependentFilter, dependentState, config), {
                        shouldSetQueryParams: false
                    }));
                    dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(props.dependentFilterId, false));
                }
            }
            dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true
            }));
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    /**
   * Sets a select filter option.
   *
   * @param validateDependentFilterId - If provided, validates if the dependent filter's containerARI
   *                                    is still in the new selection values and clears it if not.
   */ setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const filterWithState = staticSelectFilter.withState(filterState, config);
            if (!('setOption' in filterWithState)) return;
            const newFilterState = filterWithState.setOption(props.optionChange, props.options?.customValue).getState();
            if (props.filterId === (0, $4ysB6.universalTypeFilterId)) {
                const { selectedProducts: selectedProducts } = getState();
                const hasWebPageSelected = newFilterState.hasSelection && newFilterState.value?.includes((0, $7ydfN.TypeFilterValueKey).WebPage);
                if (hasWebPageSelected) {
                    // When web-page type is selected, use the same logic as clicking the noun in the right panel to select the product = AtlassianWebCrawler
                    dispatch($2b1419bc2c84719c$export$e324594224ef24da.unsafe_setWebPageType());
                    return;
                }
                if (!newFilterState.hasSelection && selectedProducts?.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler)) {
                    // Clear the product since type filter has been cleared. This will also clear the type filter
                    // and update filter selection order through selectProductFilter's existing logic
                    dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                        productResultCountMap: null
                    }));
                    dispatch($2b1419bc2c84719c$export$e324594224ef24da.selectProductFilter());
                    return;
                }
            }
            // When the contributor selection changes, the cached `initialOptions` (suggested values
            // shown when a dependent dropdown is opened without typing) on contributor-scoped
            // filters becomes stale: the base select filter short-circuits `loadInitialOptions`
            // when the current product is marked as loaded, so the dropdown keeps showing
            // pre-contributor suggestions until the user actually types. Reset
            // `didMountPerProducts` and clear `initialOptions.options` on each contributor-scoped
            // dependent filter so the next dropdown open re-fetches with the new contributor
            // scope.
            if (props.filterId === 'contributor') {
                const previousValue = Array.isArray(filterState?.value) ? filterState.value : [];
                const nextValue = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                const contributorSelectionChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))([
                    ...previousValue
                ].sort(), [
                    ...nextValue
                ].sort());
                if (contributorSelectionChanged) {
                    const contributorScopedDependents = [
                        'content'
                    ];
                    contributorScopedDependents.forEach((dependentId)=>{
                        const dependentStaticFilter = allFilters[dependentId];
                        const dependentFilterState = allFiltersState[dependentId];
                        if (!dependentStaticFilter || !dependentStaticFilter.isCompatible(dependentFilterState?.id) || !(0, $jbIQp.isSelectFilter)(dependentStaticFilter.type)) return;
                        const dependentSelectFilterState = dependentFilterState;
                        if (!dependentSelectFilterState) return;
                        const resetDependentState = {
                            ...dependentSelectFilterState,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            }
                        };
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                    });
                }
            }
            // Validate dependent filter if specified (e.g., clear content filter when space changes)
            const dependentFilterId = props.options?.validateDependentFilterId;
            let wasContentCleared = false;
            if (dependentFilterId) {
                const dependentStaticFilter = allFilters[dependentFilterId];
                const dependentFilterState = allFiltersState[dependentFilterId];
                if (dependentStaticFilter?.isCompatible(dependentFilterState?.id) && (0, $jbIQp.isSelectFilter)(dependentStaticFilter.type)) {
                    // Get new values from the updated filter state
                    const newValues = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                    const { selectedProducts: selectedProducts } = getState();
                    const shouldResetLoomFolderWhenSpaceCleared = dependentFilterId === (0, $8JYuM.folderFilterId) && selectedProducts[0] === (0, $dvVWp.ProductKeys).Loom && newValues.length === 0 && (0, $iDrrr.fg)('loom-rovo-search');
                    // Clear the dependent filter whenever the primary filter is explicitly set to a
                    // non-empty selection. Reset the per-product loaded state and clear cached
                    // initialOptions so the next dropdown open re-fetches dependent suggestions
                    // scoped to the new primary selection
                    // instead of showing stale options from the previous selection.
                    // Loom: also reset folder when all spaces are deselected (Drive→content keeps
                    // content when space is empty).
                    if (newValues.length > 0 || shouldResetLoomFolderWhenSpaceCleared) {
                        const resetDependentState = $2b1419bc2c84719c$var$resetDependentSelectFilter(dependentStaticFilter, dependentFilterState, config);
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(dependentFilterId, false));
                        wasContentCleared = true;
                    }
                }
            }
            dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            // NOTE: Inclusion-rule-driven filters (e.g. salesforceStage when type≠deal) are
            // handled as a derived projection in setSearchStoreState (URL/GraphQL builder),
            // useFiltersToDisplay (UI), and useSelectedFilterCount (badge). Stale selections
            // for excluded filters are cleared by setSearchStoreState in the same write so
            // the store stays in sync with what is visible/applied. No imperative clear is
            // needed here.
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null,
                wasContentClearedBySpaceChange: wasContentCleared
            }));
        },
    setAutoFilters: (filters)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const newFilterStates = {};
            await Promise.all(filters.map(async (filterConfig)=>{
                const staticSelectFilter = allFilters[filterConfig.filterId];
                const filterState = allFilterStates[filterConfig.filterId];
                // We should not automatically apply the filter if it has already been selected
                if (filterState?.hasSelection) return;
                if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
                const filterWithState = staticSelectFilter.withState(filterState, config);
                if (!('setOption' in filterWithState)) return;
                const optionsToChange = Array.isArray(filterConfig.optionChange) ? filterConfig.optionChange : [
                    filterConfig.optionChange
                ];
                const selectedOptions = optionsToChange.filter((o)=>o.isSelected);
                if (selectedOptions.length === 0) return;
                // Build query params object with the filter's key
                const queryParamsKey = staticSelectFilter.queryParams.key;
                const queryParams = {
                    [queryParamsKey]: selectedOptions.map((o)=>o.value)
                };
                // Add custom value fields if provided
                if (filterConfig.options?.customValue) Object.entries(filterConfig.options.customValue).forEach(([key, value])=>{
                    queryParams[key] = [
                        value
                    ];
                });
                // Use queryParams.set which handles option hydration via fetcher
                const hydratedFilter = await filterWithState.queryParams.set(queryParams);
                newFilterStates[filterConfig.filterId] = hydratedFilter.getState();
            }));
            if (Object.keys(newFilterStates).length > 0) {
                const { filterSelectionOrder: currentOrder } = getState();
                // Add new auto-applied filters to the order
                const updatedOrder = Object.keys(newFilterStates).reduce((order, filterId)=>$2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(order, filterId, newFilterStates[filterId]?.hasSelection), currentOrder);
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setNewFilterStates({
                    ...allFilterStates,
                    ...newFilterStates
                }, undefined, updatedOrder));
            }
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: selectedDatasource } = getState();
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const filterWithState = staticSelectFilter.withState(filterState, extendedConfig);
            if ('setLookupInput' in filterWithState) await filterWithState.setLookupInput(props.query, (stateChange)=>{
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $2b1419bc2c84719c$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState?.id)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            const clearedFilters = $2b1419bc2c84719c$var$clearFilters(allFilterStates, staticFilters, config);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: clearedFilters,
                selectedProducts: [],
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: $2b1419bc2c84719c$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey, datasource)=>({ getState: getState, dispatch: dispatch }, { thirdPartyConfigs: thirdPartyConfigs, allFilters: allFilters, config: config })=>{
            const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            // Convert string datasource to object if needed for consistency
            const datasourceObject = typeof datasource === 'string' ? (0, $biQM6.getDatasourceFromId)(datasource, productKey, thirdPartyConfigs) : datasource;
            // Only return early if both product and datasource are the same
            if (productKey && selectedProducts.includes(productKey) && datasourceObject?.datasourceId === selectedDatasource?.datasourceId) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey) || // Universal filters should always be persisted for forge connectors
                productKey && (0, $8fNUp.isForgeConnectorProductKey)(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $dvVWp.ProductKeys).Atlas)) delete persistedFilters[0, $4ysB6.universalTypeFilterId];
            const newSelectedProducts = productKey ? [
                productKey
            ] : [];
            // Clear web-page type filter when navigating away from Web Pages
            const currentTypeFilter = filters[0, $4ysB6.universalTypeFilterId];
            const isWebPageTypeSelected = currentTypeFilter?.type === 'single-select' && currentTypeFilter?.value?.includes((0, $7ydfN.TypeFilterValueKey).WebPage);
            if (isWebPageTypeSelected) // When user clicks "All" or selects any product, clear the web-page type
            delete persistedFilters[0, $4ysB6.universalTypeFilterId];
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                selectedProducts: newSelectedProducts,
                selectedDatasource: datasourceObject,
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $2b1419bc2c84719c$export$d4c72bab9d6cc13a.resultsSort,
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    unselectProductFilter: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null,
                wasContentClearedBySpaceChange: false
            }));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    // Sorting actions
    setSortField: (sortField)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    field: sortField
                },
                paginationTokens: []
            }));
        },
    setSortOrder: (sortOrder)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    order: sortOrder
                },
                paginationTokens: []
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: $2b1419bc2c84719c$export$d4c72bab9d6cc13a.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    resetQueryVersion: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                queryVersion: 0
            }));
        },
    incrementQueryVersion: ()=>({ getState: getState, setState: setState })=>{
            const { queryVersion: queryVersion } = getState();
            setState({
                queryVersion: queryVersion + 1
            });
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId, traceId)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId,
                traceId: traceId,
                wasContentClearedBySpaceChange: false
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                // TODO: fix colorName being passed twice with inconsistent values, see the unit test for context
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $imUxN.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) {
                            edge.node.status.name = hydratedIssue.statusField.status.name;
                            edge.node.status.colorName = hydratedIssue.statusField.status.statusCategory?.colorName;
                        }
                    }
                    return edge;
                });
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $51pfw.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $c3mkK.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined,
                wasContentClearedBySpaceChange: false
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setLeapQuery: ({ candidates: candidates, titleIndex: titleIndex, loading: loading })=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                leapQuery: {
                    loading: loading,
                    candidates: candidates,
                    titleIndex: titleIndex
                }
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { filters: filterStates, availableProducts: availableProducts, productResultCountMap: oldProductResultCountMap } = getState();
            const filtersWithSelection = Object.values(filterStates).filter((filter)=>filter?.hasSelection);
            const productsCorrespondingToAllSelectedFilters = filtersWithSelection.length ? availableProducts.filter((product)=>filtersWithSelection.every((filter)=>filter?.products?.includes(product))) : availableProducts;
            const resultsCountsAdjustedForSelectedFilters = totalCounts.map((resultCount)=>{
                if (productsCorrespondingToAllSelectedFilters.includes(resultCount.product)) return resultCount;
                else return {
                    ...resultCount,
                    count: 0
                };
            });
            const productResultCountMap = resultsCountsAdjustedForSelectedFilters.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$export$e324594224ef24da.clearAllFilters());
        },
    /**
   * TODO: QS-9329: Persist auto-applied filters when selecting
   * * Projects (type=project & product=townsquare)
   * * Goals (type=goal & product=townsquare)
   * in the right rail.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Considered unsafe since it's using queryParams to change the state.
   * Ideally we should set it directly in the state, but that requires introducing a new action.
   * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
   * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
   *
   * We hope to improve Atlassian Home / global noun handling after GA
   *
   * The last modified and contributors filters are explicitly kept in the query params because they are universal.
   * Type is also a universal filter, but we couple the type with the product to determine which Townsquare results to show.
   *
   * @param value: a noun to be set
   */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams, primaryProduct: primaryProduct })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: _, type: __, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
                // We explicitly only keep text, last modified and contributors
                setQueryParams({
                    product: (0, $dvVWp.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified,
                    contributors: contributors,
                    ...(0, $hnDqW.canContinueRovoJourney)(primaryProduct) && {
                        rovoJourneyId: (0, $hnDqW.normalizeRovoJourneyId)(queryParams.rovoJourneyId)
                    }
                });
            }
        },
    /**
   * * TODO: QS-9329: Persist auto-applied filters when selecting
   * Web Pages (type=web-page & product=atlassian-web-crawler) in the right rail
   * or type=web-page in horizontal filters.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Similar to unsafe_setAtlasNouns, this directly manipulates URL query params
   * to set the Type filter to "web-page".
   */ unsafe_setWebPageType: ()=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams, primaryProduct: primaryProduct })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
            const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
            setQueryParams({
                product: (0, $dvVWp.ProductKeys).AtlassianWebCrawler,
                type: (0, $7ydfN.TypeFilterValueKey).WebPage,
                text: text,
                originalQuery: originalQuery,
                lastModified: lastModified,
                contributors: contributors,
                ...(0, $hnDqW.canContinueRovoJourney)(primaryProduct) && {
                    rovoJourneyId: (0, $hnDqW.normalizeRovoJourneyId)(queryParams.rovoJourneyId)
                }
            });
        },
    setRequestedBackendExperiments: (requestedBackendExperiments)=>({ setState: setState })=>{
            const experimentLayers = requestedBackendExperiments?.experimentLayers?.map((layer)=>{
                const { analyticsDefinitions: analyticsDefinitions, ...rest } = layer;
                return {
                    ...rest,
                    definitions: analyticsDefinitions
                };
            });
            setState({
                requestedBackendExperiments: {
                    experimentLayers: experimentLayers
                }
            });
        },
    setJsmIncidentFilterIds: (jsmIncidentFilterIds)=>({ getState: getState, setState: setState })=>{
            if (getState().jsmIncidentFilterIds === jsmIncidentFilterIds) return;
            setState({
                jsmIncidentFilterIds: jsmIncidentFilterIds
            });
        },
    /*
   * This action is only triggered by QF but the value of filterDropdownOpen is only used by FPS
   * This means we need to update query param to make it available to FPS
   * That's why updateQueryParams is set to 'true'
   *
   * We only call it for clearing and the "set" value would be handled by onNavigate
   * */ unsetFilterDropdownOpen: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filterDropdownOpenByQueryParam: false
            }, {
                updateQueryParams: true
            }));
        }
};
const $2b1419bc2c84719c$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        // Clear all does not clear the multi-site selector
        if (filter.id === (0, $8JYuM.siteFilterId) && (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: config.primaryProduct,
            fireExperimentExposure: false
        }) !== 'control') return filterState ? [
            filter.id,
            filterState
        ] : [];
        if (!filter.isCompatible(filterState?.id)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $2b1419bc2c84719c$var$Store = (0, $8s9DV.createStore)({
    initialState: $2b1419bc2c84719c$export$d4c72bab9d6cc13a,
    actions: $2b1419bc2c84719c$export$e324594224ef24da,
    name: 'search'
});
const $2b1419bc2c84719c$export$b8f9c0e048639dd4 = (0, $kBr4q.createActionsHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$bf072992274c9fb = (0, $j8on0.createContainer)($2b1419bc2c84719c$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($2b1419bc2c84719c$export$d4c72bab9d6cc13a);
        }
});
const $2b1419bc2c84719c$export$bd221a7c56b93941 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$c5a5afdff2ff0385 = (0, $kBr4q.createActionsHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$5fd14fa624074d55 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $2b1419bc2c84719c$export$973ca22476b0e05f = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.filters
});
const $2b1419bc2c84719c$export$da992673b1309795 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.inputQuery
});
const $2b1419bc2c84719c$export$59d1399255ff1d16 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.experience
});
const $2b1419bc2c84719c$export$e985158d10c27e34 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.searchQuery
});
const $2b1419bc2c84719c$export$c2380c4d76e63cc4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.originalQuery
});
const $2b1419bc2c84719c$export$ba2ad669c5b27bca = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $2b1419bc2c84719c$export$140d37088821fcb1 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.retryCount
});
const $2b1419bc2c84719c$export$275c72361969d62c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $2b1419bc2c84719c$export$14279a3fbdb52451 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $2b1419bc2c84719c$export$34418e307d9100b4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $2b1419bc2c84719c$export$8a4c65ea4f241b48 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $6yu7A.QueryState).POSTQUERY : (0, $6yu7A.QueryState).PREQUERY
});
const $2b1419bc2c84719c$export$a2b38489a4538322 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $2b1419bc2c84719c$export$bda9ac73817ceec3 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results
});
const $2b1419bc2c84719c$export$1c9622ace43d770d = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.resultError
});
const $2b1419bc2c84719c$export$49f5dec896c355cd = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.requestId
});
const $2b1419bc2c84719c$export$944245f24d4ef0b6 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.traceId
});
const $2b1419bc2c84719c$export$4dface15d86304a4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isLoading
});
const $2b1419bc2c84719c$export$f59185497e80e274 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.resultsSort
});
const $2b1419bc2c84719c$export$e2d0c00df99a687c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.queryVersion
});
const $2b1419bc2c84719c$export$5f38673942a99ffe = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $2b1419bc2c84719c$export$3bc2682926916b14 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.wasContentClearedBySpaceChange
});
const $2b1419bc2c84719c$export$1e51d2073b60bd88 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.results,
        (state)=>state.isLoading,
        (state)=>state.resultError
    ], (results, isLoading, resultError)=>$2b1419bc2c84719c$export$71923aa45c7aa566({
            results: results,
            isLoading: isLoading,
            resultError: resultError
        }))
});
const $2b1419bc2c84719c$export$71923aa45c7aa566 = ({ results: results, isLoading: isLoading, resultError: resultError })=>{
    if (isLoading) return (0, $lDiEy.ResultsStates).IS_LOADING;
    if (results && results.edges && results.edges.length > 0) return (0, $lDiEy.ResultsStates).RESULTS;
    // If there are no entities for a query, an error will throw
    // when no entities for query is equivalent to no results
    if (resultError instanceof (0, $c59181be2ffd57d8$export$8ba86dff7c04c14c) || results && (results.edges ?? []).length === 0) return (0, $lDiEy.ResultsStates).NO_RESULTS;
    if (resultError) return (0, $lDiEy.ResultsStates).ERROR;
    if (!results) return (0, $lDiEy.ResultsStates).INITIAL;
    return (0, $lDiEy.ResultsStates).ERROR;
};
const $2b1419bc2c84719c$export$826bdf756a8bf13a = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $2b1419bc2c84719c$export$387e1da2bc9c93cc = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $2b1419bc2c84719c$export$e87eda20cc6e50c2 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedDatasource
});
const $2b1419bc2c84719c$export$8c11ef422551818 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $2b1419bc2c84719c$export$795623048d841bf2 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $2b1419bc2c84719c$export$8dc083eb9766b48 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $2b1419bc2c84719c$export$e80788222dba30a3 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $2b1419bc2c84719c$export$bedf78a7ab879711 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $2b1419bc2c84719c$export$f258398dab7c75ba = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $2b1419bc2c84719c$export$964e8498268f0fe3 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.selectedProducts,
        (state)=>state.availableProducts,
        (state)=>state.availableProductsForSelectedSites
    ], (selectedProducts, availableProducts, availableProductsForSelectedSites)=>{
        return {
            selectedProduct: selectedProducts[0],
            filteredProducts: selectedProducts[0] ? [
                selectedProducts[0]
            ] : availableProducts,
            availableProducts: availableProducts,
            availableProductsForSelectedSites: availableProductsForSelectedSites
        };
    })
});
const $2b1419bc2c84719c$export$59086fbf0d8f8d2a = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.availableProducts,
        (state)=>state.selectedProducts,
        (state)=>state.allFilterExcludedProducts,
        (state)=>state.filters,
        (_, props)=>props
    ], (availableProducts, selectedProducts, allFilterExcludedProducts, filters, props)=>{
        const { thirdPartyConfigs: thirdPartyConfigs } = props;
        return (0, $fuajF.getTypeEntities)({
            availableProducts: availableProducts,
            filters: filters,
            selectedProducts: selectedProducts,
            allFilterExcludedProducts: allFilterExcludedProducts
        }, {
            thirdPartyConfigs: thirdPartyConfigs
        });
    })
});
const $2b1419bc2c84719c$export$aad641f503e4b4a8 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(filter.type === 'multi-select' || filter.type === 'single-select')) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts,
            primaryProduct: state.primaryProduct,
            experience: state.experience
        };
    }
});
const $2b1419bc2c84719c$export$c724ec2cbd2fedce = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            primaryProduct: state.primaryProduct
        };
    }
});
const $2b1419bc2c84719c$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $2b1419bc2c84719c$export$546f6564ce5d0a17 = (filters, primaryProduct)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.products.find((relevantProductFilter)=>relevantProductFilter === primaryProduct) ? [
            filter
        ] : [];
    });
};
const $2b1419bc2c84719c$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        // Universal filters should always be shown for forge connectors
        // This is needed because forge connectors are dynamically loaded and not in the static products list
        if (filter && filter.universal && selectedProducts.some((0, $8fNUp.isForgeConnectorProductKey))) return [
            filter
        ];
        if (filter && f === 'content' && selectedProducts.includes((0, $dvVWp.ProductKeys).ConfluenceDC)) return (0, $iDrrr.fg)('confluence-dc-content-filter') ? [
            filter
        ] : [];
        else return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 * Configurable based on the primary product - this is the case for QF filters
 */ const $2b1419bc2c84719c$var$getAllAvailableFilters = (filters, selectedProducts, config)=>{
    if (config?.basedOnPrimaryProduct && config?.primaryProduct) return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? $2b1419bc2c84719c$export$546f6564ce5d0a17(filters, config?.primaryProduct) : $2b1419bc2c84719c$export$a8734449e402b6ca(filters, selectedProducts);
    return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? $2b1419bc2c84719c$export$1c5018e1c1ce99ae(filters) : $2b1419bc2c84719c$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $2b1419bc2c84719c$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder, config)=>{
    const allAvailableFilterIds = $2b1419bc2c84719c$var$getAllAvailableFilters(filters, selectedProducts, config).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    const filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // Filters with no selections can also be prioritised based on the props
    const filtersPrioritised = config?.prioritisedFilterIds?.filter((f)=>allAvailableFilterIds.includes(f)) ?? [];
    // then simply add the rest back (with a set for deduplication)
    const inline = [
        ...new Set([
            ...filtersForInline,
            ...filtersPrioritised,
            ...allAvailableFilterIds
        ])
    ];
    return inline;
};
const $2b1419bc2c84719c$export$94c94f88577d66b2 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder }, config)=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters are hidden from both the inline filter row and the dropdown list.
        // setSearchStoreState clears their underlying selection in the same write so the store
        // stays in sync with what is visible/applied to URL/GraphQL/badge count.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], filters);
        const isExcluded = (id)=>excludedFilterIds.has(id);
        // opt-in only: this hook is shared with Quick Find, which keeps the overlapping behaviour.
        // Gate × experiment × product, not a bare fg() — callers under a rollout experiment
        // (no raw gate yet) still need the disjoint placement they asked for.
        if ((0, $cJff5.shouldShowRefreshedFilterRow)(config?.primaryProduct) && config?.useDisjointFilterPlacement) {
            const available = $2b1419bc2c84719c$var$getAllAvailableFilters(filters, selectedProducts, config).map((f)=>f.id).filter((id)=>!isExcluded(id));
            // Sort is outside the filter ordering, so add it for the apps that offer it.
            if (!(0, $c3cgJ.isAllProductSearch)(selectedProducts) && (selectedProducts[0] === (0, $dvVWp.ProductKeys).Confluence || selectedProducts[0] === (0, $dvVWp.ProductKeys).Jira) && filters[0, $8JYuM.sortFilterId] !== undefined && !isExcluded((0, $8JYuM.sortFilterId)) && !available.includes((0, $8JYuM.sortFilterId))) available.push((0, $8JYuM.sortFilterId));
            // Not intersected with `available`: "All apps" only offers universal filters, while the
            // primary product's inline set still applies.
            const inlineFilterIds = (0, $b7c49ef11e2d0611$export$c119cca36ac9a52c)(selectedProducts[0], config.primaryProduct).filter((id)=>filters[id] !== undefined && !isExcluded(id));
            // preserves placement-table order rather than getAllAvailableFilters' order
            const filtersInLine = inlineFilterIds;
            const filtersInDropdown = available.filter((id)=>!inlineFilterIds.includes(id));
            return {
                filtersInDropdown: filtersInDropdown,
                filtersInLine: filtersInLine,
                filterSelectionOrder: filterSelectionOrder
            };
        }
        // All filters always show in the dropdown, in order (minus excluded)
        const filtersInDropdown = $2b1419bc2c84719c$var$getAllAvailableFilters(filters, selectedProducts, config).map((f)=>f.id).filter((id)=>!isExcluded(id));
        const filtersInLine = $2b1419bc2c84719c$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder, config).filter((id)=>!isExcluded(id));
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $2b1419bc2c84719c$export$754cc306c2d9241e = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort, primaryProduct: primaryProduct })=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters do not contribute to the badge count. setSearchStoreState
        // clears their underlying selection so the store stays in sync.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], filters);
        const isMultiSiteSearchEnabled = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct,
            fireExperimentExposure: false
        }) !== 'control';
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>filter && !excludedFilterIds.has(filter.id))// The multi-site selector is not part of the filter count (+N badge on the dropdown filter button)
        .filter((filter)=>!(isMultiSiteSearchEnabled && filter?.id === (0, $8JYuM.siteFilterId))).filter((filter)=>filter && (0, $ceA8V.isFilterSelectionCountable)(filter.id, selectedProducts));
        const { field: field } = resultsSort;
        const isNotSortedByDefault = field !== (0, $3yJeH.SORT_FIELD_KEY).RELEVANCE;
        return {
            selectedFilterCount: selectedFilters.length + (isNotSortedByDefault ? 1 : 0)
        };
    }
});
const $2b1419bc2c84719c$export$a63314038bf0cbf9 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ filters: filters })=>{
        const filterAttributes = Object.values(filters).flatMap((filter)=>{
            return filter ? [
                filter
            ] : [];
        }).map((filter)=>{
            const filterType = filter.type;
            switch(filterType){
                case 'boolean':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.value ? [
                            {
                                value: (0, $0023915a6e6a3533$export$931e138580bca877)(filter.id, String(filter.value)),
                                isSmartDefault: false,
                                filterId: filter.id
                            }
                        ] : []
                    };
                case 'multi-select':
                case 'single-select':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.options.filter((filterOption)=>filterOption.isSelected).map((filterOption)=>({
                                value: (0, $0023915a6e6a3533$export$931e138580bca877)(filter.id, filterOption.trackingKey || filterOption.value),
                                isSmartDefault: filterOption.isSuggested,
                                filterId: filter.id
                            }))
                    };
                default:
                    return filterType;
            }
        }).filter((attributes)=>attributes.filterSelections.length).reduce((acc, curr)=>{
            return {
                filters: [
                    ...acc.filters,
                    ...curr.filters
                ],
                filterSelections: [
                    ...acc.filterSelections,
                    ...curr.filterSelections
                ]
            };
        }, {
            filters: [],
            filterSelections: []
        });
        return filterAttributes;
    }
});
const $2b1419bc2c84719c$export$33ca33de08a5b6bb = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ cql: cql })=>cql
});
const $2b1419bc2c84719c$export$210935c1afa2c65c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, primaryProduct: primaryProduct }, props = {
        includeSelectedProduct: true
    })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct && props.includeSelectedProduct) return true;
        const isMultiSiteSearchEnabled = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct,
            fireExperimentExposure: false
        }) !== 'control';
        // Clear all button is not displayed if only the site selector is applied
        return Object.values(filters).some((filter)=>filter?.hasSelection && !(isMultiSiteSearchEnabled && filter?.id === (0, $8JYuM.siteFilterId)));
    }
});
const $2b1419bc2c84719c$export$1f88edaa1bb97b87 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ leapQuery: leapQuery })=>leapQuery
});
const $2b1419bc2c84719c$export$64ea42df9468ccc0 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>({
            backendExperiments: state.requestedBackendExperiments
        })
});
const $2b1419bc2c84719c$export$5ce42807c47ad171 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.jsmIncidentFilterIds
});
const $2b1419bc2c84719c$export$fce7b0e4e0dda8ee = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>{
        return state.filterDropdownOpenByQueryParam;
    }
});
module.exports["initialState"] = $2b1419bc2c84719c$export$d4c72bab9d6cc13a;
module.exports["SearchStoreContainer"] = $2b1419bc2c84719c$export$bf072992274c9fb;
module.exports["useSearch"] = $2b1419bc2c84719c$export$bd221a7c56b93941;
module.exports["useSearchActions"] = $2b1419bc2c84719c$export$c5a5afdff2ff0385;
module.exports["useSearchState"] = $2b1419bc2c84719c$export$5fd14fa624074d55;
module.exports["useFilters"] = $2b1419bc2c84719c$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $2b1419bc2c84719c$export$da992673b1309795;
module.exports["useSearchExperience"] = $2b1419bc2c84719c$export$59d1399255ff1d16;
module.exports["useSearchQuery"] = $2b1419bc2c84719c$export$e985158d10c27e34;
module.exports["useRetryCount"] = $2b1419bc2c84719c$export$140d37088821fcb1;
module.exports["useQueryUpdatedTime"] = $2b1419bc2c84719c$export$a2b38489a4538322;
module.exports["useResults"] = $2b1419bc2c84719c$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $2b1419bc2c84719c$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $2b1419bc2c84719c$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $2b1419bc2c84719c$export$4dface15d86304a4;
module.exports["useResultsSort"] = $2b1419bc2c84719c$export$f59185497e80e274;
module.exports["useQueryVersion"] = $2b1419bc2c84719c$export$e2d0c00df99a687c;
module.exports["useWasContentClearedBySpaceChange"] = $2b1419bc2c84719c$export$3bc2682926916b14;
module.exports["useResultsState"] = $2b1419bc2c84719c$export$1e51d2073b60bd88;
module.exports["useSelectedProducts"] = $2b1419bc2c84719c$export$826bdf756a8bf13a;
module.exports["useSelectedProduct"] = $2b1419bc2c84719c$export$387e1da2bc9c93cc;
module.exports["useSelectedDatasource"] = $2b1419bc2c84719c$export$e87eda20cc6e50c2;
module.exports["useIsJiraHydrationLoading"] = $2b1419bc2c84719c$export$8c11ef422551818;
module.exports["useIsSearchReady"] = $2b1419bc2c84719c$export$8dc083eb9766b48;
module.exports["useProducts"] = $2b1419bc2c84719c$export$964e8498268f0fe3;
module.exports["useTypeEntities"] = $2b1419bc2c84719c$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $2b1419bc2c84719c$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $2b1419bc2c84719c$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $2b1419bc2c84719c$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $2b1419bc2c84719c$export$754cc306c2d9241e;
module.exports["useFilterAttributesForTracking"] = $2b1419bc2c84719c$export$a63314038bf0cbf9;
module.exports["useCQL"] = $2b1419bc2c84719c$export$33ca33de08a5b6bb;
module.exports["useAnyFilterSelected"] = $2b1419bc2c84719c$export$210935c1afa2c65c;
module.exports["useRequestedBackendExperiments"] = $2b1419bc2c84719c$export$64ea42df9468ccc0;
module.exports["useJsmIncidentFilterIds"] = $2b1419bc2c84719c$export$5ce42807c47ad171;
module.exports["useFilterDropdownOpenByQueryParam"] = $2b1419bc2c84719c$export$fce7b0e4e0dda8ee;

});

parcelRegister("3yJeH", function(module, exports) {
const $2cec2822a71f660c$export$fdf34174678f07b6 = {
    RELEVANCE: 'relevance',
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $2cec2822a71f660c$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.RELEVANCE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.ASC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.ASC}`;
const $2cec2822a71f660c$export$6b492fdcc7e8d1f4 = {
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.RELEVANCE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC}Selected`,
        drawerOrder: 0
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 1
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.ASC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 2
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 3
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.ASC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 4
    }
};
const $2cec2822a71f660c$export$76673e1b214c1378 = Object.values($2cec2822a71f660c$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $2cec2822a71f660c$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $2cec2822a71f660c$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $2cec2822a71f660c$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $2cec2822a71f660c$export$6b492fdcc7e8d1f4;

});

parcelRegister("6yu7A", function(module, exports) {
const $8fae1dff497a873c$export$e8d1ded05852e864 = {
    source: 'source'
};
const $8fae1dff497a873c$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    primaryProductFilterString: 'primaryProductFilterString',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    frontendExperiments: 'frontendExperiments',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version',
    mode: 'mode',
    requestId: 'requestId',
    traceId: 'traceId'
};
const $8fae1dff497a873c$export$ed78826c06dd24e3 = 'fabric-elements';
const $8fae1dff497a873c$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $8fae1dff497a873c$export$1111f6e73bd7b1d8 = 'searchDialog';
const $8fae1dff497a873c$export$98bd2afc08f981ef = 'searchPage';
var $8fae1dff497a873c$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $8fae1dff497a873c$export$eed19b551669af14 = 'CURRENT';
const $8fae1dff497a873c$export$c936349447a77fe0 = 'ARCHIVED';
const $8fae1dff497a873c$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $8fae1dff497a873c$export$2be5c31192ba8783 = 'all';
const $8fae1dff497a873c$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $8fae1dff497a873c$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["DEFAULT_GAS_CHANNEL"] = $8fae1dff497a873c$export$ed78826c06dd24e3;
module.exports["EVENT_SOURCE"] = $8fae1dff497a873c$export$ad44d4a0591d8dba;
module.exports["SEARCH_DIALOG_EVENT_SOURCE"] = $8fae1dff497a873c$export$1111f6e73bd7b1d8;
module.exports["ACTION_SUBJECT_PREFIX"] = $8fae1dff497a873c$export$98bd2afc08f981ef;
module.exports["OptionIds"] = $8fae1dff497a873c$export$1118b8908e5d0501;
module.exports["CURRENT"] = $8fae1dff497a873c$export$eed19b551669af14;
module.exports["ARCHIVED"] = $8fae1dff497a873c$export$c936349447a77fe0;
module.exports["CROSSPRODUCT_SEARCH_API"] = $8fae1dff497a873c$export$a4c5cde0daa9b961;
module.exports["ALL_PRODUCTS_STRING"] = $8fae1dff497a873c$export$2be5c31192ba8783;
module.exports["ERROR_SCREEN_NAME"] = $8fae1dff497a873c$export$cabdc1d3c523c88;
module.exports["QueryState"] = $8fae1dff497a873c$export$15029b2eda44c6a7;

});

parcelRegister("e0v3Z", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");

const $e68e3cbc9acf5db8$export$e9131c78c1110376 = (str)=>(0, $eVK28.sha256)(str);
module.exports["sha256Hash"] = $e68e3cbc9acf5db8$export$e9131c78c1110376;

});

parcelRegister("lDiEy", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $d88562a6863f5691$export$cdcda2a8fcb980fa = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading'
};
module.exports["ResultsStates"] = $d88562a6863f5691$export$cdcda2a8fcb980fa;

});

parcelRegister("ceA8V", function(module, exports) {

var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");

const $43fd07228cfd304d$export$3d8d21e544a731c9 = (filterId, selectedProducts)=>{
    if (filterId !== (0, $4ysB6.universalTypeFilterId)) return true;
    return !selectedProducts.includes((0, $dvVWp.ProductKeys).Atlas) && !selectedProducts.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler);
};
module.exports["isFilterSelectionCountable"] = $43fd07228cfd304d$export$3d8d21e544a731c9;

});

parcelRegister("c3cgJ", function(module, exports) {
const $378379b88c60c6f4$export$49b588d87f72a4a8 = (selectedProducts)=>selectedProducts.length === 0;
module.exports["isAllProductSearch"] = $378379b88c60c6f4$export$49b588d87f72a4a8;

});

parcelRegister("hnDqW", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $3Ydx7 = parcelRequire("3Ydx7");

const $520a04896497429c$export$d1fb2cdb18632901 = (primaryProduct)=>primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence && (0, $iDrrr.fg)('rovo_search_chat_convergence_instrumentation');
const $520a04896497429c$export$ed3c69267b7c7b62 = (primaryProduct)=>(primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence || primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas) && (0, $iDrrr.fg)('rovo_search_chat_convergence_instrumentation');
const $520a04896497429c$export$fb43ed8ef2efa491 = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
module.exports["canStartRovoJourney"] = $520a04896497429c$export$d1fb2cdb18632901;
module.exports["canContinueRovoJourney"] = $520a04896497429c$export$ed3c69267b7c7b62;
module.exports["normalizeRovoJourneyId"] = $520a04896497429c$export$fb43ed8ef2efa491;

});

parcelRegister("6Vsfx", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $1Qme9 = parcelRequire("1Qme9");


var $j2nXD = parcelRequire("j2nXD");


var $dvVWp = parcelRequire("dvVWp");


var $dk2Cw = parcelRequire("dk2Cw");

const $c65f2af85e8e4dd6$export$f59daa7c22f639ca = (ari)=>{
    if (!ari) return undefined;
    try {
        return (0, $99V2N.AnyAri).parse(ari).cloudId?.trim() || undefined;
    } catch  {
        return undefined;
    }
};
/**
 * Normalises a raw `?sites=` query param into site ids. The value reaches us unparsed, so it can be
 * a comma-separated string or an already-split array.
 */ const $c65f2af85e8e4dd6$var$toSiteIds = (rawSelectedSites)=>{
    const sites = Array.isArray(rawSelectedSites) ? rawSelectedSites : typeof rawSelectedSites === 'string' ? rawSelectedSites.split(',') : [];
    return sites.map((site)=>site.trim()).filter(Boolean);
};
const $c65f2af85e8e4dd6$export$c096d96d138a38cc = (rawSelectedSites, unitMetadata, currentCloudId, primaryProduct)=>{
    const selectedSites = Object.assign(new Map(), {
        availableSitesCount: unitMetadata?.length
    });
    const useDefaultSites = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct,
        fireExperimentExposure: false
    }) === 'test-2' && rawSelectedSites === undefined;
    const sitesInScope = new Set(useDefaultSites ? (0, $dk2Cw.getDefaultSiteIds)(unitMetadata, currentCloudId) : $c65f2af85e8e4dd6$var$toSiteIds(rawSelectedSites));
    if (currentCloudId) sitesInScope.add(currentCloudId);
    for (const site of unitMetadata ?? []){
        const siteCloudId = (0, $j2nXD.getSiteCloudId)(site.id);
        if (sitesInScope.has(siteCloudId) && !selectedSites.has(siteCloudId)) selectedSites.set(siteCloudId, site.siteName);
    }
    return selectedSites;
};
const $c65f2af85e8e4dd6$export$99ca96cfa52d5605 = (selectedSites)=>selectedSites?.availableSitesCount;
const $c65f2af85e8e4dd6$export$c49ee6362a11216 = ({ availableProducts: availableProducts, selectedCloudIds: selectedCloudIds, unitMetadata: unitMetadata })=>{
    const uniqueSelectedCloudIds = Array.from(new Set(selectedCloudIds?.filter(Boolean)));
    if (uniqueSelectedCloudIds.length <= 1) return availableProducts;
    const selectedCloudIdSet = new Set(uniqueSelectedCloudIds);
    const selectedSiteProductSet = new Set();
    let matchedSiteCount = 0;
    for (const site of unitMetadata ?? []){
        if (!selectedCloudIdSet.has((0, $j2nXD.getSiteCloudId)(site.id))) continue;
        matchedSiteCount += 1;
        if (!site.firstPartyProducts) return availableProducts;
        for (const product of site.firstPartyProducts)if ((0, $dvVWp.is1pProductKey)(product.name)) selectedSiteProductSet.add(product.name);
    }
    const selectedSiteProducts = Array.from(selectedSiteProductSet);
    if (matchedSiteCount <= 1 || !selectedSiteProducts.length) return availableProducts;
    return Array.from(new Set([
        ...selectedSiteProducts,
        ...availableProducts.filter((product)=>!(0, $dvVWp.is1pProductKey)(product))
    ]));
};
const $c65f2af85e8e4dd6$export$8789a1de7f140d8d = (resultId, selectedSites)=>{
    const cloudId = $c65f2af85e8e4dd6$export$f59daa7c22f639ca(resultId);
    return cloudId ? selectedSites?.get(cloudId) : undefined;
};
const $c65f2af85e8e4dd6$export$7f9d9b17348c7f29 = (resultId, currentCloudId, selectedSites)=>{
    const availableSitesCount = $c65f2af85e8e4dd6$export$99ca96cfa52d5605(selectedSites);
    // An absent or empty lookup means the search was not site-scoped. Availability is independent of
    // the search scope, so report it when known.
    if (!selectedSites?.size) return availableSitesCount !== undefined ? {
        availableSitesCount: availableSitesCount
    } : {};
    const resultCloudId = $c65f2af85e8e4dd6$export$f59daa7c22f639ca(resultId);
    return {
        selectedSitesCount: selectedSites.size,
        isPrimarySite: currentCloudId && resultCloudId ? resultCloudId === currentCloudId : undefined,
        ...availableSitesCount !== undefined ? {
            availableSitesCount: availableSitesCount
        } : {}
    };
};
module.exports["extractCloudIdFromAri"] = $c65f2af85e8e4dd6$export$f59daa7c22f639ca;
module.exports["buildSelectedSites"] = $c65f2af85e8e4dd6$export$c096d96d138a38cc;
module.exports["getAvailableSitesCount"] = $c65f2af85e8e4dd6$export$99ca96cfa52d5605;
module.exports["getAvailableProductsForSelectedCloudIds"] = $c65f2af85e8e4dd6$export$c49ee6362a11216;
module.exports["getSiteName"] = $c65f2af85e8e4dd6$export$8789a1de7f140d8d;
module.exports["getSiteMetadata"] = $c65f2af85e8e4dd6$export$7f9d9b17348c7f29;

});

parcelRegister("j2nXD", function(module, exports) {
// Multi-site selection caps (QS-9518), shared by SiteSelect and the `site` filter.

var $99V2N = parcelRequire("99V2N");

const $b2f7466bf7ca359e$export$58cd6790f867654e = 5;
const $b2f7466bf7ca359e$export$e7aa807d35b04e85 = (siteId)=>{
    if (!siteId.startsWith('ari:')) return siteId;
    try {
        return (0, $99V2N.AnyAri).parse(siteId).resourceId || siteId;
    } catch  {
        return siteId;
    }
};
module.exports["MAX_SELECTED_SITES"] = $b2f7466bf7ca359e$export$58cd6790f867654e;
module.exports["getSiteCloudId"] = $b2f7466bf7ca359e$export$e7aa807d35b04e85;

});

parcelRegister("dk2Cw", function(module, exports) {

var $j2nXD = parcelRequire("j2nXD");

const $9abc93d56738e528$export$8652fa50b846f3c2 = (unitMetadata, currentCloudId)=>{
    const otherSites = [
        ...unitMetadata ?? []
    ].filter((site)=>(0, $j2nXD.getSiteCloudId)(site.id) !== currentCloudId).sort((a, b)=>a.siteName.localeCompare(b.siteName));
    return Array.from(new Set([
        ...currentCloudId ? [
            currentCloudId
        ] : [],
        ...otherSites.map((site)=>(0, $j2nXD.getSiteCloudId)(site.id))
    ])).slice(0, (0, $j2nXD.MAX_SELECTED_SITES));
};
module.exports["getDefaultSiteIds"] = $9abc93d56738e528$export$8652fa50b846f3c2;

});

parcelRegister("c3mkK", function(module, exports) {

var $i6ZUk = parcelRequire("i6ZUk");


var $7RXGY = parcelRequire("7RXGY");

const $4333343926bce73a$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $7RXGY.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $i6ZUk.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $7RXGY.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $i6ZUk.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $4333343926bce73a$export$e8eac31981efe1fb;

});

parcelRegister("jbIQp", function(module, exports) {
const $ed54167fae0bcfaa$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
module.exports["isSelectFilter"] = $ed54167fae0bcfaa$export$8e6bea29334a2099;

});

parcelRegister("8JYuM", function(module, exports) {
/**
 * Lightweight filter ID constants extracted from individual filter modules.
 *
 * These are simple string constants with zero transitive dependencies.
 * Use these instead of importing from the filter barrel file (index.tsx)
 * when you only need the filter ID for keying into a filters record.
 *
 * QS-9423: Breaking the dependency chain that dragged react-sweet-state
 * into the SSR bundle via filter barrel → filter controllers → search store.
 */ const $2ac1b9b51a795567$export$741d3c5ff1600fc4 = 'archived';
const $2ac1b9b51a795567$export$98981f5c8dc7607d = 'compassArchived';
const $2ac1b9b51a795567$export$798f70d5ba74d109 = 'assetsSchema';
const $2ac1b9b51a795567$export$51661d1a93f29640 = 'assetsType';
const $2ac1b9b51a795567$export$9c1e246329cdf939 = 'assignee';
const $2ac1b9b51a795567$export$e32111e9166eaf89 = 'closeDate';
const $2ac1b9b51a795567$export$9af0987cf592f533 = 'commentedByMe';
const $2ac1b9b51a795567$export$6a3fc832c5c25c7d = 'content';
const $2ac1b9b51a795567$export$e03d97f0eaa66910 = 'contributor';
const $2ac1b9b51a795567$export$9ab819519540cfb4 = 'createdBy';
const $2ac1b9b51a795567$export$cd646dbb07979a8d = 'focusAreaType';
const $2ac1b9b51a795567$export$2678e5eb1f9db396 = 'focusAreaUnder';
const $2ac1b9b51a795567$export$623d400c5f880682 = 'label';
const $2ac1b9b51a795567$export$7ecf570078da6b1c = 'lastUpdatedBy';
const $2ac1b9b51a795567$export$11e1218ac07ed03e = 'lastUpdated';
const $2ac1b9b51a795567$export$68c1310fa8b7db62 = 'campaignStatus';
const $2ac1b9b51a795567$export$6598f3f01335d547 = 'caseStatus';
const $2ac1b9b51a795567$export$3ce8ff7a271ec50 = 'documentStatus';
const $2ac1b9b51a795567$export$123079b08beba778 = 'calendarType';
const $2ac1b9b51a795567$export$1334b09cd7315981 = 'leadStatus';
const $2ac1b9b51a795567$export$cffc11c79d20b86c = 'taskStatus';
const $2ac1b9b51a795567$export$1c425911806204b2 = 'taskType';
const $2ac1b9b51a795567$export$5311692c4ffccb4f = 'tag';
const $2ac1b9b51a795567$export$4febaaf9b7a72ca9 = 'opportunityStatus';
const $2ac1b9b51a795567$export$c21586a37554cc74 = 'pullRequestStatus';
const $2ac1b9b51a795567$export$2e6de80282206ac4 = 'repository';
const $2ac1b9b51a795567$export$219dbc6f14c3fa64 = 'reviewer';
const $2ac1b9b51a795567$export$f42198825b45f0bf = 'owner';
const $2ac1b9b51a795567$export$bcfaf48394705893 = 'pageStatus';
const $2ac1b9b51a795567$export$713c4dadb56593e7 = 'positionEmploymentType';
const $2ac1b9b51a795567$export$d87a0f934d4a8c3c = 'positionFocusArea';
const $2ac1b9b51a795567$export$19dab386a6b200ee = 'positionJobFamily';
const $2ac1b9b51a795567$export$f75b5006a4fc44bc = 'positionStatus';
const $2ac1b9b51a795567$export$4c1df8b2cfbc878 = 'positionTeam';
const $2ac1b9b51a795567$export$9e360b05ef07f438 = 'project';
const $2ac1b9b51a795567$export$58bc8a3e7def8aea = 'reporter';
const $2ac1b9b51a795567$export$3515d33a163cbcb3 = 'salesforceStage';
const $2ac1b9b51a795567$export$4f9240015ff0684c = 'sort';
const $2ac1b9b51a795567$export$3a6305d8320c16a4 = 'space';
const $2ac1b9b51a795567$export$523eec4c8a60c037 = 'site';
const $2ac1b9b51a795567$export$2a46d5fba7ab443f = 'statusFilter';
const $2ac1b9b51a795567$export$89b94a9f6bd9eece = 'onlyTitleMatch';
const $2ac1b9b51a795567$export$b698e15dd0654a6b = 'verified';
const $2ac1b9b51a795567$export$883e178bcc42a97b = 'watchedByMe';
const $2ac1b9b51a795567$export$26517625dab3ad98 = 'slackChannel';
const $2ac1b9b51a795567$export$c11f86df99674975 = 'folder';
const $2ac1b9b51a795567$export$1bb4d8ad1dbc2bac = 'workspaceName';
const $2ac1b9b51a795567$export$4d0145e3d3f3e249 = 'hasAttachment';
module.exports["archivedFilterId"] = $2ac1b9b51a795567$export$741d3c5ff1600fc4;
module.exports["archivedAndPendingComponentsFilterId"] = $2ac1b9b51a795567$export$98981f5c8dc7607d;
module.exports["assetsSchemaFilterId"] = $2ac1b9b51a795567$export$798f70d5ba74d109;
module.exports["assetsTypeFilterId"] = $2ac1b9b51a795567$export$51661d1a93f29640;
module.exports["assigneeFilterId"] = $2ac1b9b51a795567$export$9c1e246329cdf939;
module.exports["closeDateFilterId"] = $2ac1b9b51a795567$export$e32111e9166eaf89;
module.exports["commentedByMeFilterId"] = $2ac1b9b51a795567$export$9af0987cf592f533;
module.exports["contentFilterId"] = $2ac1b9b51a795567$export$6a3fc832c5c25c7d;
module.exports["contributorFilterId"] = $2ac1b9b51a795567$export$e03d97f0eaa66910;
module.exports["createdByFilterId"] = $2ac1b9b51a795567$export$9ab819519540cfb4;
module.exports["focusAreaTypeFilterId"] = $2ac1b9b51a795567$export$cd646dbb07979a8d;
module.exports["focusAreaUnderFilterId"] = $2ac1b9b51a795567$export$2678e5eb1f9db396;
module.exports["labelFilterId"] = $2ac1b9b51a795567$export$623d400c5f880682;
module.exports["lastUpdatedByFilterId"] = $2ac1b9b51a795567$export$7ecf570078da6b1c;
module.exports["lastUpdatedFilterId"] = $2ac1b9b51a795567$export$11e1218ac07ed03e;
module.exports["campaignStatusFilterId"] = $2ac1b9b51a795567$export$68c1310fa8b7db62;
module.exports["caseStatusFilterId"] = $2ac1b9b51a795567$export$6598f3f01335d547;
module.exports["documentStatusFilterId"] = $2ac1b9b51a795567$export$3ce8ff7a271ec50;
module.exports["calendarTypeFilterId"] = $2ac1b9b51a795567$export$123079b08beba778;
module.exports["leadStatusFilterId"] = $2ac1b9b51a795567$export$1334b09cd7315981;
module.exports["taskStatusFilterId"] = $2ac1b9b51a795567$export$cffc11c79d20b86c;
module.exports["taskTypeFilterId"] = $2ac1b9b51a795567$export$1c425911806204b2;
module.exports["tagFilterId"] = $2ac1b9b51a795567$export$5311692c4ffccb4f;
module.exports["opportunityStatusFilterId"] = $2ac1b9b51a795567$export$4febaaf9b7a72ca9;
module.exports["pullRequestStatusFilterId"] = $2ac1b9b51a795567$export$c21586a37554cc74;
module.exports["repositoryFilterId"] = $2ac1b9b51a795567$export$2e6de80282206ac4;
module.exports["reviewerFilterId"] = $2ac1b9b51a795567$export$219dbc6f14c3fa64;
module.exports["ownerFilterId"] = $2ac1b9b51a795567$export$f42198825b45f0bf;
module.exports["pageStatusFilterId"] = $2ac1b9b51a795567$export$bcfaf48394705893;
module.exports["positionEmploymentTypeFilterId"] = $2ac1b9b51a795567$export$713c4dadb56593e7;
module.exports["positionFocusAreaFilterId"] = $2ac1b9b51a795567$export$d87a0f934d4a8c3c;
module.exports["positionJobFamilyFilterId"] = $2ac1b9b51a795567$export$19dab386a6b200ee;
module.exports["positionStatusFilterId"] = $2ac1b9b51a795567$export$f75b5006a4fc44bc;
module.exports["positionTeamFilterId"] = $2ac1b9b51a795567$export$4c1df8b2cfbc878;
module.exports["projectFilterId"] = $2ac1b9b51a795567$export$9e360b05ef07f438;
module.exports["reporterFilterId"] = $2ac1b9b51a795567$export$58bc8a3e7def8aea;
module.exports["salesforceStageFilterId"] = $2ac1b9b51a795567$export$3515d33a163cbcb3;
module.exports["sortFilterId"] = $2ac1b9b51a795567$export$4f9240015ff0684c;
module.exports["spaceFilterId"] = $2ac1b9b51a795567$export$3a6305d8320c16a4;
module.exports["siteFilterId"] = $2ac1b9b51a795567$export$523eec4c8a60c037;
module.exports["statusFilterId"] = $2ac1b9b51a795567$export$2a46d5fba7ab443f;
module.exports["titleMatchFilterId"] = $2ac1b9b51a795567$export$89b94a9f6bd9eece;
module.exports["verifiedFilterId"] = $2ac1b9b51a795567$export$b698e15dd0654a6b;
module.exports["watchedFilterId"] = $2ac1b9b51a795567$export$883e178bcc42a97b;
module.exports["slackChannelFilterId"] = $2ac1b9b51a795567$export$26517625dab3ad98;
module.exports["folderFilterId"] = $2ac1b9b51a795567$export$c11f86df99674975;
module.exports["workspaceNameFilterId"] = $2ac1b9b51a795567$export$1bb4d8ad1dbc2bac;
module.exports["hasAttachmentFilterId"] = $2ac1b9b51a795567$export$4d0145e3d3f3e249;

});

parcelRegister("ieiUX", function(module, exports) {

var $8fNUp = parcelRequire("8fNUp");


var $9ekgQ = parcelRequire("9ekgQ");


var $9pcjO = parcelRequire("9pcjO");


var $hea5O = parcelRequire("hea5O");

const $e3a55b5f19f29c03$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter((0, $hea5O.notEmpty));
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const productKey = (0, $9ekgQ.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParams[staticFilter.queryParams.key] !== undefined).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $e3a55b5f19f29c03$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $9ekgQ.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products, experience, primaryProduct)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length && experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                if (!products.length && experience === (0, $9pcjO.SearchExperience).QUICK_FIND) return staticFilterValue.products.find((product)=>product === primaryProduct);
                if (!products.length) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                // Universal filters should always be included for forge connectors
                // This is needed because forge connectors are dynamically loaded and not in the static products list
                if (staticFilterValue.universal && products.some((0, $8fNUp.isForgeConnectorProductKey))) return true;
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $e3a55b5f19f29c03$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $e3a55b5f19f29c03$export$a97e25c038594c73;

});

parcelRegister("hea5O", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $iDrrr = parcelRequire("iDrrr");


var $coUcA = parcelRequire("coUcA");


var $fOh5X = parcelRequire("fOh5X");


var $XRj3F = parcelRequire("XRj3F");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $4wG6Y = parcelRequire("4wG6Y");


var $gPOtu = parcelRequire("gPOtu");


var $cJff5 = parcelRequire("cJff5");


var $cwPfG = parcelRequire("cwPfG");


var $2gvXK = parcelRequire("2gvXK");

/**
 * Gets 3P products that support a given filter, using the consolidated
 * ThirdPartyConfigs from rovo-connectors-config.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling the 3P configs (and their icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */ 
var $fd0l2 = parcelRequire("fd0l2");

const $c194c673aa4ee214$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};



var $dEA4Z = parcelRequire("dEA4Z");





/** An entry's `entities` is intersected with the request-wide selection, so all-types lists all. */ const $f7c0c65da85b02e9$var$BITBUCKET_ENTITIES_BY_CODE_SEARCH_SCOPE = {
    document: [
        ...(0, $fOh5X.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
    ],
    'all-types': [
        ...(0, $2gvXK.BITBUCKET_TYPE_ENTITY_ATIS),
        ...(0, $fOh5X.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
    ]
};
const $f7c0c65da85b02e9$var$DEFAULT_ENTITY_SUBTYPES = {
    [(0, $7ydfN.TypeFilterValueKey).Document]: [
        (0, $7ydfN.NounSubtypeKey).Document,
        (0, $7ydfN.NounSubtypeKey).Pdf
    ],
    [(0, $7ydfN.TypeFilterValueKey).Spreadsheet]: [
        (0, $7ydfN.NounSubtypeKey).Spreadsheet
    ],
    [(0, $7ydfN.TypeFilterValueKey).Presentation]: [
        (0, $7ydfN.NounSubtypeKey).Presentation
    ],
    [(0, $7ydfN.TypeFilterValueKey).Video]: [
        (0, $7ydfN.NounSubtypeKey).Video
    ],
    [(0, $7ydfN.TypeFilterValueKey).Design]: [
        (0, $7ydfN.NounSubtypeKey).Design
    ],
    [(0, $7ydfN.TypeFilterValueKey).Conversation]: [],
    [(0, $7ydfN.TypeFilterValueKey).Message]: [],
    // Comment filter should map to the comment subtype to avoid returning unrelated results
    // (e.g. web pages) for products that don't have an explicit typeFilterConfig for comments
    [(0, $7ydfN.TypeFilterValueKey).Comment]: [
        (0, $7ydfN.NounSubtypeKey).Comment
    ],
    [(0, $7ydfN.TypeFilterValueKey).Image]: [
        (0, $7ydfN.NounSubtypeKey).Image
    ],
    [(0, $7ydfN.TypeFilterValueKey).Audio]: [
        (0, $7ydfN.NounSubtypeKey).Audio
    ],
    [(0, $7ydfN.TypeFilterValueKey).Pdf]: [
        (0, $7ydfN.NounSubtypeKey).Pdf
    ],
    [(0, $7ydfN.TypeFilterValueKey).Code]: [
        (0, $7ydfN.NounSubtypeKey).Code
    ],
    [(0, $7ydfN.TypeFilterValueKey).Archive]: [
        (0, $7ydfN.NounSubtypeKey).Archive
    ],
    [(0, $7ydfN.TypeFilterValueKey).Folder]: [
        (0, $7ydfN.NounSubtypeKey).Folder
    ],
    [(0, $7ydfN.TypeFilterValueKey).Shortcut]: [
        (0, $7ydfN.NounSubtypeKey).Shortcut
    ],
    [(0, $7ydfN.TypeFilterValueKey).Form]: [
        (0, $7ydfN.NounSubtypeKey).Form
    ],
    [(0, $7ydfN.TypeFilterValueKey).Notebook]: [
        (0, $7ydfN.NounSubtypeKey).Notebook
    ],
    [(0, $7ydfN.TypeFilterValueKey).Other]: [
        (0, $7ydfN.NounSubtypeKey).Other
    ],
    [(0, $7ydfN.TypeFilterValueKey).WebPage]: [
        (0, $7ydfN.NounSubtypeKey).WebPage
    ],
    [(0, $7ydfN.TypeFilterValueKey).Dashboard]: [
        (0, $7ydfN.NounSubtypeKey).Dashboard
    ],
    [(0, $7ydfN.TypeFilterValueKey).Database]: [
        (0, $7ydfN.NounSubtypeKey).Database
    ]
};
const $f7c0c65da85b02e9$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: false,
            contentStatuses: [],
            containerStatus: []
        },
        loomFilters: {
            spaceIds: [],
            folderIds: [],
            tagNames: []
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: []
            },
            objectTypeFilter: {
                typeARIs: []
            }
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                projectARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: {
            owners: [],
            focusAreaTypeIds: [],
            ancestorIds: []
        },
        talentFilters: {
            owners: [],
            employmentTypes: [],
            focusAreas: [],
            jobFamilies: [],
            statuses: [],
            teams: []
        },
        compassFilters: {
            componentFilter: {
                componentStates: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: [],
            createdBy: [],
            lastUpdatedBy: [],
            assignees: [],
            labels: []
        },
        sortFilters: []
    });
const $f7c0c65da85b02e9$var$DATE_RANGE_PRESETS = [
    {
        name: 'today',
        fromOffset: 0,
        toOffset: 0
    },
    {
        name: 'yesterday',
        fromOffset: 1,
        toOffset: 1
    },
    {
        name: 'past7Days',
        fromOffset: 7,
        toOffset: 0
    },
    {
        name: 'past30Days',
        fromOffset: 30,
        toOffset: 0
    },
    {
        name: 'pastYear',
        fromOffset: 365,
        toOffset: 0
    }
];
/**
 * Gets a UTC date string (YYYY-MM-DD) for a given number of days ago.
 * Uses UTC timezone to match backend date calculations.
 */ const $f7c0c65da85b02e9$var$getUTCDateString = (daysAgo)=>{
    const now = new Date();
    const utcDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - daysAgo));
    return utcDate.toISOString().split('T')[0];
};
const $f7c0c65da85b02e9$export$64e54565c5bfc685 = (dateRange)=>{
    if (!dateRange || !dateRange.gt && !dateRange.lt) return 'anytime';
    if (!dateRange.gt) return 'custom';
    const inputGtDate = dateRange.gt.split('T')[0];
    const inputLtDate = dateRange.lt?.split('T')[0];
    for (const preset of $f7c0c65da85b02e9$var$DATE_RANGE_PRESETS){
        const presetGtDate = $f7c0c65da85b02e9$var$getUTCDateString(preset.fromOffset);
        const presetLtDate = $f7c0c65da85b02e9$var$getUTCDateString(preset.toOffset);
        if (inputGtDate === presetGtDate) {
            // If BE has also provided lt, it must match the preset's lt for this to be the preset.
            // E.g. gt='2026-02-01', lt='2026-02-03' is a custom range (Feb 1–3), not past7Days
            if (inputLtDate != null && inputLtDate !== presetLtDate) continue;
            return preset.name;
        }
    }
    return 'custom';
};
const $f7c0c65da85b02e9$var$isSupportedParticipant = (participant)=>{
    const { users: users, combination: combination, type: type } = participant;
    if (type !== 'PRESENCE') return false;
    if (users.length > 1 && combination === 'AND') return false;
    return true;
};
const $f7c0c65da85b02e9$export$ae993d8ff9dd28 = (participants)=>{
    const { items: items, combination: combination } = participants;
    if (items.length > 1 && combination === 'AND') return [];
    if (!items.every($f7c0c65da85b02e9$var$isSupportedParticipant)) return [];
    return Array.from(new Set(items.flatMap(({ users: users })=>users)));
};
const $f7c0c65da85b02e9$export$2703353a19002efe = ()=>{
    return {
        ...(0, $dEA4Z.baseIntegrationARIs)
    };
};
const $f7c0c65da85b02e9$var$isVideoNounFilterSupported = (product)=>product === (0, $4wG6Y.ProductKey).GoogleDrive || product === (0, $4wG6Y.ProductKey).Sharepoint;
const $f7c0c65da85b02e9$var$buildGitFilters = (pullRequestStatus, repoName, reviewer)=>{
    if (!pullRequestStatus?.length && !repoName?.length && !reviewer?.length) return undefined;
    return {
        gitFilters: {
            ...pullRequestStatus?.length && {
                pullRequestStatus: pullRequestStatus
            },
            ...repoName?.length && {
                repoName: repoName
            },
            ...reviewer?.length && {
                reviewer: reviewer
            }
        }
    };
};
/**
 * Build MS Teams (`teamsFilters`) wire payload.
 * - `hasAttachment` (boolean): scopes Teams results to messages with attachments.
 * - `workspaceName` (string[]): `teamsFilters.workspaceName` — filters by workspace (team) name.
 *   Gated behind `rovo_fps_show_workspace_name_filter` on the frontend and
 *   `xpsearch-aggregator_teams_workspace_name_filter` on the backend.
 * Returns `undefined` when no Teams filter is set so the caller can spread without sending an empty object.
 */ const $f7c0c65da85b02e9$var$buildTeamsFilters = (hasAttachment, workspaceName)=>{
    if (!hasAttachment && !workspaceName?.length) return undefined;
    return {
        teamsFilters: {
            ...hasAttachment && {
                hasAttachment: true
            },
            ...workspaceName?.length && {
                workspaceName: workspaceName
            }
        }
    };
};
const $f7c0c65da85b02e9$var$filterConnectorSources = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    if (product === (0, $4wG6Y.ProductKey).Slack && (0, $cJff5.serveFederatedOnlySlackInAllProductSearch)(thirdPartyConfigs, isAllProductSearch)) // Slack federated results are served only through the federated box, so SmartLinks is not
    // requested (its data goes stale once an admin enables federated).
    return [
        (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE)
    ];
    if (product === (0, $4wG6Y.ProductKey).Slack && (0, $cJff5.removeFedSlackFromAllProductSearch)(thirdPartyConfigs, isAllProductSearch)) // When a federated Slack connector exists in all-product search,
    // exclude both 'federated' and 'smartlinks' connector sources so that
    // only the federated connector serves results in that context.
    return connectorSources?.filter((s)=>s !== (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) && (!(0, $iDrrr.fg)('ai_3p_slack_smartlinks_federated_connector_enabled') || s !== (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE)));
    return connectorSources;
};
const $f7c0c65da85b02e9$var$getConnectorSourcesForRequest = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    const filteredConnectorSources = $f7c0c65da85b02e9$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    const isEligibleGoogleDriveSmartlinksConnector = product === (0, $4wG6Y.ProductKey).GoogleDrive && filteredConnectorSources?.length === 1 && filteredConnectorSources[0] === (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE) && thirdPartyConfigs[(0, $4wG6Y.ProductKey).GoogleDrive]?.userNeedsOAuth === false;
    if (isEligibleGoogleDriveSmartlinksConnector && (0, $cJff5.enableFederatedSearchForGoogleDrive)()) return [
        ...filteredConnectorSources,
        (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE)
    ];
    const isEligibleSharepointSmartlinksConnector = product === (0, $4wG6Y.ProductKey).Sharepoint && filteredConnectorSources?.length === 1 && filteredConnectorSources[0] === (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE) && thirdPartyConfigs[(0, $4wG6Y.ProductKey).Sharepoint]?.userNeedsOAuth === false;
    if (isEligibleSharepointSmartlinksConnector && (0, $cJff5.enableFederatedSearchForSharepoint)()) return [
        ...filteredConnectorSources,
        (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE)
    ];
    return filteredConnectorSources;
};
const $f7c0c65da85b02e9$var$hasConnectorSources = (product, isAllProductSearch, thirdPartyConfigs)=>{
    const connectorSources = thirdPartyConfigs[product]?.connectorSources;
    const filteredConnectorSources = $f7c0c65da85b02e9$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    return (filteredConnectorSources?.length ?? 0) > 0;
};
const $f7c0c65da85b02e9$export$3766c9ce0c94452 = (products, titleMatchValue, // entities is the frontend filtered, already selected values
entities, thirdPartyConfigs, isAllProductSearch = true, range, assignees, containerAris, createdBy, lastUpdatedBy, ancestorAris, labels, additionalTexts, selectedDatasource, salesforceOwners, salesforceStage, salesforceCloseDate, opportunityStatus, pullRequestStatus, repoName, campaignStatuses, caseStatuses, slackChannels, hasAttachment, workspaceName, reviewer, knowledgeArticlePublishStatuses, eventTypes, leadStatuses, taskStatuses, taskTypes)=>{
    if (!products.length || products.some((p)=>(0, $dvVWp.is3pProductKey)(p) || (0, $8fNUp.isForgeConnectorProductKey)(p) || p === (0, $4wG6Y.ProductKey).Bitbucket)) {
        // Conditionally create the dynamic integration ARIs based on the config
        const integrationARIsFromConfig = $f7c0c65da85b02e9$export$2703353a19002efe();
        // Combine static and dynamic integration ARIs
        let productToIntegrationARIMap = integrationARIsFromConfig;
        // Add Forge connector integration ARIs from thirdPartyConfigs
        products.forEach((product)=>{
            if ((0, $8fNUp.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]) {
                const integrationAri = thirdPartyConfigs[product]?.integrationAri;
                productToIntegrationARIMap[product] = integrationAri;
            }
        });
        // Note: Bitbucket integration ARI is already included in baseIntegrationARIs
        // get the subtypes by looking at each type's subcategories
        let allSubtypes = [];
        let allContainerTypes = [];
        let thirdPartyProducts = [];
        const filteredProducts = products.filter((product)=>((0, $dvVWp.is3pProductKey)(product) || (0, $8fNUp.isForgeConnectorProductKey)(product)) && thirdPartyConfigs[product] !== undefined && (!thirdPartyConfigs[product]?.userNeedsOAuth || $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs)) && !thirdPartyConfigs[product]?.isFederated && $f7c0c65da85b02e9$var$hasConnectorSources(product, isAllProductSearch, thirdPartyConfigs)).filter((product)=>{
            return thirdPartyConfigs[product]?.isEnabled?.();
        });
        // Products that support embedded comments (comments are returned as linkedEntities within documents)
        const productsWithEmbeddedComments = [
            (0, $4wG6Y.ProductKey).GoogleDrive,
            (0, $4wG6Y.ProductKey).Sharepoint
        ];
        // Must agree with `includeCodeSearch` in search-query-generator, or the payload and the
        // Relay directive diverge.
        const codeSearchScope = (0, $coUcA.getCodeSearchScope)({
            products: products,
            selectedTypes: entities,
            isAllProductSearch: isAllProductSearch,
            codeHostProductKeys: (0, $dvVWp.CODE_HOST_PRODUCT_KEYS),
            githubProductKeys: (0, $dvVWp.GITHUB_PRODUCT_KEYS)
        });
        const bitbucketCodeEntities = $f7c0c65da85b02e9$var$BITBUCKET_ENTITIES_BY_CODE_SEARCH_SCOPE[codeSearchScope];
        for (let product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig) continue;
            const isGithubProduct = (0, $dvVWp.GITHUB_PRODUCT_KEYS).includes(product);
            const shouldSkipDocumentForGithub = isGithubProduct && codeSearchScope === 'none';
            let localSubtypes = [];
            let productEntities = [];
            let connectionIds;
            let linkedEntityGranularity;
            // Check if Comment filter is selected for a product that supports embedded comments.
            // Each product is gated behind its own feature flag so support can be toggled
            // independently:
            //   - Google Drive: enable_3p_embedded_comments_search
            //   - SharePoint:   rovo_fps_sharepoint_embedded_comments
            const isCommentFilterSelected = entities.includes((0, $7ydfN.TypeFilterValueKey).Comment);
            const isEmbeddedCommentsEnabledForProduct = product === (0, $4wG6Y.ProductKey).GoogleDrive && (0, $iDrrr.fg)('enable_3p_embedded_comments_search') || product === (0, $4wG6Y.ProductKey).Sharepoint && (0, $iDrrr.fg)('rovo_fps_sharepoint_embedded_comments');
            const supportsEmbeddedComments = productsWithEmbeddedComments.includes(product);
            if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct) // Use ONLY_LINKED_ENTITIES to force match only on comments.
            // Note: linkedEntities input is deprecated and ignored by the aggregator —
            // linkedEntityGranularity alone controls this behaviour.
            linkedEntityGranularity = 'ONLY_LINKED_ENTITIES';
            // Check if the product has specific typeFilterConfig for the requested entities
            let hasMatchingTypeConfig = false;
            thirdPartyConfig.typeFilterConfig?.forEach((entitiesConfig, entityValue)=>{
                if (entities.includes(entityValue)) {
                    localSubtypes = [
                        ...localSubtypes,
                        ...entitiesConfig.subTypes3P
                    ];
                    hasMatchingTypeConfig = true;
                }
            });
            // Extract all entities from typeFilterConfig for this product
            if (thirdPartyConfig.typeFilterConfig) {
                thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                    if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $7ydfN.TypeFilterValueKey).Comment) return;
                    if (shouldSkipDocumentForGithub && entityValue === (0, $7ydfN.TypeFilterValueKey).Document) return;
                    const shouldFilterByType = $f7c0c65da85b02e9$var$isVideoNounFilterSupported(product) && // entities.length > 0 ensures we only filter when specific types are selected;
                    // when "All" is selected, entities is empty and we fall through to the else branch
                    entities.length > 0;
                    if (shouldFilterByType) {
                        if (entities.includes(entityValue)) productEntities = [
                            ...productEntities,
                            ...entitiesConfig.entities3P
                        ];
                    } else // When entities is empty (All selected), include all entities from the config
                    productEntities = [
                        ...productEntities,
                        ...entitiesConfig.entities3P
                    ];
                });
                productEntities = [
                    ...new Set(productEntities)
                ];
            }
            // Capture connectionId when present (dynamic Forge connectors)
            if (thirdPartyConfig.connectionId) connectionIds = [
                thirdPartyConfig.connectionId
            ];
            // If no specific typeFilterConfig matched, use default subtypes for the entities
            if (!hasMatchingTypeConfig && entities.length > 0) entities.forEach((entity)=>{
                const defaultSubtypes = $f7c0c65da85b02e9$var$DEFAULT_ENTITY_SUBTYPES[entity] ?? [];
                if (defaultSubtypes.length > 0) localSubtypes = [
                    ...localSubtypes,
                    ...defaultSubtypes
                ];
            });
            // Add local subtypes to the global subtypes array and remove duplicates
            allSubtypes = [
                ...new Set([
                    ...allSubtypes,
                    ...localSubtypes
                ])
            ];
            const integrationId = thirdPartyConfig.integrationAri;
            const providerId = thirdPartyConfig.providerId;
            const connectorSources = $f7c0c65da85b02e9$var$getConnectorSourcesForRequest(product, isAllProductSearch, thirdPartyConfigs, thirdPartyConfig.connectorSources);
            // Impersonation logging: surface, per connector source, which sources are served via
            // impersonation (user NOT OAuthed AND impersonation enabled for that source) so the
            // aggregator can observe impersonated request success/failure. Resolved per connector
            // source because a product can expose multiple sources where impersonation is only
            // enabled for some of them.
            const connectorSourcesImpersonationEnabled = $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) ? $f7c0c65da85b02e9$var$getImpersonatedConnectorSources(thirdPartyConfig, connectorSources) : undefined;
            product = product === (0, $4wG6Y.ProductKey).JsmDC ? (0, $4wG6Y.ProductKey).JiraDC : product;
            // Only fan out per-datasource when a specific datasource is selected, OR when
            // getFiltersForSelectedDatasources affects thirdPartyProduct routing (e.g. Jira DC
            // sets a per-instance integrationId/providerId). For webcrawler, when "All" is
            // selected, all datasource entries would be identical (same integrationId, same
            // filters) — causing N duplicate requests to the search backend. Instead, fall
            // through to the single-entry else branch below.
            const shouldFanOut = thirdPartyConfig.datasources && thirdPartyConfig.fanOutConnectorSources && (!!selectedDatasource || product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler);
            if (shouldFanOut && thirdPartyConfig.datasources) {
                const datasourcesForQuery = selectedDatasource ? thirdPartyConfig.datasources.filter((ds)=>ds.datasourceId === selectedDatasource) : thirdPartyConfig.datasources;
                for (const datasourceConfig of datasourcesForQuery){
                    const datasourceContainerTypes = datasourceConfig.containerTypes || [];
                    allContainerTypes = [
                        ...new Set([
                            ...allContainerTypes,
                            ...datasourceContainerTypes
                        ])
                    ];
                    const thirdPartyProductFilterForThisProduct = {
                        integrationId: integrationId,
                        subtypes: localSubtypes,
                        providerId: providerId,
                        product: product,
                        connectorSources: connectorSources,
                        ...connectorSourcesImpersonationEnabled && {
                            connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                        },
                        ...productEntities.length > 0 && {
                            entities: productEntities
                        },
                        ...connectionIds && {
                            connectionIds: connectionIds
                        },
                        ...linkedEntityGranularity && {
                            linkedEntityGranularity: linkedEntityGranularity
                        }
                    };
                    // For webcrawler (flag ON), getFiltersForSelectedDatasources returns only { additionalTexts }
                    // with no thirdPartyProduct key, so allFilters?.thirdPartyProduct is always undefined for
                    // webcrawler — the else branch always runs and additionalTexts is discarded here.
                    // The webcrawler's additionalTexts is correctly accumulated in the datasourceFilters loop below,
                    // making this call a no-op for webcrawler. Only thirdPartyProduct is consumed in this code path.
                    const allFilters = product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler || (0, $iDrrr.fg)('webcrawler-fanout-ui-sidebar-enabled') ? thirdPartyConfig.getFiltersForSelectedDatasources?.(datasourceConfig, {}) : undefined;
                    if (allFilters?.thirdPartyProduct) thirdPartyProducts.push({
                        ...thirdPartyProductFilterForThisProduct,
                        ...allFilters.thirdPartyProduct
                    });
                    else thirdPartyProducts.push(thirdPartyProductFilterForThisProduct);
                }
            } else thirdPartyProducts.push({
                integrationId: integrationId,
                subtypes: localSubtypes,
                providerId: providerId,
                product: product,
                connectorSources: connectorSources,
                ...connectorSourcesImpersonationEnabled && {
                    connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                },
                ...productEntities.length > 0 && {
                    entities: productEntities
                },
                ...connectionIds && {
                    connectionIds: connectionIds
                },
                ...linkedEntityGranularity && {
                    linkedEntityGranularity: linkedEntityGranularity
                }
            });
        }
        if (thirdPartyProducts) {
            // Add Loom and Bitbucket to the thirdPartyProducts filter
            const firstPartyProductsFor3pFilters = [
                (0, $4wG6Y.ProductKey).Loom,
                (0, $4wG6Y.ProductKey).Bitbucket
            ];
            const result = firstPartyProductsFor3pFilters.filter((product)=>products.includes(product) && !thirdPartyProducts?.some((p)=>p.product === product)).map((product)=>({
                    integrationId: productToIntegrationARIMap[product] || '',
                    subtypes: allSubtypes,
                    product: product,
                    connectorSources: [
                        (0, $8fNUp.FULL_CONNECTOR_SOURCE)
                    ],
                    // Bitbucket is first-party, so it has no connector config to derive these from.
                    ...product === (0, $4wG6Y.ProductKey).Bitbucket && bitbucketCodeEntities && {
                        entities: bitbucketCodeEntities
                    }
                }));
            thirdPartyProducts = thirdPartyProducts.concat(result);
        }
        // Slack channels filter — Slack is a federated product, so it is excluded from the
        // `filteredProducts` loop above (federated products are filtered out). To pass selected
        // Slack channels to the aggregator, we attach them to a Slack `thirdPartyProducts` entry
        // here, either by mutating an existing entry (non-federated case) or by adding a new entry.
        if (slackChannels?.length) {
            const slackConfig = thirdPartyConfigs[(0, $4wG6Y.ProductKey).Slack];
            if (slackConfig) {
                const existingSlackEntry = thirdPartyProducts.find((p)=>p.product === (0, $4wG6Y.ProductKey).Slack);
                if (existingSlackEntry) existingSlackEntry.channels = slackChannels;
                else thirdPartyProducts.push({
                    integrationId: slackConfig.integrationAri || '',
                    subtypes: [],
                    providerId: slackConfig.providerId,
                    product: (0, $4wG6Y.ProductKey).Slack,
                    connectorSources: $f7c0c65da85b02e9$var$filterConnectorSources((0, $4wG6Y.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs, slackConfig.connectorSources || []),
                    channels: slackChannels
                });
            }
        }
        const createdByFilterField = {
            createdBy: createdBy || []
        };
        const lastUpdatedByFilterField = {
            lastUpdatedBy: lastUpdatedBy || []
        };
        // Labels filter is only applicable to Confluence (incl. Confluence DC).
        const isConfluenceProduct = products.includes((0, $dvVWp.ProductKeys).Confluence) || products.includes((0, $dvVWp.ProductKeys).ConfluenceDC);
        const labelsFilterField = isConfluenceProduct ? {
            labels: labels || []
        } : {};
        const containerTypes = thirdPartyProducts.length !== 1 ? [] : allContainerTypes;
        const excludeSubtypes = [];
        const isTeamsProduct = products.includes((0, $dvVWp.ProductKeys).Teams);
        const isAttachmentTypeSelected = entities.includes((0, $7ydfN.TypeFilterValueKey).Attachment);
        const teamsFilters = $f7c0c65da85b02e9$var$buildTeamsFilters(isTeamsProduct && (isAttachmentTypeSelected || hasAttachment), isTeamsProduct ? workspaceName : undefined)?.teamsFilters;
        let datasourceFilters = {
            additionalTexts: additionalTexts || []
        };
        if (selectedDatasource) for (const product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig?.getFiltersForSelectedDatasources || !thirdPartyConfig.fanOutConnectorSources) continue;
            if (thirdPartyConfig.datasources) {
                const datasourceForQuery = thirdPartyConfig.datasources.find((ds)=>ds.datasourceId === selectedDatasource);
                if (datasourceForQuery) {
                    if (product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler || (0, $iDrrr.fg)('webcrawler-fanout-ui-sidebar-enabled')) datasourceFilters = thirdPartyConfig.getFiltersForSelectedDatasources(datasourceForQuery, datasourceFilters) ?? datasourceFilters;
                }
            }
        }
        const { additionalTexts: mergedAdditionalTexts = [], ...otherDatasourceFilters } = datasourceFilters;
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>// Non-3P products pass through
                !(0, $dvVWp.is3pProductKey)(product) && !(0, $8fNUp.isForgeConnectorProductKey)(product) || // 3P products must be enabled and not require OAuth (or have impersonation)
                thirdPartyConfigs[product]?.isEnabled?.() !== false && (!thirdPartyConfigs[product]?.userNeedsOAuth || $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs))).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)// remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            })// Include Slack integration ARI only when Slack has at least one connector source (after filtering)
            .filter((ari)=>ari !== productToIntegrationARIMap[(0, $4wG6Y.ProductKey).Slack] || $f7c0c65da85b02e9$var$hasConnectorSources((0, $4wG6Y.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs));
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $XRj3F.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length || knowledgeArticlePublishStatuses?.length || eventTypes?.length || leadStatuses?.length || taskStatuses?.length || taskTypes?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                },
                ...knowledgeArticlePublishStatuses?.length && {
                    knowledgeArticlePublishStatuses: knowledgeArticlePublishStatuses
                },
                ...eventTypes?.length && {
                    eventTypes: eventTypes
                },
                ...leadStatuses?.length && {
                    leadStatuses: leadStatuses
                },
                ...taskStatuses?.length && {
                    taskStatuses: taskStatuses
                },
                ...taskTypes?.length && {
                    taskTypes: taskTypes
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: integrationARIs,
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$f7c0c65da85b02e9$var$buildGitFilters(pullRequestStatus, repoName, reviewer),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        } else {
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $XRj3F.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length || knowledgeArticlePublishStatuses?.length || eventTypes?.length || leadStatuses?.length || taskStatuses?.length || taskTypes?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                },
                ...knowledgeArticlePublishStatuses?.length && {
                    knowledgeArticlePublishStatuses: knowledgeArticlePublishStatuses
                },
                ...eventTypes?.length && {
                    eventTypes: eventTypes
                },
                ...leadStatuses?.length && {
                    leadStatuses: leadStatuses
                },
                ...taskStatuses?.length && {
                    taskStatuses: taskStatuses
                },
                ...taskTypes?.length && {
                    taskTypes: taskTypes
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: [],
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$f7c0c65da85b02e9$var$buildGitFilters(pullRequestStatus, repoName, reviewer),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        }
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $f7c0c65da85b02e9$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $f7c0c65da85b02e9$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    const now = new Date();
    if (dateFrom > now) return "fromInFutureError";
    if (dateFrom > dateTo) return "fromAfterToError";
    if (dateTo > now) return "toInFutureError";
    return null;
};
const $f7c0c65da85b02e9$export$ef6dfb919b1d7267 = (0, $c194c673aa4ee214$export$ef6dfb919b1d7267);
const $f7c0c65da85b02e9$export$b29ea735dcfba3c1 = (value)=>{
    return value !== null && value !== undefined;
};
const $f7c0c65da85b02e9$export$9c38ca92ec6e6d40 = (product, thirdPartyConfigs)=>{
    const productConfig = thirdPartyConfigs[product];
    const impersonationEnabled = product === (0, $4wG6Y.ProductKey).Sharepoint ? (0, $cwPfG.hasImpersonatedFullConnector)(product, thirdPartyConfigs) : productConfig?.impersonationEnabled;
    return !!(impersonationEnabled && (product === (0, $4wG6Y.ProductKey).GoogleDrive || product === (0, $4wG6Y.ProductKey).Github || product === (0, $4wG6Y.ProductKey).Sharepoint && (0, $cJff5.serveSharepointImpersonatedSearchExpWithoutExposure)() || product === (0, $4wG6Y.ProductKey).Teams && (0, $cJff5.serveTeamsImpersonatedSearchExpWithoutExposure)()));
};
/**
 * Derives the single connector source backing a datasource config, mirroring the resolution used
 * when building the product's `connectorSources` list (smartlinks / lite / federated / full).
 */ const $f7c0c65da85b02e9$var$getDatasourceConnectorSource = (datasource)=>{
    const resourceType = datasource.resourceType;
    // Without a resourceType the backing connector source cannot be determined, so contribute
    // nothing rather than guessing. This mirrors rovo-connectors-config's `getConnectorSources`,
    // which early-returns `[]` for this case, keeping both FPS/QF and agent-studio builders in sync.
    if (!resourceType) return undefined;
    if (resourceType.startsWith((0, $8fNUp.SMARTLINKS_RESOURCE_TYPE_PREFIX))) return 0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE;
    if (resourceType.startsWith((0, $8fNUp.LITE_CONNECTOR_SOURCE_PREFIX))) return 0, $8fNUp.LITE_CONNECTOR_SOURCE;
    // Slack federated status is driven by `connectorSyncType` rather than the static `isFederated`
    // flag. Mirror the canonical derivation in controllers/config/utils/third-party-products.ts so a
    // federated Slack datasource resolves to FEDERATED (not FULL). `connectorSyncType` is present on
    // the datasource at runtime (spread from the raw resource) but not on the typed config shape.
    if (datasource.id === (0, $dvVWp.ProductKeys).Slack && (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled')) {
        const connectorSyncType = datasource.connectorSyncType;
        return connectorSyncType === 'federated' ? (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) : (0, $8fNUp.FULL_CONNECTOR_SOURCE);
    }
    if (datasource.isFederated) return 0, $8fNUp.FEDERATED_CONNECTOR_SOURCE;
    return 0, $8fNUp.FULL_CONNECTOR_SOURCE;
};
/**
 * Returns the subset of `connectorSources` that are served via impersonation for this product.
 *
 * Impersonation is resolved per connector source (each backing datasource maps to a single
 * connector source) rather than at the product level, because a product can expose multiple
 * connector sources (e.g. `smartlinks` + `full-connector`) where impersonation is only enabled
 * for some of them. A connector source is considered impersonated when its datasource has the
 * user NOT OAuthed (`userNeedsOAuth === true`) AND impersonation enabled (`impersonationEnabled`).
 *
 * The result is restricted to sources actually present in the product's `connectorSources` and is
 * deduped while preserving the order of `connectorSources`. Returns `undefined` when no connector
 * source is impersonated.
 */ const $f7c0c65da85b02e9$var$getImpersonatedConnectorSources = (thirdPartyConfig, connectorSources)=>{
    if (!connectorSources?.length) return undefined;
    const impersonatedSources = new Set();
    const datasources = thirdPartyConfig.datasources?.length ? thirdPartyConfig.datasources : [
        thirdPartyConfig
    ];
    for (const datasource of datasources)if (datasource.userNeedsOAuth && datasource.impersonationEnabled) {
        const source = $f7c0c65da85b02e9$var$getDatasourceConnectorSource(datasource);
        if (source) impersonatedSources.add(source);
    }
    if (!impersonatedSources.size) return undefined;
    const result = connectorSources.filter((source)=>impersonatedSources.has(source));
    return result.length ? result : undefined;
};
module.exports["getEmptySelectedFilters"] = $f7c0c65da85b02e9$export$b7b676578c62639d;
module.exports["getThirdPartyFilters"] = $f7c0c65da85b02e9$export$3766c9ce0c94452;
module.exports["isImpersonationEnabled"] = $f7c0c65da85b02e9$export$9c38ca92ec6e6d40;
module.exports["DateRangeError"] = $f7c0c65da85b02e9$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $f7c0c65da85b02e9$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $f7c0c65da85b02e9$export$ef6dfb919b1d7267;
module.exports["notEmpty"] = $f7c0c65da85b02e9$export$b29ea735dcfba3c1;

});

parcelRegister("fOh5X", function(module, exports) {
const $a6b73fbb01a0c4a5$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $a6b73fbb01a0c4a5$export$d520529b4595d46c;

});

parcelRegister("XRj3F", function(module, exports) {
// these are values for the query params
// oxlint-disable-next-line eslint/no-redeclare
const $25241466e474a32c$export$d76b5866ae4061c8 = {
    Open: 'open',
    Closed: 'closed'
};
const $25241466e474a32c$export$ff1c9ca0ad19eecd = Object.values($25241466e474a32c$export$d76b5866ae4061c8);
const $25241466e474a32c$export$9e65f1e3288fbede = {
    [$25241466e474a32c$export$d76b5866ae4061c8.Open]: false,
    [$25241466e474a32c$export$d76b5866ae4061c8.Closed]: true
};
module.exports["allOpportunityStatusFilterValueKeys"] = $25241466e474a32c$export$ff1c9ca0ad19eecd;
module.exports["OpportunityStatusFilterValue"] = $25241466e474a32c$export$9e65f1e3288fbede;

});

parcelRegister("gPOtu", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $cJff5 = parcelRequire("cJff5");


var $cwPfG = parcelRequire("cwPfG");

/**
 * Products for which 3LO (user OAuth) has been removed.
 * The Connect button will be hidden for these products when the admin has
 * configured a full connector, since the user no longer needs to authenticate.
 * Add more product keys here as 3LO removal is completed for each product.
 */ const $2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL = new Set([
    (0, $fR63l.ProductKeys3P).GoogleDrive,
    (0, $fR63l.ProductKeys3P).Github
]);
const $2298d11be5d540f9$var$shouldTreatImpersonatedFullConnectorAsConnected = (productKey)=>{
    if (productKey === (0, $dvVWp.ProductKeys).Teams) return (0, $cJff5.serveTeamsImpersonatedSearchExpWithoutExposure)();
    if (productKey === (0, $dvVWp.ProductKeys).Sharepoint) return (0, $cJff5.serveSharepointImpersonatedSearchExpWithoutExposure)();
    return $2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL.has(productKey) && (0, $iDrrr.fg)('ai_3p_remove_connect_button_for_allowlist_product');
};
// `connectorSyncType` and `type` are spread onto each datasource from the raw API resource but are
// absent from the typed shape, hence the casts. Same precedent as `getDatasourceConnectorSource`.
const $2298d11be5d540f9$var$isFederatedDatasource = (datasource)=>datasource.connectorSyncType === (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
// Must read `type`, not `resourceType`: the latter is inherited from the static Slack config and
// reads `slack-connector` for both variants.
const $2298d11be5d540f9$var$isSmartlinksDatasource = (datasource)=>datasource.type?.startsWith((0, $8fNUp.SMARTLINKS_RESOURCE_TYPE_PREFIX)) ?? false;
const $2298d11be5d540f9$export$b8781914c72600e0 = (productKey, thirdPartyConfigs)=>{
    if (productKey !== (0, $fR63l.ProductKeys3P).Slack) return undefined;
    const datasources = thirdPartyConfigs[(0, $fR63l.ProductKeys3P).Slack]?.datasources;
    const federatedDatasource = datasources?.find($2298d11be5d540f9$var$isFederatedDatasource);
    if (!federatedDatasource || !datasources?.some($2298d11be5d540f9$var$isSmartlinksDatasource)) return undefined;
    // Gate last so the exposure is scoped to the affected population.
    return (0, $iDrrr.fg)('ai_3p_slack_federated_connect_cta_enabled') ? federatedDatasource : undefined;
};
const $2298d11be5d540f9$export$baed88e51744500d = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return false;
    const productConfig = thirdPartyConfigs[productKey];
    return Boolean(productConfig?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) && productConfig.datasources?.some((datasource)=>datasource.authResolutionMode === (0, $8fNUp.AUTH_RESOLUTION_MODE_ADMIN_IMPORTED)) && // Gate last so the exposure is scoped to the affected population.
    (0, $iDrrr.fg)('ai_3p_cds_auth_resolution_mode_flock'));
};
const $2298d11be5d540f9$export$afbf493cb9e90bce = 'UNKNOWN';
const $2298d11be5d540f9$export$cd9df35ad8012058 = ({ datasourceId: datasourceId, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const productConfig = productKey ? thirdPartyConfigs[productKey] : undefined;
    if (datasourceId) {
        // Scoped to the product when known so a datasource id cannot resolve against an unrelated
        // product; without a product key the whole config is the only place left to look.
        const datasources = productKey ? productConfig?.datasources : Object.values(thirdPartyConfigs).flatMap((config)=>config?.datasources ?? []);
        const matchedDatasource = datasources?.find((datasource)=>datasource?.datasourceId === datasourceId);
        if (matchedDatasource?.authResolutionMode) return matchedDatasource.authResolutionMode;
    }
    return productConfig?.authResolutionMode ?? $2298d11be5d540f9$export$afbf493cb9e90bce;
};
const $2298d11be5d540f9$export$a3e2d74740ffbb74 = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return true;
    const productConfig = thirdPartyConfigs[productKey];
    if (!productConfig) {
        // For allowlisted products with the gate ON, treat missing config as not connected
        // (the API returned no resource for this product, so no full connector is configured)
        if ($2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL.has(productKey) && (0, $iDrrr.fg)('ai_3p_remove_connect_button_for_allowlist_product') // must be last for exposure tracking
        ) return false;
        return true;
    }
    // Forge connector configs carry OAuth state at the product level and have no
    // `datasources`, so the datasource-based derivation below would always report
    // them as not connected.
    if ((0, $8fNUp.isForgeConnectorProductKey)(productKey) && (0, $iDrrr.fg)('rovo_fps_enable_lite_forge_connectors')) return productConfig.userNeedsOAuth === false;
    // Full connector admin-configured AND impersonation enabled → no user OAuth needed for products with 3LO removed
    // Check datasources directly rather than product config root, since impersonationEnabled at the
    // product config level is overwritten by the last resource processed and may be stale.
    // SmartLinks/lite-connector resources never have impersonationEnabled: true, so checking any
    // datasource is safe and effectively scopes to full-connector resources only.
    if ((0, $cwPfG.hasImpersonatedFullConnector)(productKey, thirdPartyConfigs) && $2298d11be5d540f9$var$shouldTreatImpersonatedFullConnectorAsConnected(productKey)) return true;
    if ($2298d11be5d540f9$export$baed88e51744500d(productKey, thirdPartyConfigs)) return true;
    const preferredDatasource = $2298d11be5d540f9$export$b8781914c72600e0(productKey, thirdPartyConfigs);
    if (preferredDatasource) return !preferredDatasource.userNeedsOAuth;
    return productConfig.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $2298d11be5d540f9$export$edde6dcae8734ece = ({ productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const product3PConfig = productKey && (0, $dvVWp.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
    return product3PConfig?.connectorSources?.length === 1 && product3PConfig.connectorSources[0] === (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE);
};
module.exports["getPreferredConnectorDatasource"] = $2298d11be5d540f9$export$b8781914c72600e0;
module.exports["hasAdminImportedUserLink"] = $2298d11be5d540f9$export$baed88e51744500d;
module.exports["getAuthResolutionMode"] = $2298d11be5d540f9$export$cd9df35ad8012058;
module.exports["isProductConnected"] = $2298d11be5d540f9$export$a3e2d74740ffbb74;
module.exports["isProductSmartlink"] = $2298d11be5d540f9$export$edde6dcae8734ece;

});

parcelRegister("cwPfG", function(module, exports) {

var $8fNUp = parcelRequire("8fNUp");

const $0f73ee7ec0e2ef24$export$c18564611c3e5263 = (productKey, thirdPartyConfigs)=>{
    const productConfig = thirdPartyConfigs[productKey];
    return Boolean(productConfig?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) && productConfig.datasources?.some((datasource)=>datasource?.impersonationEnabled === true));
};
module.exports["hasImpersonatedFullConnector"] = $0f73ee7ec0e2ef24$export$c18564611c3e5263;

});

parcelRegister("2gvXK", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $coUcA = parcelRequire("coUcA");


var $fOh5X = parcelRequire("fOh5X");


var $2ePuQ = parcelRequire("2ePuQ");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");

/**
 * A mapping between 1P Products
 * - ProductKey1P e.g. 'confluence'
 *
 * UI values for the type filter
 * - TypeFilterKey e.g. 'Spreadsheet'
 *
 * and entities to request from Aggregator
 *
 * - ATIString[] e.g. ['ati:cloud:confluence:blogpost']
 */ const $0cf7d20479cc2c1f$var$typeFilter1PMapping = new Map([
    [
        (0, $dvVWp.ProductKeys).Confluence,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Slide,
                [
                    'ati:cloud:confluence:slide'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Calendar,
                [
                    (0, $2ePuQ.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $2ePuQ.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Question,
                [
                    (0, $2ePuQ.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Answer,
                [
                    (0, $2ePuQ.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Gliffy,
                [
                    (0, $2ePuQ.CONFLUENCE_GLIFFY_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Jira,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Epic,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Bug,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Story,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Task,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Subtask,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Incident,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).CustomerServiceManagement,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Compass,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Focus,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).FocusArea,
                [
                    'ati:cloud:mercury:focus-area',
                    'ati:cloud:mercury:focus-area-status-update'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Talent,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Position,
                [
                    'ati:cloud:radar:position'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Trello,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Atlas,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Assets,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).AssetsObject,
                [
                    'ati:cloud:cmdb:object'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Schema,
                [
                    'ati:cloud:cmdb:schema'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Type,
                [
                    'ati:cloud:cmdb:type'
                ]
            ]
        ])
    ]
]);
const $0cf7d20479cc2c1f$export$3e4eb96407c5e8d2 = [
    ...new Set(Array.from($0cf7d20479cc2c1f$var$typeFilter1PMapping.get((0, $dvVWp.ProductKeys).Bitbucket)?.values() ?? []).flat())
];
const $0cf7d20479cc2c1f$var$nativeLoomTypeMapping = new Map([
    [
        (0, $7ydfN.TypeFilterValueKey).AsyncVideo,
        [
            'ati:cloud:loom:video'
        ]
    ],
    [
        (0, $7ydfN.TypeFilterValueKey).MeetingRecording,
        [
            'ati:cloud:loom:video'
        ]
    ],
    [
        (0, $7ydfN.TypeFilterValueKey).Playlist,
        [
            'ati:cloud:loom:playlist'
        ]
    ],
    [
        (0, $7ydfN.TypeFilterValueKey).Tag,
        [
            'ati:cloud:loom:tag'
        ]
    ],
    [
        (0, $7ydfN.TypeFilterValueKey).Space,
        [
            'ati:cloud:loom:space'
        ]
    ],
    [
        (0, $7ydfN.TypeFilterValueKey).Folder,
        [
            'ati:cloud:loom:folder'
        ]
    ]
]);
const $0cf7d20479cc2c1f$export$a185da63aca613f3 = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:attachment'
];
const $0cf7d20479cc2c1f$export$598e74d591895feb = ()=>[
        ...$0cf7d20479cc2c1f$export$a185da63aca613f3
    ];
let $0cf7d20479cc2c1f$export$1a2d7de20763c66f;
const $0cf7d20479cc2c1f$export$4b1ab8c60d2ecbf1 = ()=>{
    $0cf7d20479cc2c1f$export$1a2d7de20763c66f = undefined; // Reset cache
};
const $0cf7d20479cc2c1f$export$a7663ee59d66492f = ()=>{
    if ($0cf7d20479cc2c1f$export$1a2d7de20763c66f) return $0cf7d20479cc2c1f$export$1a2d7de20763c66f;
    const mappings = Object.fromEntries((0, $7ydfN.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $0cf7d20479cc2c1f$var$typeFilter1PMapping.forEach((_, productKey1P)=>{
        $0cf7d20479cc2c1f$var$typeFilter1PMapping.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $0cf7d20479cc2c1f$var$typeFilter1PMapping.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Conditionally add the Ask type for Focus product. The Ask UI migration flag takes
    // precedence over the legacy Passionfruit flag so ask entities are requested from only
    // one backend (Mercury when the migration is enabled, otherwise Passionfruit).
    if ((0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled')) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].products.push((0, $dvVWp.ProductKeys).Focus);
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].entities[(0, $dvVWp.ProductKeys).Focus] = [
            'ati:cloud:mercury:ask'
        ];
    } else if ((0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled')) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].products.push((0, $dvVWp.ProductKeys).Focus);
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].entities[(0, $dvVWp.ProductKeys).Focus] = [
            'ati:cloud:passionfruit:ask'
        ];
    }
    // Conditionally add Mercury Risk type for Focus product so risk entities are only
    // requested from the backend when the risk search UI is enabled.
    if ((0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled')) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Risk].products.push((0, $dvVWp.ProductKeys).Focus);
        mappings[(0, $7ydfN.TypeFilterValueKey).Risk].entities[(0, $dvVWp.ProductKeys).Focus] = [
            'ati:cloud:mercury:risk'
        ];
    }
    // Bitbucket gains a Document type option so a Bitbucket + Document query returns code.
    if ((0, $coUcA.isCodeSearchEnabled)()) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Document].products.push((0, $dvVWp.ProductKeys).Bitbucket);
        mappings[(0, $7ydfN.TypeFilterValueKey).Document].entities[(0, $dvVWp.ProductKeys).Bitbucket] = [
            ...(0, $fOh5X.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        ];
    }
    // Add all the 3P products
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((thirdPartyConfig, productKey3P)=>{
        const typeFilterConfigs = thirdPartyConfig?.typeFilterConfig;
        if (!typeFilterConfigs) return;
        typeFilterConfigs.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
            // Zoom FPS searches should only request videos, not calendar events.
            if (productKey3P === (0, $dvVWp.ProductKeys).Zoom && typeFilterValueKey === (0, $7ydfN.TypeFilterValueKey).Calendar && (0, $iDrrr.fg)('rovo_fps_exclude_zoom_calendar_event')) return;
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = typeFilterValue3PEntities.entities3P;
            mappings[typeFilterValueKey].subCategories = [
                ...mappings[typeFilterValueKey].subCategories,
                ...typeFilterValue3PEntities.subTypes3P
            ];
            mappings[typeFilterValueKey].subCategories = [
                ...new Set(mappings[typeFilterValueKey].subCategories)
            ]; // dedupe
        });
    });
    // Keep legacy Video mapped through Loom's third-party connector. The native
    // Loom categories use Alexander ATIs only while the new contract is enabled.
    if ((0, $iDrrr.fg)('loom-rovo-search')) $0cf7d20479cc2c1f$var$nativeLoomTypeMapping.forEach((entities, typeFilterValueKey)=>{
        if (!mappings[typeFilterValueKey].products.includes((0, $dvVWp.ProductKeys).Loom)) mappings[typeFilterValueKey].products.push((0, $dvVWp.ProductKeys).Loom);
        mappings[typeFilterValueKey].entities[(0, $dvVWp.ProductKeys).Loom] = entities;
    });
    $0cf7d20479cc2c1f$export$1a2d7de20763c66f = mappings;
    return mappings;
};
const $0cf7d20479cc2c1f$export$525857063443efa8 = (productKey, typeFilterConfig)=>{
    // Ensure cache is initialized before updating it
    if (!$0cf7d20479cc2c1f$export$1a2d7de20763c66f) $0cf7d20479cc2c1f$export$a7663ee59d66492f();
    if (!typeFilterConfig || typeFilterConfig.size === 0) return;
    typeFilterConfig.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
        // Type guard: only process if it's a valid TypeFilterValueKey in our mapping
        if (!(typeFilterValueKey in $0cf7d20479cc2c1f$export$1a2d7de20763c66f)) return;
        // Only add if not already present
        if (!$0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].products.includes(productKey)) $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].products.push(productKey);
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].entities[productKey] = typeFilterValue3PEntities.entities3P;
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...$0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories,
            ...typeFilterValue3PEntities.subTypes3P
        ];
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...new Set($0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories)
        ]; // dedupe
    });
};
module.exports["BITBUCKET_TYPE_ENTITY_ATIS"] = $0cf7d20479cc2c1f$export$3e4eb96407c5e8d2;
module.exports["CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES"] = $0cf7d20479cc2c1f$export$a185da63aca613f3;
module.exports["notRequestedATIsInAllSearch"] = $0cf7d20479cc2c1f$export$598e74d591895feb;
module.exports["getTypeMapping"] = $0cf7d20479cc2c1f$export$a7663ee59d66492f;
module.exports["registerForgeConnectorTypeMapping"] = $0cf7d20479cc2c1f$export$525857063443efa8;

});

parcelRegister("2ePuQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8lpY0 = parcelRequire("8lpY0");


var $9T8TZ = parcelRequire("9T8TZ");


var $iiNGz = parcelRequire("iiNGz");


var $c8ES5 = parcelRequire("c8ES5");


























const $c7802849572bf7b6$export$a2818d866ea09b15 = 'ati:cloud:passionfruit:ask';
const $c7802849572bf7b6$export$bffcbaee92d5816f = 'ati:cloud:mercury:ask';
const $c7802849572bf7b6$export$2d73983fb684eaa8 = 'ati:cloud:mercury:risk';
const $c7802849572bf7b6$export$98b8a39f6a9e8fb2 = 'ati:cloud:mercury:organization';
const $c7802849572bf7b6$export$db327a40079b14ba = 'ati:cloud:mercury:organization-status-update';
const $c7802849572bf7b6$export$e105364f000374dd = ()=>[
        ...(0, $iiNGz.DEFAULT_MERCURY_ENTITY_ATI),
        // Ask UI migration flag takes precedence over the legacy Passionfruit flag so only one
        // Ask entity (Mercury or Passionfruit) is ever requested from the backend.
        ...(0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled') ? [
            $c7802849572bf7b6$export$bffcbaee92d5816f
        ] : (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            $c7802849572bf7b6$export$a2818d866ea09b15
        ] : [],
        ...(0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled') ? [
            $c7802849572bf7b6$export$2d73983fb684eaa8
        ] : [],
        ...(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? [
            $c7802849572bf7b6$export$98b8a39f6a9e8fb2,
            $c7802849572bf7b6$export$db327a40079b14ba
        ] : []
    ];
const $c7802849572bf7b6$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $c7802849572bf7b6$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $c7802849572bf7b6$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $c7802849572bf7b6$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $c7802849572bf7b6$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $c7802849572bf7b6$export$bcdd6265f8049b41 = 'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';
const $c7802849572bf7b6$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $c7802849572bf7b6$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $c7802849572bf7b6$export$68f33db8fcc8984d = 'ati:cloud:jira:filter';
const $c7802849572bf7b6$export$1f91fc8e40b54c58 = 'ati:cloud:jira:dashboard';
const $c7802849572bf7b6$export$b1c20fb509d2d550 = 'ati:cloud:jira:board';
const $c7802849572bf7b6$export$fdd5ab530ffed95b = 'ati:cloud:jira:plan';
const $c7802849572bf7b6$export$b4a7e1c18385196d = [
    $c7802849572bf7b6$export$2d84b48cf0a2eca6,
    $c7802849572bf7b6$export$4fb210ecd60bcccb,
    $c7802849572bf7b6$export$68f33db8fcc8984d,
    $c7802849572bf7b6$export$1f91fc8e40b54c58,
    $c7802849572bf7b6$export$b1c20fb509d2d550,
    $c7802849572bf7b6$export$fdd5ab530ffed95b
];
const $c7802849572bf7b6$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $c7802849572bf7b6$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $c7802849572bf7b6$export$50adf3273cb5cdeb = [
    $c7802849572bf7b6$export$6ec0530ffade9ab0,
    $c7802849572bf7b6$export$dfd3b612305212b4
];
const $c7802849572bf7b6$export$46827d4f79048f80 = ()=>[
        ...(0, $8lpY0.DEFAULT_ATLAS_ENTITY_ATI),
        ...(0, $9T8TZ.DEFAULT_CONFLUENCE_ENTITY_ATI),
        ...$c7802849572bf7b6$export$b4a7e1c18385196d,
        ...$c7802849572bf7b6$export$e105364f000374dd(),
        ...(0, $c8ES5.DEFAULT_TALENT_ENTITY_ATI)
    ];
const $c7802849572bf7b6$export$423da9b1dcd76b7 = 15;
const $c7802849572bf7b6$export$405ff9c6ee9ee7de = 30;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $c7802849572bf7b6$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $c7802849572bf7b6$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $c7802849572bf7b6$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $c7802849572bf7b6$export$de533c0a50cfcba1;
module.exports["CONFLUENCE_GLIFFY_ENTITY_ATI"] = $c7802849572bf7b6$export$bcdd6265f8049b41;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $c7802849572bf7b6$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $c7802849572bf7b6$export$2d84b48cf0a2eca6;
module.exports["JIRA_FILTER_ENTITY_ATI"] = $c7802849572bf7b6$export$68f33db8fcc8984d;
module.exports["JIRA_DASHBOARD_ENTITY_ATI"] = $c7802849572bf7b6$export$1f91fc8e40b54c58;
module.exports["JIRA_BOARD_ENTITY_ATI"] = $c7802849572bf7b6$export$b1c20fb509d2d550;
module.exports["JIRA_PLAN_ENTITY_ATI"] = $c7802849572bf7b6$export$fdd5ab530ffed95b;
module.exports["getDefaultEntityAti"] = $c7802849572bf7b6$export$46827d4f79048f80;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $c7802849572bf7b6$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $c7802849572bf7b6$export$405ff9c6ee9ee7de;

});

parcelRegister("dEA4Z", function(module, exports) {
/**
 * Static integration ARI mapping extracted for SSR bundle isolation.
 * No icon, config, or React imports — just pure string constants.
 *
 * This replaces the dynamic getIntegrationARIsFromConfig() function which
 * iterated ThirdPartyConfigs (pulling in 66 icon-laden config files).
 *
 * The baseIntegrationARIs map is the single source of truth for
 * ProductKey → integration ARI mappings. filters/index.ts imports and
 * re-exports from here.
 */ 
var $4wG6Y = parcelRequire("4wG6Y");

// 3P Integration ARIs
const $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $b49aac7b02131b1c$export$13bcb53a86a96b4a = 'ari:cloud:platform::integration/microsoft';
const $b49aac7b02131b1c$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $b49aac7b02131b1c$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $b49aac7b02131b1c$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $b49aac7b02131b1c$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $b49aac7b02131b1c$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $b49aac7b02131b1c$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $b49aac7b02131b1c$var$SMARTSHEET_INTEGRATION_ARI = 'ari:cloud:platform::integration/smartsheet';
const $b49aac7b02131b1c$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $b49aac7b02131b1c$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $b49aac7b02131b1c$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $b49aac7b02131b1c$var$ZENDESK_INTEGRATION_ARI = 'ari:cloud:platform::integration/zendesk';
const $b49aac7b02131b1c$var$DOCUSIGN_INTEGRATION_ARI = 'ari:cloud:platform::integration/docusign';
const $b49aac7b02131b1c$var$LUCID_INTEGRATION_ARI = 'ari:cloud:platform::integration/lucid';
const $b49aac7b02131b1c$var$MONDAY_INTEGRATION_ARI = 'ari:cloud:platform::integration/monday';
const $b49aac7b02131b1c$var$AZURE_DEVOPS_INTEGRATION_ARI = 'ari:cloud:platform::integration/azure-devops';
const $b49aac7b02131b1c$var$GITLAB_INTEGRATION_ARI = 'ari:cloud:platform::integration/gitlab';
const $b49aac7b02131b1c$var$CONFLUENCE_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/confluence-dc';
const $b49aac7b02131b1c$var$CANVA_INTEGRATION_ARI = 'ari:cloud:platform::integration/canva';
const $b49aac7b02131b1c$var$ASANA_INTEGRATION_ARI = 'ari:cloud:platform::integration/asana';
const $b49aac7b02131b1c$var$BOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/box';
const $b49aac7b02131b1c$var$GONG_INTEGRATION_ARI = 'ari:cloud:platform::integration/gong';
const $b49aac7b02131b1c$export$376b618ac352b4d2 = 'ari:cloud:platform::integration/zoom';
const $b49aac7b02131b1c$var$ZEPLIN_INTEGRATION_ARI = 'ari:cloud:platform::integration/zeplin';
const $b49aac7b02131b1c$var$SERVICENOW_INTEGRATION_ARI = 'ari:cloud:platform::integration/servicenow';
const $b49aac7b02131b1c$var$FRESHSERVICE_INTEGRATION_ARI = 'ari:cloud:platform::integration/freshservice';
const $b49aac7b02131b1c$var$CLICKUP_INTEGRATION_ARI = 'ari:cloud:platform::integration/clickup';
const $b49aac7b02131b1c$var$AMPLITUDE_INTEGRATION_ARI = 'ari:cloud:platform::integration/amplitude';
const $b49aac7b02131b1c$var$STRIPE_INTEGRATION_ARI = 'ari:cloud:platform::integration/stripe';
const $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI = 'ari:cloud:platform::integration/adobe';
const $b49aac7b02131b1c$var$AHA_INTEGRATION_ARI = 'ari:cloud:platform::integration/aha';
const $b49aac7b02131b1c$var$MURAL_INTEGRATION_ARI = 'ari:cloud:platform::integration/mural';
const $b49aac7b02131b1c$var$WEBEX_INTEGRATION_ARI = 'ari:cloud:platform::integration/cisco';
const $b49aac7b02131b1c$var$TODOIST_INTEGRATION_ARI = 'ari:cloud:platform::integration/todoist';
const $b49aac7b02131b1c$var$PAGERDUTY_INTEGRATION_ARI = 'ari:cloud:platform::integration/pagerduty';
const $b49aac7b02131b1c$var$PIPEDRIVE_INTEGRATION_ARI = 'ari:cloud:platform::integration/pipedrive';
const $b49aac7b02131b1c$var$HUBSPOT_INTEGRATION_ARI = 'ari:cloud:platform::integration/hubspot';
const $b49aac7b02131b1c$var$DOVETAIL_INTEGRATION_ARI = 'ari:cloud:platform::integration/dovetail';
const $b49aac7b02131b1c$var$LAUNCHDARKLY_INTEGRATION_ARI = 'ari:cloud:platform::integration/launchdarkly';
const $b49aac7b02131b1c$var$SALESFORCE_INTEGRATION_ARI = 'ari:cloud:platform::integration/salesforce';
const $b49aac7b02131b1c$var$SENTRY_INTEGRATION_ARI = 'ari:cloud:platform::integration/sentry';
const $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/jira-dc';
const $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI = 'ari:cloud:platform::integration/graph-test-app';
const $b49aac7b02131b1c$var$DATABRICKS_INTEGRATION_ARI = 'ari:cloud:platform::integration/databricks';
const $b49aac7b02131b1c$export$7df2356c26307b1c = 'ari:cloud:platform::integration/slack';
// Forge Integration ARIs
const $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z';
const $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93';
const $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy';
const $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO';
const $b49aac7b02131b1c$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL';
const $b49aac7b02131b1c$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy';
const $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY';
const $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K';
const $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi';
const $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u';
const $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j';
const $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI';
const $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC';
const $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL';
const $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq';
const $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo';
const $b49aac7b02131b1c$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5';
const $b49aac7b02131b1c$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29';
const $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC';
const $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP';
const $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF';
const $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J';
const $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo';
const $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb';
const $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0';
const $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G';
const $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3';
const $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5';
const $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua';
const $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf';
const $b49aac7b02131b1c$export$d82a82f2333502ad = {
    [(0, $4wG6Y.ProductKey).GoogleDrive]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Sharepoint]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).AtlassianWebCrawler]: $b49aac7b02131b1c$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Teams]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).Figma]: $b49aac7b02131b1c$var$FIGMA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gitbook]: $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Loom]: $b49aac7b02131b1c$var$LOOM_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OneDrive]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).Github]: $b49aac7b02131b1c$var$GITHUB_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Bitbucket]: $b49aac7b02131b1c$var$BITBUCKET_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Airtable]: $b49aac7b02131b1c$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Smartsheet]: $b49aac7b02131b1c$var$SMARTSHEET_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Notion]: $b49aac7b02131b1c$var$NOTION_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Miro]: $b49aac7b02131b1c$var$MIRO_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zendesk]: $b49aac7b02131b1c$var$ZENDESK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Docusign]: $b49aac7b02131b1c$var$DOCUSIGN_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Lucid]: $b49aac7b02131b1c$var$LUCID_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Monday]: $b49aac7b02131b1c$var$MONDAY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AzureDevops]: $b49aac7b02131b1c$var$AZURE_DEVOPS_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gitlab]: $b49aac7b02131b1c$var$GITLAB_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ConfluenceDC]: $b49aac7b02131b1c$var$CONFLUENCE_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Canva]: $b49aac7b02131b1c$var$CANVA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OutlookCalendar]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).Asana]: $b49aac7b02131b1c$var$ASANA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zeplin]: $b49aac7b02131b1c$var$ZEPLIN_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ServiceNow]: $b49aac7b02131b1c$var$SERVICENOW_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Freshservice]: $b49aac7b02131b1c$var$FRESHSERVICE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).PowerBI]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).ClickUp]: $b49aac7b02131b1c$var$CLICKUP_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Amplitude]: $b49aac7b02131b1c$var$AMPLITUDE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Stripe]: $b49aac7b02131b1c$var$STRIPE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AdobeXD]: $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Aha]: $b49aac7b02131b1c$var$AHA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AdobeSign]: $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Mural]: $b49aac7b02131b1c$var$MURAL_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Webex]: $b49aac7b02131b1c$var$WEBEX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Todoist]: $b49aac7b02131b1c$var$TODOIST_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).PagerDuty]: $b49aac7b02131b1c$var$PAGERDUTY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Pipedrive]: $b49aac7b02131b1c$var$PIPEDRIVE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Hubspot]: $b49aac7b02131b1c$var$HUBSPOT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Dovetail]: $b49aac7b02131b1c$var$DOVETAIL_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).LaunchDarkly]: $b49aac7b02131b1c$var$LAUNCHDARKLY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Salesforce]: $b49aac7b02131b1c$var$SALESFORCE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Sentry]: $b49aac7b02131b1c$var$SENTRY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).JiraDC]: $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).JsmDC]: $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Box]: $b49aac7b02131b1c$var$BOX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gong]: $b49aac7b02131b1c$var$GONG_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zoom]: $b49aac7b02131b1c$export$376b618ac352b4d2,
    [(0, $4wG6Y.ProductKey).Dropbox]: $b49aac7b02131b1c$var$DROPBOX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).GoogleCalendar]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gmail]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Databricks]: $b49aac7b02131b1c$var$DATABRICKS_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AWSS3]: $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OutlookMail]: $b49aac7b02131b1c$export$13bcb53a86a96b4a,
    [(0, $4wG6Y.ProductKey).Slack]: $b49aac7b02131b1c$export$7df2356c26307b1c,
    // Forge Products - Dev and Prod versions
    [(0, $4wG6Y.ProductKey).ForgeAdamVitareqDev]: $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeAdamVitareqProd]: $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeK15tScrollSitesDev]: $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeK15tScrollSitesProd]: $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioAwsDev]: $b49aac7b02131b1c$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioAwsProd]: $b49aac7b02131b1c$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioClickupDev]: $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioClickupProd]: $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitbookDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitbookProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGithubDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGithubProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitlabDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitlabProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGoogleDriveDev]: $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGoogleDriveProd]: $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGuruDev]: $b49aac7b02131b1c$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGuruProd]: $b49aac7b02131b1c$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHelpjuiceDev]: $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHelpjuiceProd]: $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHubspotDev]: $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHubspotProd]: $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSalesforceDev]: $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSalesforceProd]: $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSharepointDev]: $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSharepointProd]: $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioStackOverflowDev]: $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioStackOverflowProd]: $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeUtoolityGitbookDev]: $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeUtoolityGitbookProd]: $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeGdriveEugeneTestDev]: $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeGdriveEugeneTestProd]: $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI
};
const $b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX = 'forge-connector-';
const $b49aac7b02131b1c$export$530d1d49b6479256 = (productKey)=>{
    if (!productKey.startsWith($b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX)) return undefined;
    const withoutPrefix = productKey.slice($b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX.length);
    // Hash is everything before the first hyphen after the prefix
    const hyphenIndex = withoutPrefix.indexOf('-');
    if (hyphenIndex === -1) return undefined;
    const hash = withoutPrefix.slice(0, hyphenIndex);
    return `ari:cloud:platform::integration/${hash}`;
};
const $b49aac7b02131b1c$export$3be99390ed5e95e2 = (productKey)=>{
    // Check static mapping first
    const staticAri = $b49aac7b02131b1c$export$d82a82f2333502ad[productKey];
    if (staticAri !== undefined) return staticAri;
    // Fall back to Forge connector derivation
    return $b49aac7b02131b1c$export$530d1d49b6479256(productKey);
};
module.exports["MICROSOFT_INTEGRATION_ARI"] = $b49aac7b02131b1c$export$13bcb53a86a96b4a;
module.exports["ZOOM_INTEGRATION_ARI"] = $b49aac7b02131b1c$export$376b618ac352b4d2;
module.exports["SLACK_INTEGRATION_ARI"] = $b49aac7b02131b1c$export$7df2356c26307b1c;
module.exports["baseIntegrationARIs"] = $b49aac7b02131b1c$export$d82a82f2333502ad;

});

parcelRegister("fuajF", function(module, exports) {

var $4ysB6 = parcelRequire("4ysB6");


var $h6X6L = parcelRequire("h6X6L");

const $e1bf37817d38fdbf$export$a50dff3bb8b597ca = ({ availableProducts: availableProducts, filters: filters, selectedProducts: selectedProducts, allFilterExcludedProducts: allFilterExcludedProducts }, { thirdPartyConfigs: thirdPartyConfigs })=>{
    // Filter out excluded products from "All" filter
    const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
    const productsToSearch = selectedProducts[0] ? [
        selectedProducts[0]
    ] : allFilterIncludedProducts;
    const typeFilter = filters[0, $4ysB6.universalTypeFilterId];
    const typeEntities = (0, $h6X6L.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
    if (selectedProducts[0]) return typeEntities;
    const excludedEntities = new Set((0, $4ysB6.getAllFilterExcludedEntities)(allFilterExcludedProducts));
    return {
        ...typeEntities,
        entitiesForQuery: typeEntities.entitiesForQuery.filter((entity)=>!excludedEntities.has(entity)),
        entitiesForResultsCountQuery: typeEntities.entitiesForResultsCountQuery.filter((entity)=>!excludedEntities.has(entity))
    };
};
module.exports["getTypeEntities"] = $e1bf37817d38fdbf$export$a50dff3bb8b597ca;

});

parcelRegister("7IS25", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $fbOob = parcelRequire("fbOob");


var $coUcA = parcelRequire("coUcA");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $gPOtu = parcelRequire("gPOtu");


var $hea5O = parcelRequire("hea5O");


var $2gvXK = parcelRequire("2gvXK");


var $c3cgJ = parcelRequire("c3cgJ");


var $aTy6Z = parcelRequire("aTy6Z");


var $eQwbw = parcelRequire("eQwbw");


var $2uw6T = parcelRequire("2uw6T");


var $bwyoU = parcelRequire("bwyoU");


var $6zZLZ = parcelRequire("6zZLZ");

/** Slides type filter + slide ATI require env rollout and cc-mui-slides-experiment (same as Quick Find supported entities). */ function $8644185c8dc31b93$var$isSlideTypeFilterEnabled() {
    return (0, $fbOob.isContentTypeEnabledInCurrentEnv)('slide') && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
        fireExperimentExposure: true
    }) === true;
}
const $8644185c8dc31b93$var$isNativeLoomEntity = (entity)=>entity.startsWith('ati:cloud:loom:');
const $8644185c8dc31b93$export$860193da8e7fe3cd = ()=>(0, $7ydfN.allTypeFilterValueKeys).filter((key)=>key !== (0, $7ydfN.TypeFilterValueKey).Slide || $8644185c8dc31b93$var$isSlideTypeFilterEnabled());
const $8644185c8dc31b93$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $8644185c8dc31b93$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>(0, $bwyoU.lookupMatches)(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
    return matchingOptions;
};
const $8644185c8dc31b93$var$combineEntitiesForResultsCountQuery = (selectedEntities, unselectedEntities)=>{
    const entitiesToExclude = [
        'ati:cloud:trello:card',
        ...(0, $2gvXK.CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES)
    ];
    return Array.from([
        ...new Set([
            ...selectedEntities,
            ...unselectedEntities
        ])
    ]).filter((entity)=>!entitiesToExclude.includes(entity)).sort();
};
const $8644185c8dc31b93$var$isProductEntitiesIncludedSimplified = (availableProducts, product, thirdPartyConfigs)=>{
    // Main change from the original code
    if ((0, $dvVWp.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $hea5O.isImpersonationEnabled)(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs));
    return availableProducts.includes(product);
};
const $8644185c8dc31b93$var$getProductsWithEntities = (products, thirdPartyConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($8644185c8dc31b93$var$isProductEntitiesIncludedSimplified(products, product, thirdPartyConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $8644185c8dc31b93$export$e085e94f90daa6c8 = (products, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $7ydfN.TypeFilterValueKey).Slide || $8644185c8dc31b93$var$isSlideTypeFilterEnabled());
    const isLoomOnlySearch = products.length === 1 && products[0] === (0, $dvVWp.ProductKeys).Loom;
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $8644185c8dc31b93$var$getProductsWithEntities(products, thirdPartyConfigs);
    const otherProductsWithEntities = otherProducts.reduce((acc, otherProduct)=>{
        if ((0, $2uw6T.isProductEntitiesIncluded)(otherProducts, otherProduct, thirdPartyConfigs)) acc.push(otherProduct);
        return acc;
    }, []);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const hasNoSelectedTypes = selectedTypesFiltered.length === 0;
    // Keyed on `selectedProducts`, not `products`, so All-apps reports no code.
    const codeSearchScope = (0, $coUcA.getCodeSearchScope)({
        products: selectedProducts ?? [],
        selectedTypes: selectedTypesFiltered,
        isAllProductSearch: (0, $c3cgJ.isAllProductSearch)(selectedProducts ?? []),
        codeHostProductKeys: (0, $dvVWp.CODE_HOST_PRODUCT_KEYS),
        githubProductKeys: (0, $dvVWp.GITHUB_PRODUCT_KEYS)
    });
    const shouldExpandAllTypeMappings = hasNoSelectedTypes || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler);
    // Start an unfiltered Loom search with legacy graph Video. Explicit native Type
    // selections are mapped here; Loom value filters can switch to native Video downstream.
    let types;
    if (isLoomOnlySearch && hasNoSelectedTypes) types = [
        (0, $7ydfN.TypeFilterValueKey).Video
    ];
    else if (shouldExpandAllTypeMappings) types = $8644185c8dc31b93$export$860193da8e7fe3cd();
    else types = selectedTypesFiltered;
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                // While Loom uses federated search, exclude its native entities from All-products
                // search. They are only requested when Loom is the sole selected product.
                if ($8644185c8dc31b93$var$isNativeLoomEntity(ati) && !isLoomOnlySearch) continue;
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $dvVWp.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    continue;
                }
                if (product === (0, $dvVWp.ProductKeys).Bitbucket && type === (0, $7ydfN.TypeFilterValueKey).Document && !selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Document) && codeSearchScope !== 'all-types') {
                    // Keep it in the unselected set so right-panel counts stay consistent
                    unselectedEntities.add(ati);
                    continue;
                }
                if ((0, $eQwbw.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = otherProductsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                // While Loom uses federated search, exclude its native entities from All-products
                // search. They are only requested when Loom is the sole selected product.
                if ($8644185c8dc31b93$var$isNativeLoomEntity(ati) && !isLoomOnlySearch) continue;
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $8644185c8dc31b93$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (types.includes('customer-contact') && !(0, $iDrrr.fg)('afm_customer_contact_search_type')) selectedEntities.delete('ati:cloud:graph:customer-contact');
    if (!$8644185c8dc31b93$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $8644185c8dc31b93$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $6zZLZ.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $cZKQq.ContentType)['All'],
        isDefault: true,
        product: config.product
    };
    const typeOptions = $8644185c8dc31b93$export$860193da8e7fe3cd().filter((type)=>type !== 'customer-contact' || type === 'customer-contact' && (0, $iDrrr.fg)('afm_customer_contact_search_type')).map((type)=>{
        let messageKey = (0, $aTy6Z.getTypeOptionMessageKey)(type);
        return {
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $6zZLZ.typeLabels)[messageKey]) || '',
            product: config.product
        };
    });
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["getAllTypeFilterKeysForSearch"] = $8644185c8dc31b93$export$860193da8e7fe3cd;
module.exports["lookupOptions"] = $8644185c8dc31b93$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $8644185c8dc31b93$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $8644185c8dc31b93$export$e085e94f90daa6c8;

});

parcelRegister("6zZLZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ebab087727106624$export$9f8e6b98f3e412c5 = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.type.all",
        defaultMessage: "All"
    },
    position: {
        id: "search-page.filter.type.position",
        defaultMessage: "Positions"
    },
    document: {
        id: "search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    'async-video': {
        id: "search-page.controllers.store.search.filters.universal-type.async-video",
        defaultMessage: "Async videos"
    },
    'meeting-recording': {
        id: "search-page.controllers.store.search.filters.universal-type.meeting-recording",
        defaultMessage: "Meeting recordings"
    },
    playlist: {
        id: "search-page.controllers.store.search.filters.universal-type.playlist",
        defaultMessage: "Playlists"
    },
    design: {
        id: "search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    pageAndLiveDoc: {
        id: "search-page.filter.type.pageAndLiveDoc",
        defaultMessage: "Pages and Live Docs"
    },
    page: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    slide: {
        id: "search-page.filter.type.slide",
        defaultMessage: "Slides"
    },
    issue: {
        id: "search-page.filter.type.jira-work-item",
        defaultMessage: "Work items"
    },
    project: {
        id: "search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "search-page.filter.type.work-item",
        defaultMessage: "Tasks"
    },
    card: {
        id: "search-page.filter.type.card",
        defaultMessage: "Cards"
    },
    incident: {
        id: "search-page.filter.type.incident",
        defaultMessage: "Incidents"
    },
    'focus-area': {
        id: "search-page.filter.type.focus-area",
        defaultMessage: "Focus areas"
    },
    organization: {
        id: "search-page.filter.type.organization",
        defaultMessage: "Organizations"
    },
    ask: {
        id: "search-page.filter.type.ask",
        defaultMessage: "Asks"
    },
    risk: {
        id: "search-page.filter.type.risk",
        defaultMessage: "Risks"
    },
    dashboard: {
        id: "search-page.filter.type.dashboard",
        defaultMessage: "Dashboards"
    },
    invoice: {
        id: "search-page.filter.type.invoice",
        defaultMessage: "Invoices"
    },
    deal: {
        id: "search-page.filter.type.deal",
        defaultMessage: "Deals"
    },
    gliffy: {
        id: "search-page.filter.type.gliffy",
        defaultMessage: "Gliffy Diagrams"
    },
    'customer-contact': {
        id: "search-page.filter.type.customer-contact",
        defaultMessage: "Customer Contacts"
    },
    'customer-org': {
        id: "search-page.filter.type.customer-org",
        defaultMessage: "Customer Organizations"
    },
    board: {
        id: "search-page.filter.type.board",
        defaultMessage: "Boards"
    },
    plan: {
        id: "search-page.filter.type.plan",
        defaultMessage: "Plans"
    },
    filter: {
        id: "search-page.filter.type.filter",
        defaultMessage: "Filters"
    },
    'data-table': {
        id: "search-page.filter.type.data-table",
        defaultMessage: "Data tables"
    },
    object: {
        id: "search-page.filter.type.object",
        defaultMessage: "Objects"
    },
    schema: {
        id: "search-page.filter.type.schema",
        defaultMessage: "Schemas"
    },
    type: {
        id: "search-page.filter.type.type",
        defaultMessage: "Object types"
    },
    epic: {
        id: "search-page.filter.type.epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search-page.filter.type.bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search-page.filter.type.Story",
        defaultMessage: "Story"
    },
    task: {
        id: "search-page.filter.type.task",
        defaultMessage: "Task"
    },
    subtask: {
        id: "search-page.filter.type.subtask",
        defaultMessage: "Subtask"
    },
    image: {
        id: "search-page.filter.type.image",
        defaultMessage: "Images"
    },
    audio: {
        id: "search-page.filter.type.audio",
        defaultMessage: "Audio"
    },
    pdf: {
        id: "search-page.filter.type.pdf",
        defaultMessage: "PDF"
    },
    shortcut: {
        id: "search-page.filter.type.shortcut",
        defaultMessage: "Shortcut"
    },
    code: {
        id: "search-page.filter.type.code",
        defaultMessage: "Code"
    },
    archive: {
        id: "search-page.filter.type.archive",
        defaultMessage: "Archive"
    },
    form: {
        id: "search-page.filter.type.form",
        defaultMessage: "Form"
    },
    notebook: {
        id: "search-page.filter.type.notebook",
        defaultMessage: "Notebook"
    },
    other: {
        id: "search-page.filter.type.other",
        defaultMessage: "Other"
    },
    article: {
        id: "search-page.filter.type.article",
        defaultMessage: "Articles"
    },
    post: {
        id: "search-page.filter.type.post",
        defaultMessage: "Posts"
    },
    ticket: {
        id: "search-page.filter.type.ticket",
        defaultMessage: "Tickets"
    },
    'devops-work-item': {
        id: "search-page.filter.type.devops-work-item",
        defaultMessage: "Issues"
    },
    campaign: {
        id: "search-page.filter.type.campaign",
        defaultMessage: "Campaigns"
    },
    case: {
        id: "search-page.filter.type.case",
        defaultMessage: "Cases"
    },
    'catalog-item': {
        id: "search-page.filter.type.catalog-item",
        defaultMessage: "Catalog items"
    },
    'requested-item': {
        id: "search-page.filter.type.requested-item",
        defaultMessage: "Requested items"
    },
    'knowledge-article': {
        id: "search-page.filter.type.knowledge-article",
        defaultMessage: "Knowledge articles"
    },
    'news-article': {
        id: "search-page.filter.type.news-article",
        defaultMessage: "News articles"
    },
    demand: {
        id: "search-page.filter.type.demand",
        defaultMessage: "Demands"
    },
    lead: {
        id: "search-page.filter.type.lead",
        defaultMessage: "Leads"
    }
});
module.exports["typeLabels"] = $ebab087727106624$export$9f8e6b98f3e412c5;

});

parcelRegister("9ekgQ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $95637c076bd712f6$export$1cbda5ccc2e23e06 = (0, $87Lnp.z).union([
    (0, $87Lnp.z).nativeEnum((0, $dvVWp.ProductKeys)),
    (0, $87Lnp.z).string().refine((0, $8fNUp.isForgeConnectorProductKey), (val)=>({
            message: `${val} is not a valid product key`
        }))
]);
module.exports["productKeySchema"] = $95637c076bd712f6$export$1cbda5ccc2e23e06;

});

parcelRegister("iYHGy", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $4492018f58b7cb34$export$7a844b7429919d2 = (0, $87Lnp.z).nativeEnum({
    All: 'all'
});
module.exports["allContentTypeSchema"] = $4492018f58b7cb34$export$7a844b7429919d2;

});

parcelRegister("1T3zR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $0442ab6bf6c52ce6$export$578ac6cc3cc5997a = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item'
});
module.exports["asanaContentTypeSchema"] = $0442ab6bf6c52ce6$export$578ac6cc3cc5997a;

});

parcelRegister("fEMyR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b80a2edbef32607a$export$36d574e92bf2f0fc = (0, $87Lnp.z).nativeEnum({
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type'
});
module.exports["assetsContentTypeSchema"] = $b80a2edbef32607a$export$36d574e92bf2f0fc;

});

parcelRegister("5sbmC", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $90dfc11b6e89a136$export$ddfc756f87e8324d = (0, $87Lnp.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
module.exports["atlasContentTypeSchema"] = $90dfc11b6e89a136$export$ddfc756f87e8324d;

});

parcelRegister("cQ704", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $a43729b80b3b0c13$export$ffa5bf38ea9a76ee = (0, $87Lnp.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
module.exports["booleanSchema"] = $a43729b80b3b0c13$export$ffa5bf38ea9a76ee;

});

parcelRegister("4ktA3", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $1ab0bf18e8c978d1$export$236bfa8a18b6097 = (0, $87Lnp.z).string().transform((x)=>x.split(','));
module.exports["commaSeparatedArraySchema"] = $1ab0bf18e8c978d1$export$236bfa8a18b6097;

});

parcelRegister("04Vsl", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b79d5bbf4e2bebeb$export$e3c670f5c4b4df75 = (0, $87Lnp.z).nativeEnum({
    Component: 'component'
});
module.exports["compassContentTypeSchema"] = $b79d5bbf4e2bebeb$export$e3c670f5c4b4df75;

});

parcelRegister("esQrd", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c5b71ba557825190$export$d872f0aa011c3a9d = (0, $87Lnp.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Gliffy: 'gliffy',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard',
    Slide: 'slide'
});
module.exports["confluenceContentTypeSchema"] = $c5b71ba557825190$export$d872f0aa011c3a9d;

});

parcelRegister("bvXTU", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $af3d14f8bce3c227$export$374297d3e3f8ca0c = (0, $87Lnp.z).nativeEnum({
    Dashboard: 'dashboard',
    DataTable: 'data-table'
});
module.exports["databricksContentTypeSchema"] = $af3d14f8bce3c227$export$374297d3e3f8ca0c;

});

parcelRegister("3L25R", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $dccb0e84ab51df02$export$dbec9fc36dbba98b = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
module.exports["dropboxContentTypeSchema"] = $dccb0e84ab51df02$export$dbec9fc36dbba98b;

});

parcelRegister("ai4mL", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $152f6816a74182d8$export$f4b8db47840ea062 = (0, $87Lnp.z).nativeEnum({
    Design: 'design'
});
module.exports["figmaContentTypeSchema"] = $152f6816a74182d8$export$f4b8db47840ea062;

});

parcelRegister("kvUqR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $6617c84c20a13493$export$3d532d345dacbf34 = (0, $87Lnp.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch',
    DevopsWorkItem: 'devops-work-item'
});
module.exports["githubContentTypeSchema"] = $6617c84c20a13493$export$3d532d345dacbf34;

});

parcelRegister("4IMl4", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $2c2b419fdbac4f66$export$340da7d4450f4487 = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Video: 'video',
    Image: 'image',
    Folder: 'folder',
    Audio: 'audio',
    Pdf: 'pdf',
    Code: 'code',
    Form: 'form',
    Notebook: 'notebook',
    WebPage: 'web-page',
    Other: 'other'
});
module.exports["googleContentTypeSchema"] = $2c2b419fdbac4f66$export$340da7d4450f4487;

});

parcelRegister("41SDB", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c71f738dedbb8cb1$export$f63d577c43feca48 = (0, $87Lnp.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
module.exports["hubspotContentTypeSchema"] = $c71f738dedbb8cb1$export$f63d577c43feca48;

});

parcelRegister("gcyCs", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $1104058c93aa818e$export$e31a67e5bb829f5c = (0, $87Lnp.z).nativeEnum({
    Project: 'project',
    Incident: 'incident',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board',
    Plan: 'plan',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask'
});
module.exports["jiraContentTypeSchema"] = $1104058c93aa818e$export$e31a67e5bb829f5c;

});

parcelRegister("hAGDy", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $a6c4b3fa9ff27424$export$7c078c2ec2ab4e93 = (0, $87Lnp.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
module.exports["lastModifiedValueSchema"] = $a6c4b3fa9ff27424$export$7c078c2ec2ab4e93;

});

parcelRegister("fZYb4", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b986069ddb074892$export$915266ba4ee70164 = (0, $87Lnp.z).nativeEnum({
    Video: 'video',
    AsyncVideo: 'async-video',
    MeetingRecording: 'meeting-recording',
    Playlist: 'playlist',
    Tag: 'tag',
    Space: 'space',
    Folder: 'folder'
});
module.exports["loomContentTypeSchema"] = $b986069ddb074892$export$915266ba4ee70164;

});

parcelRegister("cVMuZ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $2b95107f8200b6a2$export$3f35493c0e1fe9ec = (0, $87Lnp.z).nativeEnum({
    FocusArea: 'focus-area',
    Ask: 'ask',
    Organization: 'organization',
    Risk: 'risk'
});
module.exports["mercuryContentTypeSchema"] = $2b95107f8200b6a2$export$3f35493c0e1fe9ec;

});

parcelRegister("QaUQl", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $cb83f2a02b0453d5$export$2d13808294fd047f = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Image: 'image',
    Folder: 'folder',
    Video: 'video',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Archive: 'archive',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Notebook: 'notebook',
    Other: 'other'
});
module.exports["microsoftContentTypeSchema"] = $cb83f2a02b0453d5$export$2d13808294fd047f;

});

parcelRegister("4wG6Y", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $dvVWp = parcelRequire("dvVWp");

const $4f4db9d032f19672$export$f3a53bd43617a593 = (0, $87Lnp.z).nativeEnum((0, $dvVWp.ProductKeys)).enum;
module.exports["ProductKey"] = $4f4db9d032f19672$export$f3a53bd43617a593;

});

parcelRegister("eV6Wt", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $4d84593fcdfe288c$export$e7eef498de91d92 = (0, $87Lnp.z).nativeEnum({
    Deal: 'deal',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Campaign: 'campaign',
    Case: 'case',
    Lead: 'lead'
});
module.exports["salesforceContentTypeSchema"] = $4d84593fcdfe288c$export$e7eef498de91d92;

});

parcelRegister("86rIn", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $996d55aa57ff23c5$export$2414dbe41633e9e4 = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Comment: 'comment',
    Incident: 'incident',
    Epic: 'epic',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Project: 'project',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
});
module.exports["servicenowContentTypeSchema"] = $996d55aa57ff23c5$export$2414dbe41633e9e4;

});

parcelRegister("kI7H0", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $99e1f7285a86480d$export$78ff7f7a3ef7dca8 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
module.exports["slackContentTypeSchema"] = $99e1f7285a86480d$export$78ff7f7a3ef7dca8;

});

parcelRegister("k4X5q", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $61c0a437c106ee0b$export$ff8ed9d399173456 = (0, $87Lnp.z).nativeEnum({
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal'
});
module.exports["smartLinksContentTypeSchema"] = $61c0a437c106ee0b$export$ff8ed9d399173456;

});

parcelRegister("f8JMS", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $706d3f74e53afbd4$export$c7be2dbb4ce58b0d = (0, $87Lnp.z).nativeEnum({
    Relevance: 'relevance',
    UpdatedNewest: 'updatedNewest',
    UpdatedOldest: 'updatedOldest',
    CreatedNewest: 'createdNewest',
    CreatedOldest: 'createdOldest'
});
module.exports["sortSchema"] = $706d3f74e53afbd4$export$c7be2dbb4ce58b0d;

});

parcelRegister("9efpj", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c54848f8d126b153$export$78a2f7ec9c09bf3b = (0, $87Lnp.z).nativeEnum({
    Position: 'position'
});
module.exports["talentContentTypeSchema"] = $c54848f8d126b153$export$78a2f7ec9c09bf3b;

});

parcelRegister("8maTJ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $6c9ed91850d398e4$export$e362a3dbc1368cf2 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation',
    Video: 'video',
    Attachment: 'attachment'
});
module.exports["teamsContentTypeSchema"] = $6c9ed91850d398e4$export$e362a3dbc1368cf2;

});

parcelRegister("clVfp", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $9cba60a7d383da66$export$15f07c0375d70d62 = (0, $87Lnp.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
module.exports["trelloContentTypeSchema"] = $9cba60a7d383da66$export$15f07c0375d70d62;

});

parcelRegister("iRUkk", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $d1d8b156dce8692d$export$c30d3299c2899a1f = (0, $87Lnp.z).nativeEnum({
    WebPage: 'web-page'
});
module.exports["webPageContentTypeSchema"] = $d1d8b156dce8692d$export$c30d3299c2899a1f;

});

parcelRegister("e63Cm", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b0ec7b4533eaff23$export$8669b3074569e564 = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Comment: 'comment'
});
module.exports["zendeskContentTypeSchema"] = $b0ec7b4533eaff23$export$8669b3074569e564;

});

parcelRegister("yW9ML", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2c16c69ad6c9adc9$export$38b0e736a3b4e542 = (initial)=>{
    let state = initial;
    const listeners = new Set();
    return {
        getSnapshot: ()=>state,
        setState: (next)=>{
            if (next !== state) {
                state = next;
                listeners.forEach((listener)=>listener());
            }
        },
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
};
function $2c16c69ad6c9adc9$export$21fad0c5d7df52dc(store, selector) {
    const selectorRef = (0, $cozmU.useRef)(selector);
    selectorRef.current = selector;
    const cachedRef = (0, $cozmU.useRef)(null);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        const currentState = store.getSnapshot();
        // If the underlying state hasn't changed, return the cached selected value.
        // This ensures referential stability for object/array selectors.
        if (cachedRef.current !== null && cachedRef.current.state === currentState) return cachedRef.current.value;
        const newValue = selectorRef.current(currentState);
        cachedRef.current = {
            value: newValue,
            state: currentState
        };
        return newValue;
    }, [
        store
    ]);
    // Third argument (getServerSnapshot) is required for SSR compatibility.
    // We reuse getSnapshot because store.getSnapshot() has no browser dependencies —
    // it simply returns the current state, which during SSR is the default initial state.
    return (0, $cozmU.useSyncExternalStore)(store.subscribe, getSnapshot, getSnapshot);
}
module.exports["createStaticBootstrapStore"] = $2c16c69ad6c9adc9$export$38b0e736a3b4e542;
module.exports["useStaticBootstrapSelector"] = $2c16c69ad6c9adc9$export$21fad0c5d7df52dc;

});

parcelRegister("35JNe", function(module, exports) {
class $e8efd61979a1a404$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
module.exports["ResultsFetchError"] = $e8efd61979a1a404$export$94cd2e6f39615373;

});

parcelRegister("8lpY0", function(module, exports) {
const $e6ab925b95dff3cb$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $e6ab925b95dff3cb$export$c87d62ed9387fa60;

});

parcelRegister("9T8TZ", function(module, exports) {
const $dd0438d540e6ed33$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $dd0438d540e6ed33$export$c07a1c127052b557;

});

parcelRegister("iiNGz", function(module, exports) {
const $176c80251568190d$export$e5280e1b46081838 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_MERCURY_ENTITY_ATI"] = $176c80251568190d$export$e5280e1b46081838;

});

parcelRegister("c8ES5", function(module, exports) {
const $52cf8ddfd20396ba$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $52cf8ddfd20396ba$export$368c06447ee18b39;

});

parcelRegister("h6X6L", function(module, exports) {

var $7IS25 = parcelRequire("7IS25");

const $0059f11b86c7a931$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: [],
        selectedTypes: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $7IS25.getEntitiesForQuery)(productsToSearch, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        selectedTypes: selectedTypes
    };
};
module.exports["getUniversalTypeEntities"] = $0059f11b86c7a931$export$6466dd1b74ba3dff;

});

parcelRegister("aTy6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $03884dd74e450530$export$48804b5672e75138 = (type)=>{
    let messageKey = type;
    if (type === 'page' && (0, $iDrrr.fg)('confluence_live_pages_open_beta_trait_opted_in')) messageKey = 'pageAndLiveDoc';
    return messageKey;
};
module.exports["getTypeOptionMessageKey"] = $03884dd74e450530$export$48804b5672e75138;

});

parcelRegister("eQwbw", function(module, exports) {

var $2gvXK = parcelRequire("2gvXK");


var $c3cgJ = parcelRequire("c3cgJ");

const $892857c04cbb329d$export$c0b4470d000520ff = (ati, selectedTypes, selectedProducts)=>{
    // In the "all products" and "all types" search, we drop some entities for relevance
    // If types are selected (e.g. "All products" + "Page") or a product is selected ("Confluence" + "all types"), we don't drop any entities
    if (selectedTypes.length === 0 && selectedProducts && (0, $c3cgJ.isAllProductSearch)(selectedProducts)) return !(0, $2gvXK.notRequestedATIsInAllSearch)().includes(ati);
    return true;
};
module.exports["isEntityEnabled"] = $892857c04cbb329d$export$c0b4470d000520ff;

});

parcelRegister("2uw6T", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $gPOtu = parcelRequire("gPOtu");


var $hea5O = parcelRequire("hea5O");

const $d7764986caf8206f$export$521c196d70b6785e = (availableProducts, product, thirdPartyConfigs)=>{
    if ((0, $dvVWp.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $hea5O.isImpersonationEnabled)(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs));
    else return availableProducts.includes(product);
};
module.exports["isProductEntitiesIncluded"] = $d7764986caf8206f$export$521c196d70b6785e;

});

parcelRegister("bwyoU", function(module, exports) {
const $8f7cb3f6ffa1ca7d$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
module.exports["lookupMatches"] = $8f7cb3f6ffa1ca7d$export$e902a1c7f3216533;

});


//# sourceMappingURL=filter-toggle.29d0c788.js.map
